(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_theme-colors', {
            url      : '/ui/theme-colors',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/theme-colors/theme-colors.html',
                    controller : 'ThemeColorsController as vm'
                }
            },
            bodyClass: 'theme-colors'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('CustomThemeDialogController', CustomThemeDialogController);

    /** @ngInject */
    function CustomThemeDialogController(fuseTheming, $mdDialog, fuseGenerator, $cookies, $window)
    {
        // Data
        var vm = this;
        vm.palettes = fuseTheming.getRegisteredPalettes();
        vm.themes = fuseTheming.getRegisteredThemes();

        // Delete Unnecessary hue value
        delete vm.palettes.grey['1000'];

        // Methods
        vm.rgba = fuseGenerator.rgba;
        vm.setTheme = setTheme;
        vm.closeDialog = closeDialog;

        //////////

        // If custom theme exist keep using it otherwise set default as a custom
        if ( !vm.themes.custom )
        {
            vm.theme = angular.copy(vm.themes['default'].colors);
        }
        else
        {
            vm.theme = vm.themes.custom.colors;
        }

        /**
         * Put custom theme into the cookies
         * and reload for generate styles
         */
        function setTheme()
        {
            $cookies.putObject('customTheme', vm.theme);
            $cookies.put('selectedTheme', 'custom');
            $window.location.reload();
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
  'use strict';

  angular
    .module('app.research', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
  {
    // State
    $stateProvider.state('app.research', {
      url      : '/research',
      params: {
        screener: null,
        sport: null,
        home: true,
        newScreener: false
      },
      views    : {
        'content@app': {
          templateUrl: 'app/main/research/research.html',
          controller : 'ResearchController as vm'
        }
      },
      resolve: {
        ResearchData: function (apiResolver)
        {
          return apiResolver.resolve('research.data@get', { page: 1, limit: 10});
        },
        ScreenerData: function (apiResolver)
        {
          return apiResolver.resolve('screener.list@query');
        },
        ConstantsData: function (apiResolver)
        {
          return apiResolver.resolve('research.constants@get');
        }
      },
      bodyClass: 'research',
      authenticate: true,
      inactiveUserAccessible: false
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/research');

    // Navigation
    msNavigationServiceProvider.saveItem('home', {
      title : 'Home',
      weight: 1,
      icon: 'icon-home',
      state: 'app.research',
      stateParams: { home: true }
    });

  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.research')
    .controller('ScreenerDialogController', ScreenerDialogController);

  /** @ngInject */
  function ScreenerDialogController($mdDialog, $mdToast, $rootScope, $scope, $cacheFactory, researchSettings, update, event, api)
  {
    var vm = this;

    // Data
    vm.title = 'Save Screener';
    vm.researchSettings = researchSettings;
    vm.screenerForm = {};

    vm.screenerForm.name = researchSettings.name;
    vm.screenerForm.description = researchSettings.description;

    $scope.constants = $rootScope.constants;

    // Methods
    vm.saveScreener = saveScreener;
    vm.closeDialog = closeDialog;

    function saveScreener()
    {
      vm.researchSettings.name = vm.screenerForm.name;
      vm.researchSettings.description = vm.screenerForm.description;

      if(update) {

        var partialScreener = [
          { op: "replace", path: "Name", value: vm.screenerForm.name },
          { op: "replace", path: "Description", value: vm.screenerForm.description }
        ]

        api.screener.partial.update({ id: vm.researchSettings.id }, partialScreener,
          function (response) {
            var $httpDefaultCache = $cacheFactory.get('$http');
            $httpDefaultCache.remove($rootScope.apiURL + 'api/screeners');

            $mdDialog.hide(response);

            $mdToast.show(
              $mdToast.simple()
                .textContent('Screener Saved!')
                .position('top right')
                .hideDelay(3000)
            );

          },
          function (response) {
            console.log(response);
            $mdToast.show(
              $mdToast.simple()
                .textContent($rootScope.constants.errors.default)
                .position('top right')
                .hideDelay(3000)
            );
          }
        );
      }

      closeDialog();
    }

    function closeDialog()
    {
      $mdDialog.hide();
    }
  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.papertrade', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
  {
    // State
    $stateProvider.state('app.papertrade', {
      url      : '/papertrade',
      views    : {
        'content@app': {
          templateUrl: 'app/main/papertrade/papertrades.html',
          controller : 'PapertradeController as vm'
        }
      },
      resolve: {
        PaperTradeData: function (apiResolver)
        {
          return apiResolver.resolve('papertrade.data@get');
        },
        PaperTradesList: function (apiResolver)
        {
          return apiResolver.resolve('papertrade.range@get', { range: 'all', page: 1, limit: 10});
        },
        ConstantsData: function (apiResolver)
        {
          return apiResolver.resolve('research.constants@get');
        }
      },
      bodyClass: 'papertrade',
      authenticate: true,
      inactiveUserAccessible: false
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/pages/auth/profile');
    msNavigationServiceProvider.saveItem('papertrade', {
      title : 'Paper Trades',
      weight: 4,
      icon: 'icon-coin',
      state: 'app.papertrade',
      stateOpts: {
        reload: true
      }
    });
  }

})();

(function ()
{
  'use strict';

  angular
    .module('app.papertrade')
    .controller('PaperTradeDialogController', PaperTradeDialogController);

  /** @ngInject */
  function PaperTradeDialogController($rootScope, $scope, $mdDialog, $mdToast, $analytics, $cacheFactory, betTypes, spreadTeams, spreadWagerTypes, totalsWagerTypes, moneylineWagerTypes, marketGroupings, tradingBehaviors, wlUtil, event, api, papertrade, constants)
  {
    var vm = this;

    // Data
    vm.title = 'Paper Trade';
    vm.match = papertrade.match;
    vm.constants = constants;

    vm.betTypes = [];
    //console.log(betTypes);

    for(var i=0;i<betTypes.length;i++) {
      // make sure we have a bet value for each type
      if((betTypes[i].id == 0 && vm.match.spreadOdds && vm.match.spreadOdds.status == 0) || (betTypes[i].id == 1 && vm.match.totalsOdds && vm.match.totalsOdds.status == 0) || (betTypes[i].id == 2 && vm.match.moneylineOdds && vm.match.moneylineOdds.status == 0)) {
        vm.betTypes.push(betTypes[i]);
      }
    }

    vm.spreadTeams = spreadTeams;
    vm.spreadWagerTypes = spreadWagerTypes;
    vm.totalsWagerTypes = totalsWagerTypes;
    vm.moneylineWagerTypes = moneylineWagerTypes;
    vm.marketGroupings = marketGroupings;
    vm.tradingBehaviors = tradingBehaviors;
    vm.user = $rootScope.user;
    vm.papertrade = papertrade;

    $scope.constants = $rootScope.constants;
    vm.form = {
      match: vm.match,
      betType: papertrade.oddsType,
      wagerAmount: null,
      wagerType: null
    };

    vm.formBetClass = '';
    //console.log(papertrade);
    if(papertrade.id) {
      vm.form.wagerAmount = papertrade.wagerAmount;
      vm.form.wagerType = papertrade.wagerType;

    }

    vm.formBetClass = vm.form.betType.name.toLowerCase();

    // Methods
    vm.changeBetType = changeBetType;
    vm.closeDialog = closeDialog;
    vm.savePaperTrade = savePaperTrade;


    function changeBetType(betType)
    {
      vm.formBetClass = betType.name.toLowerCase();
      vm.form.wagerType = null;
    }

    function closeDialog()
    {
      $mdDialog.hide();
    }

    function savePaperTrade()
    {
      var newPapertrade = {
        oddsType: vm.form.betType.id,
        wagerType: vm.form.wagerType.id,
        wagerAmount: vm.form.wagerAmount,
        matchID: vm.match.id,
        userID: $rootScope.user.id,
        marketGrouping: papertrade.marketGrouping.id,
        tradingBehavior: papertrade.tradingBehavior.id
      }

      if(papertrade.id) {
        newPapertrade.id = papertrade.id;
      }


      var betTypeKey;
      if(vm.form.betType.id == 0) { // ats
        betTypeKey = 'ats';
        newPapertrade.oddsID = vm.match.spreadOdds.id;
      } else if(vm.form.betType.id == 1) { // totals
        betTypeKey = 'totals';
        newPapertrade.oddsID = vm.match.totalsOdds.id;
      } else { // moneyline
        betTypeKey = 'moneyline';
        newPapertrade.oddsID = vm.match.moneylineOdds.id;
      }

      //console.log(vm.match);

      var op = 'save';
      var opKey = 'add';
      if(papertrade.id) {
        op = 'update';
        opKey = 'edit';
      }

      //console.log(opKey + '.' + op);
      $mdDialog.hide();

      var $httpDefaultCache = $cacheFactory.get('$http');

      api.papertrade[betTypeKey][opKey][op](newPapertrade,
        function (response) {
          $httpDefaultCache.remove($rootScope.apiURL + 'api/papertrades');
          $httpDefaultCache.remove($rootScope.apiURL + 'api/app/papertradedata');

          angular.merge(papertrade, newPapertrade);

          // lookup the enums for display
          papertrade.oddsType = wlUtil.lookupEnumObjectByID(papertrade.oddsType, vm.betTypes);
          if(papertrade.oddsType.id == 0) {
            papertrade.wagerType = wlUtil.lookupEnumObjectByID(papertrade.wagerType, vm.spreadWagerTypes);
          } else if(papertrade.oddsType.id == 1) {
            papertrade.wagerType = wlUtil.lookupEnumObjectByID(papertrade.wagerType, vm.totalsWagerTypes);
          } else {
            papertrade.wagerType = wlUtil.lookupEnumObjectByID(papertrade.wagerType, vm.moneylineWagerTypes);
          }

          papertrade.marketGrouping = wlUtil.lookupEnumObjectByID(papertrade.marketGrouping, vm.marketGroupings);
          papertrade.tradingBehavior = wlUtil.lookupEnumObjectByID(papertrade.tradingBehavior, vm.tradingBehaviors);

          //console.log(papertrade);
          if(opKey == 'add') {
            $analytics.eventTrack('created', {  category: 'papertrade', label: papertrade.oddsType.name.toLowerCase(), value: papertrade.wagerAmount });
            $analytics.eventTrack('sport', {  category: 'papertrade', label: papertrade.match.sport.name.toLowerCase() });
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent('Paper Trade Saved!')
              .position('top right')
              .hideDelay(3000)
          );
        },
        function (response) {
          var errorMessage = $rootScope.constants.errors.default;
          if(response.status == 401) {
            errorMessage = $rootScope.constants.errors.paperTradeDenied;
          }

          $mdToast.show(
            $mdToast.simple()
              .textContent(errorMessage)
              .position('top right')
              .hideDelay(4000)
          );
          console.log(response);
        }
      );
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500',
            inactiveUserAccessible: false
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/errors/500');

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404',
            inactiveUserAccessible: false
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/errors/404');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $httpProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login',
            inactiveUserAccessible: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/auth/login');


    }

})();

(function ()
{
  'use strict';

  angular
    .module('app.pages.auth.login')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $injector, $timeout, $state, $window, $location, api)
  {
    // authenticate route
    $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams){
      //console.log('state change');
      //console.log(toState);
      //console.log($window.sessionStorage.token);
      if(typeof $rootScope.user === 'undefined' && $window.sessionStorage.user) {
        $rootScope.user = JSON.parse($window.sessionStorage.user); // reload the user from the session
      }

      if (toState.authenticate && typeof $rootScope.user === 'undefined'){
        // User isn’t authenticated
        $location.path('/login');
      }
      if($rootScope.user && $rootScope.user.subscriptionStatus != 0 && $rootScope.user.subscriptionStatus != 3 && moment().isAfter($rootScope.user.subscriptionExpirationDate) && !toState.inactiveUserAccessible) { // 0 is active
        $timeout(function ()
        {
          $rootScope.loadingProgress = false;
        });

        //event.preventDefault();
        $location.path('/checkout');
      }
    });


  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($scope, $rootScope, $httpParamSerializer, $state, $window, $cacheFactory, api, $mdDialog)
    {
      if(typeof $rootScope.user != 'undefined') { // already logged in
        $state.go("app.research");
      }

      // delete any old token and data from other users.
      delete $window.sessionStorage.token;
      delete $window.sessionStorage.user;
      var $httpDefaultCache = $cacheFactory.get('$http');
      $httpDefaultCache.removeAll();
      $rootScope.screenerSummary = null;
      $rootScope.user = null;

      var vm = this;

      vm.authenticate = authenticate;
      vm.isSubmitting = false;
      vm.localStorage = checkLocalStorage();
      $rootScope.screenerSummary = null;

      function authenticate()
      {
        var params = { grant_type: "password", userName: vm.form.email, password: vm.form.password };

        vm.isSubmitting = true;

        api.user.login.save($httpParamSerializer(params),
          // Success
          function (response)
          {
            // console.log(response);
            $window.sessionStorage.token = response.access_token;
            var user = {
              id: response.id,
              firstName: response.firstName,
              lastName: response.lastName,
              username: response.username,
              email: response.username,
              phonenumber: response.phoneNumber,
              timezone: response.timezone,
              oddsFormat: response.oddsFormat,
              alertFrequency: response.alertFrequency,
              defaultCreditCardID: response.defaultCreditCardID,
              productSubscriptionID: response.productSubscriptionID,
              subscriptionStatus: response.subscriptionStatus,
              subscriptionExpirationDate: response.subscriptionExpirationDate,
              paypalSubscriptionID: response.paypalSubscriptionID
            };
            // console.log(response)
            // set the profile info
            if($rootScope.constants.debugMode) {
              $window.sessionStorage.user = JSON.stringify(user);
            }
            if (user.paypalSubscriptionID != "") {
              api.user.paypalSubscriptionDetails.get({ id: user.paypalSubscriptionID},
                function(response)
                {
                  // console.log(response)
                  // console.log(apiSubscriptionExpirationDate)
                  // console.log(response.status)
                  var isActive = false;
                  if (response.status == "ACTIVE") {
                    isActive = true;
                  }
                  //active = 0
                  //canceled = 1
                  if (isActive)
                  {
                    user.subscriptionStatus = 0;
                  }
                  else
                  {
                    user.subscriptionStatus = 1;
                  }
                  user.isActive = isActive
                  var profileInfo = {
                    SubscriptionStatus: user.subscriptionStatus,
                    email: user.email,
                    timezone: user.timezone,
                    SubscriptionExpirationDate: response.billing_info.next_billing_time
                  };

                  if (isActive) {
                    profileInfo.SubscriptionExpirationDate = response.billing_info.next_billing_time
                    user.subscriptionExpirationDate = response.billing_info.next_billing_time
                  }
                  else {
                    profileInfo.SubscriptionExpirationDate = user.subscriptionExpirationDate
                  }
                  // console.log(profileInfo)
                  // console.log(response.billing_info)
                  // console.log(response.billing_info.next_billing_time)
                  // console.log(user)
                  api.user.editSubscriptionInfo.update(profileInfo,
                    function(response)
                    {
                      // console.log(response)
                    },
                    function(response)
                    {
  
                    }
                  );
                  $rootScope.user = user;
                  // console.log(user)
                  // console.log(user.isActive)
                  // console.log(user.paypalSubscriptionID)
                  // console.log($rootScope.user.subscriptionStatus)
                  // console.log($rootScope.user.subscriptionExpirationDate)
                  // if(moment().isBefore($rootScope.user.subscriptionExpirationDate)) {
                  if(($rootScope.user.subscriptionStatus == 0)) {
                    $state.go("app.research");
                  } else {
                    if (moment().isBefore($rootScope.user.subscriptionExpirationDate)){
                      $state.go("app.research");
                    }
                    else{
                      $state.go('app.checkout');
                    }
                  }
                  // not necessary to display confirmation
                },
                // Error
                function (response)
                {
                  $rootScope.user = user;
                  // console.log('no paypal')
                  // if(moment().isBefore($rootScope.user.subscriptionExpirationDate)) {
                  if(($rootScope.user.subscriptionStatus == 0)) {
                    $state.go("app.research");
                  } else {
                    if (moment().isBefore($rootScope.user.subscriptionExpirationDate)){
                      $state.go("app.research");
                    }
                    else{
                      $state.go('app.checkout');
                    }
                  }
                }
              ); 
            }
            else {
              $rootScope.user = user;
              // console.log('no api call')
              // if(moment().isBefore($rootScope.user.subscriptionExpirationDate)) {
              // if(($rootScope.user.subscriptionStatus == 0)) {
              //   $state.go("app.research");
              // } else {
              //   $state.go('app.checkout');
              // }
              $state.go('app.checkout');
            }

            // $rootScope.user = user;
            // // 0 = active, 1 = cancelled, 2 = expired, 3 = trial, 4 = suspended
            // //if(($rootScope.user.subscriptionStatus == 0 || $rootScope.user.subscriptionStatus == 3) || ($rootScope.user.subscriptionStatus == 1 && moment().isBefore($rootScope.user.subscriptionExpirationDate))) {
            // if(moment().isBefore($rootScope.user.subscriptionExpirationDate)) {
            //   $state.go("app.research");
            // } else {
            //   $state.go('app.checkout');
            // }

            //console.log($window.sessionStorage.user);
            //console.log($rootScope.user);
          },
          // Error
          function (response)
          {
            delete $window.sessionStorage.token;

            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .title('Login Failed')
                .textContent('Please try again.')
                .ariaLabel('Login Failed')
                .ok('OK')
            );

            vm.isSubmitting = false;
          }
        );
      }

      function checkLocalStorage()
      {
        var uid = new Date;
        var result;
        try {
          localStorage.setItem(uid, uid);
          result = localStorage.getItem(uid) == uid;
          localStorage.removeItem(uid);
          return result && localStorage;
        } catch (exception) {

        }
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/reset-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/pages/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password',
            inactiveUserAccessible: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/auth/reset-password');

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController($rootScope, $location, $mdToast, api)
    {
      var vm = this;
      vm.params = $location.search();
      vm.serverErrorMessage = null;
      // Data

      // Methods
      vm.resetPassword = resetPassword;

      function resetPassword()
      {
        var data = { userId: vm.params.userId, token: vm.params.token, password: vm.form.password };
        //console.log(data);
        api.user.reset_password.save(data,
          function(response)
          {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Your password has been reset.')
                .position('top right')
                .hideDelay(3000)
            );
            $location.search({});
            $location.path('/login');
          },
          function(response)
          {
            var errorMessage = $rootScope.constants.errors.default;

            if(response.data && response.data.modelState) {
              var errors = response.data.modelState[""];
              errorMessage = '';
              for(var i=0;i<errors.length;i++) {
                errorMessage += errors[i];
              }
            }

            vm.serverErrorMessage = errorMessage;
          }
        );
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/auth/forgot-password');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($rootScope, $mdToast, $location, api)
    {
        var vm = this;

        // Data
        vm.isSubmitting = false;

        // Methods
        vm.forgotPassword = forgotPassword;

        function forgotPassword()
        {
          var baseUrl = $location.protocol() + "://" + $location.host();
          if($location.port() != 80 && $location.port() != 443) {
            baseUrl += ":" + $location.port();
          }

          vm.isSubmitting = true;

          api.user.forgot_password.save({ email: vm.form.email, resetUrl: baseUrl + '/reset-password' },
            function(response)
            {
              vm.isSubmitting = false;
              $mdToast.show(
                $mdToast.simple()
                  .textContent('A reset link has been sent to your email address.')
                  .position('top right')
                  .hideDelay(5000)
              );
            },
            function(response)
            {
              $mdToast.show(
                $mdToast.simple()
                  .textContent($rootScope.constants.errors.default)
                  .position('top right')
                  .hideDelay(5000)
              );
              vm.isSubmitting = false;
            }
          );
        }
        //////////
    }
})();

(function ()
{
  'use strict';

  angular
    .module('app.papertrade')
    .controller('CreditCardDialogController', CreditCardDialogController);

  /** @ngInject */
  function CreditCardDialogController($rootScope, $scope, $mdDialog, $mdToast, $window, $cacheFactory, creditCards, creditCard, wlUtil, api)
  {
    var vm = this;

    // Data
    vm.title = 'Credit Card';
    vm.countries = $rootScope.appData.countries;
    vm.cardTypes = $rootScope.appData.creditCardTypes;
    vm.cardStatuses = $rootScope.appData.creditCardStatuses;
    vm.creditCards = creditCards;
    vm.creditCard = creditCard;
    vm.submitting = false;
    vm.date = new Date();

    vm.creditCardForm = {
      defaultCard: true
    };

    if($rootScope.appData.countries.length == 1) {
      vm.creditCardForm.country = $rootScope.appData.countries[0]; // set US by default since currently its the only country selectable
    }


    if(vm.creditCard) {
      vm.creditCardForm.description = creditCard.description;
      vm.creditCardForm.firstName = creditCard.firstName;
      vm.creditCardForm.lastName = creditCard.lastName;
      vm.creditCardForm.company = creditCard.company;
      vm.creditCardForm.address1 = creditCard.billingAddress.streetAddress;
      vm.creditCardForm.address2 = creditCard.billingAddress.streetAddress2;
      vm.creditCardForm.city = creditCard.billingAddress.city;
      vm.creditCardForm.province = creditCard.billingAddress.province;
      vm.creditCardForm.postalCode = creditCard.billingAddress.postalCode;
      vm.creditCardForm.country = creditCard.billingAddress.country;
      vm.creditCardForm.cardType = creditCard.cardType;
      vm.creditCardForm.cardExpirationMonth = creditCard.expirationMonth;
      vm.creditCardForm.cardExpirationYear = creditCard.expirationYear;
    }

    $scope.constants = $rootScope.constants;
    vm.saveCreditCard = saveCreditCard;
    vm.closeDialog = closeDialog;

    function saveCreditCard()
    {
      vm.submitting = true;

      var creditCard = {
        description: vm.creditCardForm.description,
        firstName: vm.creditCardForm.firstName,
        lastName: vm.creditCardForm.lastName,
        company: vm.creditCardForm.company,
        billingAddress: {
          streetAddress: vm.creditCardForm.address1,
          streetAddress2: vm.creditCardForm.address2,
          city: vm.creditCardForm.city,
          province: vm.creditCardForm.province,
          postalCode: vm.creditCardForm.postalCode,
          countryID: vm.creditCardForm.country.id
        },
        cardType: vm.creditCardForm.cardType.id,
        expirationMonth: vm.creditCardForm.cardExpirationMonth,
        expirationYear: vm.creditCardForm.cardExpirationYear,
        cardNumber: vm.creditCardForm.cardNumber,
        cardCvv: vm.creditCardForm.cardCvv,
        userID: $rootScope.user.id,
        default: vm.creditCardForm.defaultCard
      };

      if(vm.creditCard != null)
      {
        creditCard.id = vm.creditCard.id;
        creditCard.authorizeNetCIMToken = vm.creditCard.authorizeNetCIMToken;
        creditCard.billingAddressID = vm.creditCard.billingAddressID;
        creditCard.billingAddress.id = vm.creditCard.billingAddress.id;
      }

      var $httpDefaultCache = $cacheFactory.get('$http');

      if(creditCard.id) {
        api.user.credit_card.edit.update({ id: creditCard.id }, creditCard,
          function (response) {

            if($rootScope.user.defaultCreditCardID == creditCard.id && !creditCard.default) {
              $rootScope.user.defaultCreditCardID = null;

              if($rootScope.constants.debugMode) {
                $window.sessionStorage.user = JSON.stringify($rootScope.user);
              }
            }

            $httpDefaultCache.remove($rootScope.apiURL + 'api/creditcards');

            closeDialog();

            angular.merge(vm.creditCard, response);

            if(creditCard.default) {
              $rootScope.user.defaultCreditCardID = vm.creditCard.id;
              if($rootScope.constants.debugMode) {
                $window.sessionStorage.user = JSON.stringify($rootScope.user);
              }
            }

            $mdDialog.hide();

            $mdToast.show(
              $mdToast.simple()
                .textContent('Credit Card Saved!')
                .position('top right')
                .hideDelay(3000)
            );

            vm.submitting = false;
          },
          function (response) {
            console.log(response);
            $mdToast.show(
              $mdToast.simple()
                .textContent($rootScope.constants.errors.creditCardError)
                .position('top right')
                .hideDelay(3000)
            );

            vm.submitting = false;
          }
        );
      } else {
        api.user.credit_card.add.save(creditCard,
          function (response) {

            $httpDefaultCache.remove($rootScope.apiURL + 'api/creditcards');

            closeDialog();

            vm.creditCards.push(response);

            if(creditCard.default && response) {
              $rootScope.user.defaultCreditCardID = response.id;
              if($rootScope.constants.debugMode) {
                $window.sessionStorage.user = JSON.stringify($rootScope.user);
              }
            }

            $mdToast.show(
              $mdToast.simple()
                .textContent('Credit Card Saved!')
                .position('top right')
                .hideDelay(3000)
            );
          },
          function (response) {
            console.log(response);
            $mdToast.show(
              $mdToast.simple()
                .textContent($rootScope.constants.errors.creditCardError)
                .position('top right')
                .hideDelay(3000)
            );
            vm.submitting = false;
          }
        );
      }

    }

    function closeDialog()
    {
      $mdDialog.hide();
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('ThemeColorsController', ThemeColorsController);

    /** @ngInject */
    function ThemeColorsController(fuseTheming, $mdDialog, $document)
    {
        var vm = this;
        // Data
        vm.themes = fuseTheming.themes;

        // Methods
        vm.createTheme = createTheme;
        //////////

        function createTheme(ev)
        {
            $mdDialog.show({
                controller         : 'CustomThemeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                //'angular-chartist',
                //'chart.js',
                'datatables',
                'gridshore.c3js.chart',
                'nvd3',
                'pascalprecht.translate',
                'timer',
                'ui.router',
                'uiGmapgoogle-maps',
                'textAngular',
                'ui.sortable',
                'ng-sortable',
                'xeditable',
                'moment-picker'
            ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('match', matchDirective)
      .directive('marketvalue', marketvalueDirective);

    /** @ngInject */
    function matchDirective()
    {
        return {
          restrict : "A",
          require: 'ngModel',
          link: function(scope, elm, attrs, ctrl) {
            ctrl.$validators.match = function(modelValue) {
              if(modelValue === undefined) {
                modelValue = "";
              }
              return attrs.match === modelValue;
            };


          }
        };
    }

  function marketvalueDirective()
  {
    return {
      restrict : "A",
      require: 'ngModel',
      link: function(scope, elm, attrs, ctrl) {
        ctrl.$validators.marketvalue = function(modelValue) {
          if (attrs.oddsFormat == 0)
          {
            if (modelValue >= 0 && attrs.team == 0) {
              return false;
            }
            else if (modelValue <= 0 && attrs.team == 1) {
              return false;
            }
            else {
              return true;
            };
          }
          else
          {
            if (modelValue <= 0) {
              return false;
            }
            else {
              return true;
            };
          };
        };


      }
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.saveLink = saveLink;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        function saveLink(path, item, link) {
            var parts = path.split('.');

            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper href
                updateItem.href = link;
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.href = link;

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);

                updateItem.uisrefopts = _getUiSrefOpts(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                item.uisrefopts = _getUiSrefOpts(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + JSON.stringify(item.stateParams) + ')';
                }
            }
            //console.log(uisref);
            return uisref;
        }

        function _getUiSrefOpts(item)
        {
          var uisrefopts = '';

          if ( angular.isDefined(item.state) )
          {
            uisrefopts = item.state;

            if ( angular.isDefined(item.stateOpts) && angular.isObject(item.stateOpts) )
            {
              uisrefopts = JSON.stringify(item.stateOpts);
            }
          }

          return uisrefopts;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                saveLink           : saveLink,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, $mdSidenav, msNavigationService)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;

        // console.log(vm.node)

        // force the sidenav closed. bug in fuse for mobile
        vm.hideVerticalMobileMenu = function() {
          $mdSidenav('navigation').toggle();
        };

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight + 1;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : '',
                //'overflow-y': 'scroll'
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        vm.goToStep = goToStep;
        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            vm.selectedIndex++;
        }

        function goToStep(index)
        {
          if(index > vm.forms.length - 1) {
            console.log('index ' + index + ' is out of bounds');
          }
          vm.selectedIndex = index;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === vm.forms.length - 1;
        }


        /**
         * Is current step invalid?
         *
         * @returns {boolean|*}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_maintenance', {
            url      : '/pages/maintenance',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_maintenance': {
                    templateUrl: 'app/pages/maintenance/maintenance.html',
                    controller : 'MaintenanceController as vm'
                }
            },
            bodyClass: 'maintenance',
            inactiveUserAccessible: false
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/pages/maintenance');

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance')
        .controller('MaintenanceController', MaintenanceController);

    /** @ngInject */
    function MaintenanceController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
  'use strict';

  angular
    .module('app.screener', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
  {
    // State
    $stateProvider.state('app.screener', {
      url      : '/screener',
      views    : {
        'content@app': {
          templateUrl: 'app/main/screener/screeners.html',
          controller : 'ScreenerController as vm'
        }
      },
      resolve: {
        ScreenerData: function (apiResolver)
        {
          return apiResolver.resolve('screener.list@query');
        }
      },
      bodyClass: 'screener',
      authenticate: true,
      inactiveUserAccessible: false
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/pages/auth/profile');
    msNavigationServiceProvider.saveItem('screeners', {
      title : 'My Screeners',
      weight: 3,
      icon: 'icon-binoculars',
      state: 'app.screener'
    });
  }

})();

(function ()
{
  'use strict';

  angular
    .module('app.screener')
    .controller('ScreenerController', ScreenerController);

  /** @ngInject */
  function ScreenerController($rootScope, ScreenerData, $location, $mdDialog, $mdToast, $analytics, $cacheFactory, wlUtil, api)
  {
    // Data
    var vm = this;
    vm.title = "Screeners";
    vm.screeners = ScreenerData;

    $rootScope.$watch('screenerSummary', function () {
      if ($rootScope.screenerSummary) {
        for (var i = 0; i < vm.screeners.length; i++) {
          var screenerID = vm.screeners[i].id;
          for (var j = 0; j < $rootScope.screenerSummary.screenerModels.length; j++) {
            if ($rootScope.screenerSummary.screenerModels[j].screener.id == screenerID) {
              vm.screeners[i].matchCount = $rootScope.screenerSummary.screenerModels[j].matchCount;
              break;
            }
          }
        }
      }
    });

    // Methods
    vm.deleteScreener = deleteScreener;

    function deleteScreener(ev, screener)
    {
      var confirm = $mdDialog.confirm()
        .title('Delete Screener')
        .textContent('Are you sure you want to delete this screener?')
        .ariaLabel('Delete Screener')
        .targetEvent(ev)
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function() {
        api.screener.delete.remove({ id: screener.id },
          function(response)
          {
            var $httpDefaultCache = $cacheFactory.get('$http');
            $httpDefaultCache.remove($rootScope.apiURL + 'api/screeners');

            $analytics.eventTrack('deleted', {  category: 'screener' });

            $mdToast.show(
              $mdToast.simple()
                .textContent('Screener Deleted!')
                .position('top right')
                .hideDelay(3000)
            );

            for(var i=0;i<vm.screeners.length;i++) {
              if(screener.id == vm.screeners[i].id) {
                vm.screeners.splice(i,1);
                break;
              }
            }

            $rootScope.screenerSummary = null; // reset the call to get the screener count
          },
          function(response)
          {
            console.log(response);
            $mdToast.show(
              $mdToast.simple()
                .textContent($rootScope.constants.errors.default)
                .position('top right')
                .hideDelay(3000)
            );
          }
        );
      }, function() {
      });



    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.profile', {
            url      : '/profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            resolve: {
              CreditCardData: function (apiResolver)
              {
                return apiResolver.resolve('user.credit_card.list@query');
              },
              SubscriptionData: function (apiResolver)
              {
                return apiResolver.resolve('subscription@query');
              }
            },
            bodyClass: 'account-profile',
            authenticate: true,
            inactiveUserAccessible: true
        });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/pages/auth/profile');

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController($rootScope, $mdDialog, $mdToast, $state, $window, $document, $cacheFactory, CreditCardData,SubscriptionData, wlUtil, api)
    {
      var vm = this;
      // Data
      vm.title = 'My Profile';
      vm.profileForm = {
        firstName: $rootScope.user.firstName,
        lastName:  $rootScope.user.lastName,
        email: $rootScope.user.email,
        phonenumber: $rootScope.user.phonenumber,
        alertFrequency: $rootScope.user.alertFrequency,
        oddsFormat: $rootScope.user.oddsFormat
      };
      vm.userProductInfo = {
        firstName: $rootScope.user.firstName,
        lastName:  $rootScope.user.lastName,
        productSubscriptionID: $rootScope.user.paypalSubscriptionID,
        subscriptionExpirationDate: $rootScope.user.subscriptionExpirationDate
      };

      vm.filteredProduct = getProductByFilter($rootScope.user.productSubscriptionID);
      vm.userProductInfo.productName = vm.filteredProduct.name;

      vm.timezones = $rootScope.appData.timezones;
      // get the selected timezone
      for(var i=0;i<vm.timezones.length;i++) {
        if($rootScope.user.timezone == vm.timezones[i].zoneId) {
          vm.profileForm.timezone = vm.timezones[i];
          break;
        }
      }
      vm.user = $rootScope.user;

      vm.creditCards = CreditCardData;
      //console.log(vm.creditCards);
      for(var i=0;i<vm.creditCards.length;i++) {
        vm.creditCards[i].cardType = wlUtil.lookupEnumObjectByID(vm.creditCards[i].cardType, $rootScope.appData.creditCardTypes);
        vm.creditCards[i].status = wlUtil.lookupEnumObjectByID(vm.creditCards[i].status, $rootScope.appData.creditCardStatuses);
      }

      vm.alertFrequency = null;
      for(var i=0;i<$rootScope.appData.alertFrequencies.length;i++) {
        if(vm.profileForm.alertFrequency == $rootScope.appData.alertFrequencies[i].id) {
          vm.profileForm.alertFrequency = $rootScope.appData.alertFrequencies[i];
          break;
        }
      }

      // Methods
      vm.saveProfile = saveProfile;
      vm.addCreditCard = addCreditCard;
      vm.editCreditCard = editCreditCard;
      vm.deleteCreditCard = deleteCreditCard;
      vm.cancelAccount = cancelAccount;
      vm.setCreditCardAsDefault = setCreditCardAsDefault;
      vm.checkout = checkout;

      function checkout()
      {
        $state.go("app.checkout");
      }

      function getProductByFilter(id)
      {
        for (var i=0; i < SubscriptionData.length; i++) {
          if (SubscriptionData[i].id == id) {
              return SubscriptionData[i];
          }
        }
      }

      function saveProfile()
      {
        var profileInfo = {
          firstName: vm.profileForm.firstName,
          lastName:  vm.profileForm.lastName,
          email: $rootScope.user.email,
          phoneNumber: vm.profileForm.phonenumber,
          timezone: vm.profileForm.timezone.zoneId,
          oldPassword: vm.profileForm.oldPassword,
          password: vm.profileForm.newPassword,
          alertFrequency: vm.profileForm.alertFrequency.id,
          oddsFormat: $rootScope.user.oddsFormat
        };

        api.user.edit.update(profileInfo,
          function(response)
          {
            $mdToast.show(
              $mdToast.simple()
                .textContent('Profile Saved!')
                .position('top right')
                .hideDelay(3000)
            );

            $rootScope.user.firstName = profileInfo.firstName;
            $rootScope.user.lastName = profileInfo.lastName;
            $rootScope.user.phonenumber = profileInfo.phoneNumber;
            $rootScope.user.timezone = profileInfo.timezone;
            $rootScope.user.alertFrequency = profileInfo.alertFrequency;

            if($rootScope.constants.debugMode) {
              $window.sessionStorage.user = JSON.stringify($rootScope.user);
            }
          },
          function(response)
          {
            console.log(response);
            if(response.status == 400) {
              /*$mdDialog.show(
                $mdDialog.alert()
                  .parent(angular.element(document.body))
                  .clickOutsideToClose(true)
                  .title('Error')
                  .textContent('You can specify some description text in here.')
                  .ariaLabel('Profile errors')
                  .ok('OK')
                  .targetEvent(ev)
              );*/

            } else {
              $mdToast.show(
                $mdToast.simple()
                  .textContent($rootScope.constants.errors.default)
                  .position('top right')
                  .hideDelay(3000)
              );
            }


          }
        );

      }

      function addCreditCard(ev)
      {
        $mdDialog.show({
          controller         : 'CreditCardDialogController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/profile/dialogs/creditcard-dialog.html',
          parent             : angular.element($document.body),
          targetEvent        : ev,
          clickOutsideToClose: true,
          locals             : {
            event: ev,
            creditCard: null,
            creditCards: vm.creditCards
          }
        });
      }

      function editCreditCard(ev, creditCard)
      {
        $mdDialog.show({
          controller         : 'CreditCardDialogController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/profile/dialogs/creditcard-dialog.html',
          parent             : angular.element($document.body),
          targetEvent        : ev,
          clickOutsideToClose: true,
          locals             : {
            event: ev,
            creditCard: creditCard,
            creditCards: vm.creditCards
          }
        });
      }

      function deleteCreditCard(ev, id)
      {
        var confirm = $mdDialog.confirm()
          .title('Delete Credit Card')
          .textContent('Are you sure you want to delete this credit card?')
          .ariaLabel('Delete Credit Card')
          .targetEvent(ev)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .ok('Yes')
          .cancel('No');

        $mdDialog.show(confirm).then(function() {
          api.user.credit_card.delete.remove({ id: id },
            function(response)
            {
              var $httpDefaultCache = $cacheFactory.get('$http');
              $httpDefaultCache.remove($rootScope.apiURL + 'api/creditcards');

              for(var i=0;i<vm.creditCards.length;i++) {
                if(id == vm.creditCards[i].id) {
                  vm.creditCards.splice(i,1);
                  break;
                }
              }

              if(vm.user.defaultCreditCardID == id) {
                $rootScope.user.defaultCreditCardID = null;

                if($rootScope.constants.debugMode) {
                  $window.sessionStorage.user = JSON.stringify($rootScope.user);
                }
              }

              $mdToast.show(
                $mdToast.simple()
                  .textContent('Credit Card Deleted!')
                  .position('top right')
                  .hideDelay(3000)
              );

            },
            function(response)
            {
              $mdToast.show(
                $mdToast.simple()
                  .textContent($rootScope.constants.errors.default)
                  .position('top right')
                  .hideDelay(3000)
              );
              //console.log(response);
            }
          );
        }, function() {

        });

      }

      function cancelAccount(ev) {
        var confirm = $mdDialog.confirm()
          .title('Cancel Account')
          .textContent('Are you sure you want to cancel your account?')
          .ariaLabel('Cancel Account')
          .targetEvent(ev)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .ok('Yes')
          .cancel('No');

        $mdDialog.show(confirm).then(function() {
          api.user.cancel.get({ },
            function(response)
            {
              $mdToast.show(
                $mdToast.simple()
                  .textContent('Sorry to see you go. Your subscription will expire on ' + $rootScope.user.subscriptionExpirationDate)
                  .position('top right')
                  .hideDelay(5000)
              );

              $rootScope.user.subscriptionStatus = response.subscriptionStatus;

              if($rootScope.constants.debugMode) {
                $window.sessionStorage.user = JSON.stringify($rootScope.user);
              }

            },
            function(response)
            {
              $mdToast.show(
                $mdToast.simple()
                  .textContent($rootScope.constants.errors.default)
                  .position('top right')
                  .hideDelay(3000)
              );
            }
          );
        }, function() {

        });
      }

      function setCreditCardAsDefault(creditCard) {
        api.user.credit_card.default.update({ id: creditCard.id },
          function(response)
          {
            $rootScope.user.defaultCreditCardID = response.defaultCreditCardID;

            if($rootScope.constants.debugMode) {
              $window.sessionStorage.user = JSON.stringify($rootScope.user);
            }
          },
          function(response)
          {
            $mdToast.show(
              $mdToast.simple()
                .textContent($rootScope.constants.errors.default)
                .position('top right')
                .hideDelay(3000)
            );
          }
        );
      }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.research')
        .controller('ResearchController', ResearchController);

    /** @ngInject */
    function ResearchController($rootScope, $scope, $stateParams, $document, $mdDialog, $mdMedia, $mdToast, $timeout, $interval, $state, $location, $anchorScroll, $analytics, $cacheFactory, $window, api, ResearchData, ScreenerData, ConstantsData, wlUtil)
    {
      // @todo - organize/clean up this controller and related after functionality & revisions are complete
      var vm = this;

      if ($rootScope.user.subscriptionStatus == 1){
        if (moment().isAfter($rootScope.user.subscriptionExpirationDate)){
          $state.go('app.checkout');
        }
      }

      //<editor-fold desc="Init">
      vm.sports = angular.copy($rootScope.appData.sports);
      // vm.sports.unshift({ id: null, name: "All" });

      vm.help = ConstantsData.help;
      vm.constants = ConstantsData;
      $scope.constants = $rootScope.constants;
      vm.isScreenLTESm = false;
      if($mdMedia('xs') || $mdMedia('sm')) {
        vm.isScreenLTESm = true;
      }

      vm.defaultMatchResultsTitle = vm.constants.matchResults.title;

      vm.tradingBehaviors = ResearchData.tradingBehaviors;
      //$scope.screener = {};
      vm.chartLine = {
        enabled: false,
        type: null
      };

      vm.allTournaments = {
        id: 0,
        name: 'All',
        label: 'All'
      };

      vm.alertLevels = ResearchData.alertLevels;
      vm.alertLevels.shift(); // removes normal level

      vm.betTypes = ResearchData.queryOddsTypes;
      vm.queryOperators = ResearchData.queryOperators;
      vm.mathOperators = ResearchData.mathOperators;
      vm.wagerTypes = ResearchData.wagerTypes;
      vm.spreadWagerTypes = ResearchData.spreadWagerTypes;
      vm.screeners = ScreenerData;

      $scope.selectedTradingBehavior = vm.tradingBehaviors[0];
      ResearchData.queryOperators.unshift({ id: null, name: "Finished" });

      vm.marketGroupings = ResearchData.marketGroupings;
      vm.noMarketGrouping = vm.marketGroupings[0];
      vm.marketGroupings.shift();
      $scope.selectedMarketGrouping = vm.marketGroupings[0];

      //$scope.marketGroupingClass = vm.marketGroupings[0].name.toLowerCase();

      //console.log(ResearchData);

      var alertMarketGroupings = angular.copy(vm.marketGroupings);
      $scope.alertMarketGroupings = alertMarketGroupings;

      $scope.selectedMatch = null;
      $scope.selectedMatchDataPoint = null;
      $scope.matchDetailColumns = ["Market"];

      // set the alert range labels
      for(var i=0;i<$scope.alertMarketGroupings.length;i++) {
        var rangeGroupLength = $scope.alertMarketGroupings[i].values.length / ResearchData.alertQueryRanges.length; // 6/2=3
        $scope.alertMarketGroupings[i].ranges = [];

        for(var j=0;j<ResearchData.alertQueryRanges.length;j++) {
          var startingIndex = j * rangeGroupLength;
          var endingIndex = startingIndex + rangeGroupLength;
          var rangeGroup = $scope.alertMarketGroupings[i].values.slice(startingIndex, endingIndex);
          var alertRange = {
            id: ResearchData.alertQueryRanges[j].id,
            name: ResearchData.alertQueryRanges[j].name,
            label: ResearchData.alertQueryRanges[j].name + ' (' + rangeGroup.join(',') + ')'
          };

          $scope.alertMarketGroupings[i].ranges.push(alertRange);
        }

        $scope.alertMarketGroupings[i].ranges.unshift({
          id: 0,
          name: 'All',
          label: 'All'
        });
      }

      // @todo researchSettings and upcomingMatches should be combined to one object.
      $scope.researchSettings = {
        name: null,
        description: null,
        sport: null,
        wizard: {
          enabled: false,
          editMode: false,
          searching: false
        },
        tradingBehavior: ResearchData.tradingBehaviors[0],
        marketGrouping: $scope.alertMarketGroupings[0],
        markets: {
          title: 'Current Market Conditions',
          columns: wlUtil.getMarketQueryColumns(),
          rows: [],
          multiple: true
        },
        alerts: {
          title: 'Wolfline Alerts',
          columns: wlUtil.getAlertQueryColumns(),
          rows: []
        },
        matchResults: {
          title: vm.defaultMatchResultsTitle,
          showResultsPanel: true
        }
      };

      // upcoming match data
      $scope.upcomingMatches = {
        title: 'Matches',
        columns: [
          {
            "title": "Trade"
          },
          {
            "title": "Date"
          },
          {
            "title": "Sport"
          },
          {
            "title": "Competitors"
          },
          {
            "title": "Market"
          }
        ],
        screener: {},
        api: api.research.data,
        criteria: {
          page: 1,
          limit: 10,
          search: null,
          lastSearch: null,
          preview: false
        },
        rowCount: 0,
        init: function(matches, matchCount) {
          this.setUpcomingMatches(matches, matchCount);
          this.refreshPaginator();
        },
        setLimit: function(limit) {
          if(limit != this.criteria.limit) {
            this.criteria.page = 1; // reset the page
            this.criteria.limit = limit;
            this.refresh();
          }
        },
        search: function() {
          this.criteria.lastSearch = this.criteria.search;
          this.criteria.page = 1; // reset the page
          this.refresh();
        },
        clearSearch: function() {
          if(this.criteria.search == this.criteria.lastSearch) {
            this.criteria.search = null;
            this.criteria.page = 1; // reset the page
            this.refresh();
          } else {
            this.criteria.search = null;
          }

        },
        refresh: function(selectedMatchIndex) {
          this.showLoading();
          if($mdMedia('xs') || $mdMedia('sm')) {
            $location.hash('results-widget');
            $anchorScroll();
          }

          var criteria = {
            page: this.criteria.page,
            limit: this.criteria.limit,
            search: this.criteria.search
          };

          var _this = this;

          if(this.criteria.preview) {
            var screener = prepareScreenerFromResearchSettings();
            this.api.save(criteria, screener,
              function(response)
              {
                _this.setUpcomingMatches(response.matches, response.matchCount);
                if(selectedMatchIndex !== undefined) {
                  loadMatchByIndex(selectedMatchIndex);
                }
                _this.hideLoading();
                $scope.researchSettings.wizard.enabled = true;
                $scope.researchSettings.wizard.editMode = false;

                if($mdMedia('xs') || $mdMedia('sm')) {
                  $location.hash('results-widget');
                  $anchorScroll();
                }
              },
              function(response)
              {
                $mdToast.show(
                  $mdToast.simple()
                    .textContent($rootScope.constants.errors.default)
                    .position('top right')
                    .hideDelay(3000)
                );
                $rootScope.loadingProgress = false;
                $scope.researchSettings.wizard.searching = false;
              }
            );
          } else {

            if(this.screener) {
              criteria.id = this.screener.id;
            }

            this.api.get(criteria,
              function(response)
              {
                _this.setUpcomingMatches(response.matches, response.matchCount);
                if(selectedMatchIndex !== undefined) {
                  loadMatchByIndex(selectedMatchIndex);
                }

                if(_this.screener.id) {
                  $scope.researchSettings.wizard.enabled = true;
                  $scope.researchSettings.wizard.editMode = false;
                }
                _this.hideLoading();

                if($mdMedia('xs') || $mdMedia('sm')) {
                  $location.hash('results-widget');
                  $anchorScroll();
                }
              },
              function(response)
              {
                $mdToast.show(
                  $mdToast.simple()
                    .textContent($rootScope.constants.errors.default)
                    .position('top right')
                    .hideDelay(3000)
                );
                //console.log(response);
                $rootScope.loadingProgress = false;
                $scope.researchSettings.wizard.searching = false;
              }
            );
          }

        },
        setUpcomingMatches: function(matches, matchCount)
        {
          this.rowCount = matchCount;
          this.rows = matches;
          if(matches.length > 0) {
            for(var i=0; i<this.rows.length; i++) {
              this.rows[i].allChartData = wlUtil.prepareMatchChartData(this.rows[i], vm.noMarketGrouping.values[vm.noMarketGrouping.values.length - 1], $scope.selectedTradingBehavior);
              this.rows[i].chartData = wlUtil.prepareMatchChartData(this.rows[i], $scope.selectedMarketGrouping.values[$scope.selectedMarketGrouping.values.length - 1], $scope.selectedTradingBehavior);
            }
          } else {
            this.rows =[];
          }

          this.refreshPaginator();
        },
        refreshPaginator: function() {
          this.startingRow = ((this.criteria.page - 1) * this.criteria.limit) + 1;
          if(this.rowCount >= this.criteria.limit) {
            this.endingRow = ((this.criteria.page - 1) * this.criteria.limit) + this.criteria.limit;
            if(this.endingRow > this.rowCount) {
              this.endingRow = this.rowCount;
            }
          } else {
            this.endingRow = this.rowCount;
          }
          this.pageCount = Math.ceil(this.rowCount / this.criteria.limit);
          this.paginator = new Array();
          if(this.rowCount > this.criteria.limit) {
            for(var i=0;i<this.pageCount;i++) {
              this.paginator.push({ active: false, page: (i + 1) })
            }
          }

        },
        showLoading: function ()
        {
          $scope.researchSettings.wizard.searching = true;
        },
        hideLoading: function ()
        {
          $timeout(function() {
            $scope.researchSettings.wizard.searching = false;
          }, 500);

        },
        startingRow: 0,
        endingRow: 0,
        paginator: null,
        pageCount: 0,
        rows: []
      };

      var columnIntervals = new Array();
      for(var i=0; i<vm.noMarketGrouping.values.length; i++) {
        columnIntervals.push({ "title": vm.noMarketGrouping.values[i] + ' SP'});
        $scope.matchDetailColumns.push(vm.noMarketGrouping.values[i] + ' SP');
      }
      $scope.upcomingMatches.columns = $scope.upcomingMatches.columns.concat(columnIntervals);

      // filter out inactive tournament groups
      for (var i = 0; i < vm.sports.length; i++) {
        var activeTournamentGroups = new Array();
        if(vm.sports[i].tournamentGroups) {
          for(var j=0;j<vm.sports[i].tournamentGroups.length;j++) {
            if(vm.sports[i].tournamentGroups[j].active) {
              activeTournamentGroups.push(vm.sports[i].tournamentGroups[j]);
            }
          }
          vm.sports[i].tournamentGroups = activeTournamentGroups;
        }
      }
      // console.log($stateParams)

      if(!$stateParams.home) {
        vm.home = false;
        if ($stateParams.sport) {
          // start new screener

          // lookup entire sport object from partial state param object
          var sport = null;
          for (var i = 0; i < vm.sports.length; i++) {
            if ($stateParams.sport.id == vm.sports[i].id) {
              sport = vm.sports[i];
              sport.tournamentGroups.unshift(vm.allTournaments);
              break;
            }
          }

          if (sport) {
            // console.log(sport)
            setDefaultResearchSettings(sport);
            $scope.researchSettings.name = wlUtil.createNewScreenerName(vm.screeners, sport.name + ' Screener');
            $stateParams.screener = null;
            $scope.researchSettings.wizard.enabled = true;
            $scope.researchSettings.wizard.editMode = false;

            previewScreener();
          } else {
            $mdToast.show(
              $mdToast.simple()
                .textContent('The sport requested was not found.')
                .position('top right')
                .hideDelay(3000)
            );
          }

        } else {
          if ($stateParams.screener) {
            angular.copy($stateParams.screener, $scope.upcomingMatches.screener);
            loadScreener($scope.upcomingMatches.screener, $scope.researchSettings);
            $scope.researchSettings.wizard.enabled = true;
            $scope.researchSettings.wizard.editMode = false;

            for (var i = 0; i < $scope.researchSettings.markets.rows.length; i++) {
              if ($scope.researchSettings.markets.rows[i].conditions.length > 0) {
                $scope.researchSettings.markets.rows[i].advancedSettingsVisible = true;
              }
            }

            $scope.upcomingMatches.criteria.preview = false;
            $scope.upcomingMatches.api = api.screener.matches.getById;
            $scope.upcomingMatches.refresh();
          } else { // first run
            resetHomeState();
          }
        }
      } else {
        vm.home = true;
        resetHomeState();
      }

      vm.originalResearchSettings = {};
      angular.copy($scope.researchSettings, vm.originalResearchSettings);

      if($stateParams.newScreener) {
        startNewScreenerWizard();
      }

      // check start times and disable paper trade button if started
      $interval(function() {
        var invalidateCache = false;
        for(var i=0;i<$scope.upcomingMatches.rows.length;i++) {
          //console.log($scope.upcomingMatches.rows[i].matchDate);
          if($scope.upcomingMatches.rows[i].matchStatus == 0) {
            var matchDateTimeUtc = moment.utc($scope.upcomingMatches.rows[i].matchDate);

            //console.log(matchDateTimeUtc.format() + ' | ' + moment().utc().format());
            //var currentTime = moment.utc().add(1, 'hours');
            if(moment.utc().isAfter(matchDateTimeUtc)) {
              $scope.upcomingMatches.rows[i].hasOdds = false;
              $scope.upcomingMatches.rows[i].inProgress = true;
              invalidateCache = true;
            }
          }
        }

        if(invalidateCache) {
          var $httpDefaultCache = $cacheFactory.get('$http');
          $httpDefaultCache.remove($rootScope.apiURL + 'api/app/researchdata');
          for(var i=0;i<vm.screeners.length;i++) {
            $httpDefaultCache.remove($rootScope.apiURL + 'api/screeners/matches/' + vm.screeners[i].id);
          }
        }

      }, 5000);

      //</editor-fold>

      //<editor-fold desc="Method definitions">
      // match methods
      vm.viewMatchDetail = viewMatchDetail;
      vm.closeMatchDetail = closeMatchDetail;
      vm.selectMatchBetType = selectMatchBetType;
      vm.drawTrendLine = graphItemClick;
      vm.selectChartDataPoint = selectChartDataPoint;
      vm.enableLineDrawing = enableLineDrawing;
      vm.disableLineDrawing = disableLineDrawing;
      vm.clearTrendLines = clearTrendLines;
      vm.clearGuideLines = clearGuideLines;
      vm.highlightChartCursor = highlightChartCursor;
      vm.unhighlightChartCursor = unhighlightChartCursor;
      vm.chartMouseMove = chartMouseMove;
      vm.loadNextMatch = loadNextMatch;
      vm.loadPreviousMatch = loadPreviousMatch;
      vm.isFirstMatch = isFirstMatch;
      vm.isLastMatch = isLastMatch;

      // screener methods
      vm.saveScreener = saveScreener;
      vm.saveAndRunScreener = saveAndRunScreener;
      vm.startNewScreenerWizard = startNewScreenerWizard;
      vm.editScreener = editScreener;
      vm.selectScreenerMarket = selectScreenerMarket;
      vm.previewScreener = previewScreener;
      vm.toggleScreenerAdvancedMarketSettings = toggleScreenerAdvancedMarketSettings;
      vm.addScreenerMarketQuery = addScreenerMarketQuery;
      vm.deleteScreenerMarketQuery = deleteScreenerMarketQuery;
      vm.addScreenerMarketQueryCondition = addScreenerMarketQueryCondition;
      vm.deleteScreenerMarketQueryCondition = deleteScreenerMarketQueryCondition;
      vm.addScreenerAlert = addScreenerAlert;
      vm.deleteScreenerAlert = deleteScreenerAlert;
      vm.screenerAlertOperatorSelected = screenerAlertOperatorSelected;
      vm.changeScreenerMarketGrouping = changeScreenerMarketGrouping;
      vm.exitScreenerWizard = exitScreenerWizard;
      vm.changeScreenerTradingBehavior = changeScreenerTradingBehavior;

      // results methods
      vm.changeResultsTradingBehavior = changeResultsTradingBehavior;
      vm.changeResultsMarketGrouping = changeResultsMarketGrouping;
      vm.getAlertLevel = wlUtil.getAlertLevel;
      vm.getTradingBehaviorIndicator = wlUtil.getTradingBehaviorIndicator;
      vm.getTotalsTradingBehaviorIndicator = wlUtil.getTotalsTradingBehaviorIndicator;
      vm.pageMatchResults = pageMatchResults;
      vm.toggleNoGrouping = toggleNoGrouping;
      vm.toggleNoGroupingRow = toggleNoGroupingRow;

      // dialog methods
      vm.openPaperTradeDialog = openPaperTradeDialog;
      vm.openScreenerDialog = openScreenerDialog;
      vm.openHelpDialog = openHelpDialog;
      vm.openDialog = openDialog;

      // misc methods
      vm.togglePanelContent = togglePanelContent;
      vm.goHome = goHome;
      vm.gotoScreeners = goToScreeners;
      //</editor-fold>

      //<editor-fold desc="Match Methods">
      angular.element($window).bind('orientationchange', function () {
        setIsScreenLTESm();
      });

      angular.element($window).bind('resize', function () {
        setIsScreenLTESm();
      });

      function setIsScreenLTESm() {
        if($mdMedia('xs') || $mdMedia('sm')) {
          vm.isScreenLTESm = true;
        } else {
          vm.isScreenLTESm = false;
        }
      }

      function loadMatch(match, betType, loadNewMatch)
      {
        //console.log(match);
        if (loadNewMatch === undefined) {
          loadNewMatch = true;
          if($scope.selectedMatch) {
            if($scope.selectedMatch.id == match.id) {
              loadNewMatch = false;
            }
          }
        }

        if(loadNewMatch) {
          $scope.selectedMatch = match;
          $scope.selectedMatch.betType = betType;

          loadMatchChart(betType, $scope.selectedMarketGrouping.values[$scope.selectedMarketGrouping.values.length - 1]);

        }
      }

      function loadMatchChart(betType, matchesBack)
      {
        $scope.selectedMatch.matchesBack = matchesBack;
        // @todo this can probably be optimized
       /* for (var i = 0; i < ResearchData.upcomingMatches.length; i++) {
          ResearchData.upcomingMatches[i].chartData = wlUtil.prepareMatchChartData(ResearchData.upcomingMatches[i], matchesBack, $scope.selectedTradingBehavior);
        }*/

        for (var i = 0; i < $scope.upcomingMatches.rows.length; i++) {
          $scope.upcomingMatches.rows[i].chartData = wlUtil.prepareMatchChartData($scope.upcomingMatches.rows[i], matchesBack, $scope.selectedTradingBehavior);
        }

        //console.log($scope.upcomingMatches.rows);

        $scope.matchChartOptions = {
          categoryField: "matchesBack",
          addClassNames: true,
          valueAxes: [{
            title: $scope.selectedMatch.chartData[betType].title,
            axisAlpha: 0,
            inside: true
          }],
          graphs: [],
          dataProvider: $scope.selectedMatch.chartData[betType].data,
          listeners: [{
            event: "clickGraphItem",
            method: graphItemClick
          }],
          startEffect: 'easeOutSine',
          allLabels: [{
            text: "Study Period",
            bold: true,
            y: 338,
            align: "center"
          }]
        };

        //console.log($scope.selectedMatch.chartData[betType].data);

        angular.copy($scope.selectedMatch.chartData[betType].graphs, $scope.matchChartOptions.graphs);

        $scope.matchChartOptions = wlUtil.serialChartOptionDefaults($scope.matchChartOptions);

        for(var i=0;i<$scope.matchChartOptions.graphs.length;i++) {
          if(betType == 'totals') {
            $scope.matchChartOptions.graphs[i].balloonFunction = formatTotalsChartBalloon;
          } else {
            $scope.matchChartOptions.graphs[i].balloonFunction = formatAtsMoneylineChartBalloon;
          }
          $scope.matchChartOptions.graphs[i].showHandOnHover = true;

          // hide balloon on small screens
          if(vm.isScreenLTESm)
          {
            $scope.matchChartOptions.graphs[i].showBalloon = false;
          }
        }

        //console.log(JSON.stringify($scope.matchChartOptions));
      }

      function viewMatchDetail(match, betType, index)
      {
        match.noGroupingVisible = false;
        loadMatch(match, betType);
        $scope.selectedMatch.selectedIndex = index;


        $('#results-widget').addClass('flipped');

        $location.hash('match-detail');
        $anchorScroll();

      }

      function closeMatchDetail()
      {
        $scope.selectedMatch = null;
        $('#results-widget').removeClass('flipped');
        resetChartLines('match-chart');
        AmCharts.charts = []; // clear chart so only a single chart is created. When window closes, its regenerated with new options
      }

      function selectMatchBetType(event, betType)
      {
        var activeRow = angular.element(event.target).parents('tr');
        // switch chart
        if(!activeRow.hasClass('active')) {
          $('#match-detail-wl-results-table tbody tr').removeClass('active');
          activeRow.addClass('active');
          $scope.selectedMatch.betType = betType;
          loadMatchChart(betType, $scope.selectedMarketGrouping.values[$scope.selectedMarketGrouping.values.length - 1]);
        }
      }

      function loadNextMatch()
      {
        var isLastMatch = vm.isLastMatch();
        if(!isLastMatch) {
          // check if the pagination needs to go to the next page
          if($scope.selectedMatch.selectedIndex == $scope.upcomingMatches.rows.length - 1) { // last row with this page data set
            // make call for next page of data
            $scope.upcomingMatches.criteria.page++;
            $scope.upcomingMatches.refresh(0);
          } else {
            var nextSelectedIndex = $scope.selectedMatch.selectedIndex + 1;
            loadMatchByIndex(nextSelectedIndex);
          }
        }

        resetChartLines('match-chart');
      }

      function loadPreviousMatch()
      {
        var isFirstMatch = vm.isFirstMatch();
        if(!isFirstMatch) {
          if($scope.selectedMatch.selectedIndex == 0) { // first row with this page data set
            // make call for previous page of data
            $scope.upcomingMatches.criteria.page--;
            $scope.upcomingMatches.refresh($scope.upcomingMatches.rows.length - 1);
          } else {
            var nextSelectedIndex = $scope.selectedMatch.selectedIndex - 1;
            loadMatchByIndex(nextSelectedIndex);
          }
        }
        resetChartLines('match-chart');
      }

      function loadMatchByIndex(index)
      {
        //console.log($scope.upcomingMatches.rows[index]);
        loadMatch($scope.upcomingMatches.rows[index], $scope.selectedMatch.betType);
        $scope.selectedMatch.selectedIndex = index;
        resetChartLines('match-chart');
      }

      function isFirstMatch()
      {
        if($scope.selectedMatch && $scope.upcomingMatches.rows.length > 0) {
          if($scope.upcomingMatches.criteria.page == 1 && $scope.selectedMatch.id == $scope.upcomingMatches.rows[0].id) {
            return true;
          }
        }
        return false;
      }

      function isLastMatch()
      {
        if($scope.selectedMatch && $scope.upcomingMatches.rows.length > 0) {
          if($scope.upcomingMatches.criteria.page == $scope.upcomingMatches.pageCount && $scope.selectedMatch.id == $scope.upcomingMatches.rows[$scope.upcomingMatches.rows.length - 1].id) {
            return true;
          }
        }
        return false;
      }

      //<editor-fold desc="Match chart methods">
      function selectChartDataPoint($event, betType, matchesBack)
      {
        $event.stopPropagation();
        var activeRow = angular.element($event.target).parents('tr');
        // switch chart
        if(!activeRow.hasClass('active')) {
          $('#match-detail-wl-results-table tbody tr').removeClass('active');
          activeRow.addClass('active');
        }

        if($scope.selectedMatchDataPoint) {
          $scope.selectedMatchDataPoint.removeClass('active');
        }

        $scope.selectedMatchDataPoint = angular.element($event.target)
        $scope.selectedMatchDataPoint.addClass('active');
        loadMatchChart(betType, matchesBack);
      }

      function highlightChartCursor(event, category)
      {
        var rowElement = angular.element(event.target).parents('tr');
        if(rowElement.hasClass('active')) {
          var chart = getAmChartByID('matchChart');
          category = getSelectedMarketGroupingMatchLength() - (category - 1); // point is opposite of grid match values
          /*if(chart.chartCursor != undefined) {
           chart.chartCursor.showCursorAt(category);
           }*/
        }
      }

      function unhighlightChartCursor(event)
      {
        var rowElement = angular.element(event.target).parents('tr');
        if(rowElement.hasClass('active')) {
          var chart = getAmChartByID('matchChart');
          /* if(chart.chartCursor != undefined) {
           chart.chartCursor.hideCursor();
           }*/
        }
      }

      function formatAtsMoneylineChartBalloon(graphDataItem, graph)
      {
        var graphData = {
          value: graphDataItem.values.value,
          homeVolatility: graphDataItem.dataContext.homeVolatility,
          awayVolatility: graphDataItem.dataContext.awayVolatility,
          matchesBack: graphDataItem.dataContext.matchesBack
        }

        var divergence  = Math.abs(graphDataItem.dataContext.homeVolatility - graphDataItem.dataContext.awayVolatility);
        var wolflineValue = divergence / (graph.data.length - (graphDataItem.dataContext.matchesBack - 1));

        var value = '<b>Price:</b> ' + graphDataItem.values.value + '<br>';
        value += '<b>Divergence:</b> ' + divergence + '<br>';
        value += '<b>Wolfline:</b> <span class="wl-label wl-alert-' + wlUtil.getAlertLevelByWolfline(wolflineValue) +'">' + wlUtil.formatWolflineNumber(wolflineValue) + '</span>';

        return value;
      }

      function formatTotalsChartBalloon(graphDataItem, graph)
      {
        var divergence  = Math.abs(graphDataItem.dataContext.volatility - 0);
        var wolflineValue = graphDataItem.values.value / (graph.data.length - (graphDataItem.dataContext.matchesBack - 1));
        //console.log(wolflineValue);
        var value = '<b>Volatility:</b> ' + graphDataItem.values.value + '<br>';
        value += '<b>Divergence:</b> ' + divergence + '<br>';
        value += '<b>Wolfline:</b> <span class="wl-label wl-alert-' + wlUtil.getAlertLevelByWolfline(wolflineValue) +'">' + wlUtil.formatWolflineNumber(wolflineValue) + '</span>';

        return value;
      }

      function enableLineDrawing(type) {
        vm.chartLine.enabled = true;
        vm.chartLine.type = type;

      }

      function disableLineDrawing() {
        vm.chartLine.enabled = false;
        vm.chartLine.trendline = null;
      }

      function clearTrendLines(chartID) {
        var chart = getAmChartByID(chartID);
        if(chart) {
          chart.trendLines = [];
          chart.validateNow();
        } else {
          //console.log('chart with id ' + chartID + ' not found');
        }
      }

      function clearGuideLines(chartID)
      {
        var chart = getAmChartByID(chartID);
        console.log(chart.valueAxes[0].guides);
        if(chart) {
          chart.valueAxes[0].guides = [];
          chart.validateNow();
        }
      }

      function resetChartLines(chartID)
      {
        var chart = getAmChartByID(chartID);
        if(chart) {
          chart.trendLines = [];
          chart.valueAxes[0].guides = [];
          chart.validateNow();

          vm.chartLine.enabled = false;
          vm.chartLine.type = null;
          vm.chartLine.trendline = null;
        }
      }

      function graphItemClick(event)
      {
        //console.log(event.chart);
        if(vm.chartLine.enabled) {
          if(vm.chartLine.type == 'trendline') {
            if(vm.chartLine.trendline) { // second click
              vm.chartLine.trendline.finalCategory = event.item.category;
              vm.chartLine.trendline.finalValue = event.item.values.value;

              event.chart.addTrendLine(vm.chartLine.trendline);
              event.chart.validateNow();
              vm.chartLine.trendline = null;
            } else { // first click
              vm.chartLine.trendline = {
                initialCategory: event.item.category,
                initialValue: event.item.values.value,
                lineColor: '#000000',
                lineThickness: 2,
                offsetX: event.event.layerX,
                offsetY: event.event.layerY
              }
              //  highlight the data point
              //console.log(event);
              var bullet = event.item.bulletGraphics.node;

              bullet.setAttribute("stroke","#000000");
              bullet.setAttribute("fill","#000000");
            }
          } else if(vm.chartLine.type == 'guide') {
            var guide = new AmCharts.Guide();
            guide.lineAlpha = 1;
            guide.value = event.item.values.value;
            guide.lineColor = "#a01db0";
            guide.lineThickness = 2;
            event.chart.valueAxes[0].addGuide(guide);
            event.chart.validateNow();
          }
        }
      }

      function chartMouseMove(event)
      {
        /*$('.jquery-line').remove();
        if(vm.chartLine.enabled && vm.chartLine.trendline) { // enable drawing from first point only from first click
          //console.log('x:' + event.offsetX + ' y:' + event.offsetY);

          if(event.offsetX > 1 && event.offsetY > 1) { // hovering over background grid causes the y to reset to 0 or 1 for some reason.
            $('#match-chart').line(vm.chartLine.trendline.offsetX, vm.chartLine.trendline.offsetY, event.offsetX - 10, event.offsetY, {color:"black", stroke: 2});
          }

        }*/
      }
      //</editor-fold>
      //</editor-fold>

      //<editor-fold desc="Results Methods">
      function changeResultsMarketGrouping(grouping)
      {
        if(grouping.id != $scope.selectedMarketGrouping.id) {
          $scope.selectedMarketGrouping = grouping;

          if($scope.selectedMatch) {
            // change the chart data range
            loadMatchChart('ats', $scope.selectedMarketGrouping.values[$scope.selectedMarketGrouping.values.length - 1]);
          }
        }
      }

      function changeResultsTradingBehavior(behavior)
      {
        if($scope.selectedTradingBehavior.id != behavior.id) {
          $scope.selectedTradingBehavior = behavior;
          // update the chart if we are on the match detail
          if($scope.selectedMatch) {
            loadMatchChart($scope.selectedMatch.betType, $scope.selectedMatch.matchesBack);
          }
        }
      }

      function pageMatchResults(page)
      {
        $scope.upcomingMatches.criteria.page = page;
        $scope.upcomingMatches.refresh();

        $location.hash('results-widget');
        $anchorScroll();
      }

      function toggleNoGroupingRow(ev, match)
      {
        ev.stopPropagation();

        var parentRow = $(ev.currentTarget).parents('tr').prev();
        var noGroupingContainer = $('td .no-grouping-container', parentRow.next('.no-grouping-row'));

        var horizPadding = parseInt($('td:first', parentRow).css('padding-left').replace('px', '')) + parseInt($('td:last', parentRow).css('padding-right').replace('px', ''));
        noGroupingContainer.css({'width': parentRow.width() - horizPadding});

        // set the data
        if(noGroupingContainer.html() == '') {
          var noGroupingContent = $('<table class="simple condensed"><thead><tr><th>Odds</th></tr></thead><tbody><tr><td>'+ $('td', parentRow).eq(4).html() + '</td></tr></tbody></table>');

          for(var i=1;i<vm.noMarketGrouping.values.length + 1;i++) {
            $('thead tr:first', noGroupingContent).append('<th>' + i + '</th>');
            $('tbody tr:first', noGroupingContent).append('<td>' + $('td', parentRow).eq(i+4).html() + '</td>');
          }

          noGroupingContainer.html(noGroupingContent);
        }

        if(noGroupingContainer.css('display') == 'block') {
          match.noGroupingVisible = false;
          noGroupingContainer.slideUp();

        } else {
          noGroupingContainer.slideDown();
          match.noGroupingVisible = true;
        }
      }

      function toggleNoGrouping(ev, match)
      {
        ev.stopPropagation();

        var parentContainer = $(ev.currentTarget).parents('.wolfline-table-container');
        var table = $('.wl-values-table', parentContainer);
        var className = $scope.selectedMarketGrouping.name.toLowerCase();

        if(table.hasClass(className)) {
          parentContainer.css({
            'width': parentContainer.width(),
            'overflow-x': 'scroll'
          });

          table.removeClass(className);
          match.noGroupingVisible = true;
        } else {
          table.addClass(className);
          parentContainer.css({
            'width': '',
            'overflow-x': ''
          });

          match.noGroupingVisible = false;
        }

      }
      //</editor-fold>

      //<editor-fold desc="Dialogs">
      function openPaperTradeDialog(ev, match, betType)
      {
        ev.stopPropagation();

        $mdDialog.show({
          controller         : 'PaperTradeDialogController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/papertrade/dialogs/papertrade/papertrade-dialog.html',
          parent             : angular.element($document.body),
          targetEvent        : ev,
          clickOutsideToClose: true,
          locals             : {
            event: ev,
            betTypes: ResearchData.queryOddsTypes,
            spreadTeams: ResearchData.spreadTeams,
            spreadWagerTypes: ResearchData.wagerTypes,
            totalsWagerTypes: ResearchData.totalsWagerTypes,
            moneylineWagerTypes: ResearchData.wagerTypes,
            marketGroupings: vm.marketGroupings,
            tradingBehaviors: ResearchData.tradingBehaviors,
            papertrade: {
              match: match,
              marketGrouping: $scope.selectedMarketGrouping,
              oddsType: wlUtil.findById(ResearchData.queryOddsTypes, betType),
              tradingBehavior: $scope.selectedTradingBehavior
            },
            constants: vm.constants
          }
        });
      }

      function openScreenerDialog(ev)
      {
        console.log("open screener");
        var update = false;
        if($scope.upcomingMatches.screener && $scope.upcomingMatches.screener.id) {
          update = true;
        }
        $mdDialog.show({
          controller         : 'ScreenerDialogController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/research/dialogs/screener/screener-dialog.html',
          parent             : angular.element($document.body),
          targetEvent        : ev,
          clickOutsideToClose: true,
          locals             : {
            event: ev,
            researchSettings: $scope.researchSettings,
            update: update
          }
        });
      }

      function openHelpDialog(ev, key)
      {
        $mdDialog.show(
          $mdDialog.alert()
            .htmlContent(vm.help[key])
            .ariaLabel('Help')
            .targetEvent(ev)
            .clickOutsideToClose(true)
            .ok('Close')
        );
      }

      function openDialog(ev, title, content)
      {

        $mdDialog.show(
          $mdDialog.alert()
            .htmlContent(content)
            .title(title)
            .ariaLabel('Dialog')
            .targetEvent(ev)
            .clickOutsideToClose(true)
            .ok('Close')
        );
      }
      //</editor-fold>

      //<editor-fold desc="Screener methods">
      function setDefaultResearchSettings(sport)
      {
        console.log("setDefaultResearchSettings");
        if (sport === undefined) {
          sport = null;
        }

        $scope.researchSettings.markets.rows = [];
        $scope.researchSettings.markets.rows.push({
          sport: sport,
          advancedSettingsVisible: false,
          conditions:[]
        });

        $scope.researchSettings.alerts.rows = [];
        /*$scope.researchSettings.alerts.rows.push({
          betType: null,
          alertLevel: null,
          numberOfAlerts: null,
          operator: ">=",
          range: null,
          conditionOperator: null
        });*/

      }

      function startNewScreenerWizard(ev)
      {
        console.log("startNewScreenerWizard");
        // reset screener
        $scope.researchSettings.name = null;
        $scope.researchSettings.description = null;
        $scope.researchSettings.sport = null;
        $scope.researchSettings.tournament = null;
        $scope.researchSettings.wizard.enabled = true;
        $scope.researchSettings.wizard.editMode = true;
        $scope.researchSettings.matchResults.showResultsPanel = false;
        $scope.researchSettings.tradingBehavior = ResearchData.tradingBehaviors[0];
        $scope.researchSettings.marketGrouping = $scope.alertMarketGroupings[0];
        $scope.researchSettings.alerts.rows = [];
        $scope.researchSettings.markets.rows = [{
          sport: null,
          advancedSettingsVisible: false,
          conditions:[]
        }];
      }


      function editScreener(ev)
      {
        console.log("editScreener");
        $scope.researchSettings.wizard.enabled = true;
        $scope.researchSettings.wizard.editMode = true;
        $scope.researchSettings.matchResults.showResultsPanel = false;
      }

      function selectScreenerMarket(ev, row, s)
      {
        console.log("selectScreenerMarket");
        if(s.id == null) {
          $scope.researchSettings.markets.multiple = false; // disable the ability to add additional markets because its set to all markets
          // alert user if they already have multiple markets and have selected all
          if($scope.researchSettings.markets.rows.length > 1) {
            $mdDialog.show(
              $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title('Warning')
                .textContent('You already have specific markets defined. Either remove your other markets or select a specific market.')
                .ariaLabel('Warning')
                .ok('OK')
                .targetEvent(ev)
            );
          }

        } else {
          row.sport = s;
          $scope.researchSettings.markets.multiple = true;

          // add all for tournaments
          if(row.sport.tournamentGroups.length > 0) {
            if(row.sport.tournamentGroups[0].id != 0) {
              row.sport.tournamentGroups.unshift(vm.allTournaments);
            }
          } else {
            row.sport.tournamentGroups.unshift(vm.allTournaments);
          }
        }
      }

      function loadScreener(screener, researchSettings)
      {
        console.log("loadScreener");

        researchSettings.id = screener.id;
        researchSettings.name = screener.name;
        researchSettings.description = screener.description;
        researchSettings.tradingBehavior = wlUtil.lookupEnumObjectByID(screener.tradingBehavior, ResearchData.tradingBehaviors);
        researchSettings.marketGrouping = wlUtil.lookupEnumObjectByID(screener.marketGrouping, $scope.alertMarketGroupings);
        $scope.selectedTradingBehavior = researchSettings.tradingBehavior;

        //$scope.researchSettings.marketGrouping = wlUtil.lookupEnumObjectByID(screener.marketGrouping, $scope.alertMarketGroupings);
        $scope.selectedMarketGrouping = researchSettings.marketGrouping;

        for(var i=0;i<screener.marketQueries.length; i++) {
          var query = screener.marketQueries[i];

          var row = {
            sport: query.sport,
            tournament: query.tournamentGroup,
            conditions: []
          };

          if(row.sport == null)
          {
            row.sport = vm.sports[0]; // if null its all
          }

          //console.log(row.sport.tournamentGroups);

          row.sport.tournamentGroups.unshift(vm.allTournaments);

          for(var j=0;j<query.conditions.length; j++) {

            var condition = {
              id: query.conditions[j].id,
              betType: wlUtil.lookupEnumObjectByID(query.conditions[j].oddsType, ResearchData.queryOddsTypes),
              operator: wlUtil.lookupEnumObjectByID(query.conditions[j].operator, ResearchData.mathOperators),
              value: query.conditions[j].value
            };

            row.conditions.push(condition);

            if(query.conditions[j].team !== undefined) {
              condition.team = wlUtil.lookupEnumObjectByID(query.conditions[j].team, ResearchData.spreadWagerTypes);
            }
          }

          researchSettings.markets.rows.push(row);
        }

        if(screener.alertQueries.length > 0) {
          for(var i=0;i<screener.alertQueries.length; i++) {
            var query = screener.alertQueries[i];
            var row = {
              id: query.id,
              betType: wlUtil.lookupEnumObjectByID(query.oddsType, ResearchData.queryOddsTypes),
              numberOfAlerts: query.numberOfAlerts,
              range: wlUtil.lookupEnumObjectByID(query.queryRange, $scope.researchSettings.marketGrouping.ranges),
              conditionOperator: wlUtil.lookupEnumObjectByID(query.conditionOperator, ResearchData.queryOperators),
              alertLevel: wlUtil.lookupEnumObjectByID(query.alertLevel, ResearchData.alertLevels)
            }

            researchSettings.alerts.rows.push(row);
          }
        } else {
          screener.alertQueries.push({
            betType: null,
            numberOfAlerts: null,
            range: null,
            conditionOperator: null,
            alertLevel: null
          });
        }
      }

      function saveAndRunScreener(ev)
      {
        if($scope.researchSettings.name == null) {
          $mdDialog.show({
            controller: 'ScreenerDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/research/dialogs/screener/screener-dialog.html',
            parent: angular.element($document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              event: ev,
              researchSettings: $scope.researchSettings,
              update: false
            }
          }).then(function() {
            if($scope.researchSettings.name) {
              saveScreener();
              $analytics.eventTrack('created', {  category: 'screener' });
              $analytics.eventTrack('ran', {  category: 'screener' });
            }
          });
        } else {
          saveScreener();
          $analytics.eventTrack('updated', {  category: 'screener' });
          $analytics.eventTrack('ran', {  category: 'screener' });
        }

      }

      function prepareScreenerFromResearchSettings()
      {
        var screener = {
          userID: $rootScope.user.id,
          name: $scope.researchSettings.name,
          description: $scope.researchSettings.description,
          tradingBehavior: $scope.researchSettings.tradingBehavior.id,
          marketGrouping: $scope.researchSettings.marketGrouping.id
        };

        screener.marketQueries = [];
        if($scope.researchSettings.markets.rows.length > 0) {

          for(var i=0;i<$scope.researchSettings.markets.rows.length; i++) {
            var row = $scope.researchSettings.markets.rows[i];
            var marketQuery = {
              conditions: []
            };

            if(row.sport) {
              marketQuery.sportID = row.sport.id;
            }

            if(row.tournament && row.tournament.id > 0) {
              marketQuery.tournamentGroupID = row.tournament.id;
            } else {
              marketQuery.tournamentGroupID = null;
            }

            if(row.conditions.length > 0) {
              for(var j=0;j<row.conditions.length;j++) {
                var marketQueryConditionValue = row.conditions[j].value;

                // if american odds && moneyline bet convert value to decimal which uses market price
                if($rootScope.user.oddsFormat == 0 && row.conditions[j].betType.id == 2) {
                  marketQueryConditionValue = wlUtil.convertAmericanPriceToDecimal(marketQueryConditionValue);
                }

                var marketQueryCondition = {
                  id: row.conditions[j].id,
                  oddsType: row.conditions[j].betType.id,
                  operator: row.conditions[j].operator.id,
                  value: marketQueryConditionValue
                };

                if(row.conditions[j].betType.id != 1) {
                  marketQueryCondition.team = row.conditions[j].team.id;
                }

                marketQuery.conditions.push(marketQueryCondition);
              }
            }

            screener.marketQueries.push(marketQuery);
          }
        }

        screener.alertQueries = [];
        if($scope.researchSettings.alerts.rows.length > 0) {

          for (var i = 0; i < $scope.researchSettings.alerts.rows.length; i++) {
            var row = $scope.researchSettings.alerts.rows[i];
            var alertQuery = {
              id: row.id,
              oddsType: row.betType.id,
              numberOfAlerts: row.numberOfAlerts,
              alertLevel: row.alertLevel.id,
              queryRange: row.range.id
            };

            if (row.conditionOperator) {
              alertQuery.conditionOperator = row.conditionOperator.id;
            }

            screener.alertQueries.push(alertQuery);
          }
        }

        //console.log(screener);

        return screener;
      }

      function saveScreener()
      {
        if($mdMedia('xs') || $mdMedia('sm')) {
          $location.hash('results-widget');
          $anchorScroll();
        }

        $scope.upcomingMatches.showLoading();
        $scope.researchSettings.matchResults.title = vm.defaultMatchResultsTitle;
        $scope.upcomingMatches.criteria.preview = false;
        $scope.researchSettings.matchResults.showResultsPanel = true;
        $scope.researchSettings.wizard.editMode = false;
        $scope.selectedMarketGrouping = $scope.researchSettings.marketGrouping;
        $scope.selectedTradingBehavior = $scope.researchSettings.tradingBehavior;
        $scope.upcomingMatches.criteria.page = 1;

        var screener = prepareScreenerFromResearchSettings();

        var $httpDefaultCache = $cacheFactory.get('$http');

        if($scope.upcomingMatches.screener.id) { // update screener

          screener.id = $scope.upcomingMatches.screener.id;

          $httpDefaultCache.remove($rootScope.apiURL + 'api/screeners');
          $httpDefaultCache.remove($rootScope.apiURL + 'api/screeners/' + screener.id);

          api.screener.matches.edit.update({ id: screener.id }, screener,
            function(response)
            {
              $scope.upcomingMatches.hideLoading();
              $scope.upcomingMatches.setUpcomingMatches(response.matches, response.matchCount);
              $scope.researchSettings.wizard.enabled = true;
              $scope.researchSettings.wizard.editMode = false;
              $rootScope.screenerSummary = null;

              if($mdMedia('xs') || $mdMedia('sm')) {
                $location.hash('results-widget');
                $anchorScroll();
              }

            },
            function(response)
            {
              $mdToast.show(
                $mdToast.simple()
                  .textContent($rootScope.constants.errors.default)
                  .position('top right')
                  .hideDelay(3000)
              );
              //console.log(response);
              $rootScope.loadingProgress = false;
              $scope.researchSettings.wizard.searching = false;
            }
          );

        } else { // new screener
          api.screener.matches.add.save(screener,
            function (response) {

              $httpDefaultCache.remove($rootScope.apiURL + 'api/screeners');
              //
              $scope.upcomingMatches.screener.id = response.screener.id;

              $mdDialog.hide(response.screener); // @todo not sure why this is here.

              $scope.upcomingMatches.hideLoading();
              $scope.upcomingMatches.setUpcomingMatches(response.matches, response.matchCount);

              $rootScope.screenerSummary = null; // reset the call to get the screener count
              //console.log('get new screener summary');
              if($mdMedia('xs') || $mdMedia('sm')) {
                $location.hash('results-widget');
                $anchorScroll();
              }

            },
            function (response) {
              //console.log(response);
              $rootScope.loadingProgress = false;
              $scope.researchSettings.wizard.searching = false;
            }
          );
        }
      }

      function previewScreener()
      {
        $scope.researchSettings.matchResults.title = vm.constants.matchResults.previewTitle;
        $scope.upcomingMatches.criteria.preview = true;
        $scope.upcomingMatches.api = api.screener.matches.preview;
        $scope.researchSettings.wizard.searching = true;
        $scope.researchSettings.matchResults.showResultsPanel = true;
        $scope.upcomingMatches.criteria.page = 1;

        var screener = prepareScreenerFromResearchSettings();
        if(screener.name) {
          screener.name += " (Preview)";
        } else {
          screener.name = "Preview";
        }

        $scope.selectedMarketGrouping = $scope.researchSettings.marketGrouping;
        $scope.selectedTradingBehavior = $scope.researchSettings.tradingBehavior;

        $scope.upcomingMatches.refresh();

        $analytics.eventTrack('previewed', {  category: 'screener' });
      }

      function changeScreenerTradingBehavior(behavior)
      {
        if($scope.researchSettings.tradingBehavior.id != behavior.id) {
          $scope.researchSettings.tradingBehavior = behavior;
        }
      }

      function toggleScreenerAdvancedMarketSettings(row)
      {
        if(row.advancedSettingsVisible) {
          row.advancedSettingsVisible = false;
          row.conditions = [];
        } else {
          row.advancedSettingsVisible = true;
          if(row.conditions.length == 0) {
            row.conditions.push({
              betType: null,
              operator: null,
              value: null,
              wagerType: null
            });
          }
        }
      }

      function addScreenerMarketQuery()
      {
        $scope.researchSettings.markets.rows.push({
          sport: null,
          advancedSettingsVisible: false,
          conditions: []
        });
      }

      function deleteScreenerMarketQuery(index)
      {
        $scope.researchSettings.markets.rows.splice(index, 1);
      }

      function addScreenerMarketQueryCondition(row)
      {
        row.conditions.push({
          betType: null,
          operator: null,
          value: null,
          wagerType: null
        });
      }

      function foo(row, index)
      {
        console.log(index);
        console.log(row);
      }

      function deleteScreenerMarketQueryCondition(row, index)
      {
        row.conditions.splice(index, 1);
        if(row.conditions.length == 0) {
          row.advancedSettingsVisible = false;
        }
      }

      function addScreenerAlert()
      {
        $scope.researchSettings.alerts.rows.push({
          betType: null,
          alertLevel: null,
          numberOfAlerts: null,
          operator: ">=",
          range: null,
          conditionOperator: null
        });
      }

      function deleteScreenerAlert(index)
      {
        $scope.researchSettings.alerts.rows.splice(index, 1);
        if($scope.researchSettings.alerts.rows.length > 0) {
          $scope.researchSettings.alerts.rows[$scope.researchSettings.alerts.rows.length - 1].conditionOperator = null; // remove the last condition operator
        }
      }

      function screenerAlertOperatorSelected(index, operator, ranges)
      {
        //console.log('index: ' + index + ' market queries:' + vm.marketForm.conditions.length);
        if(index == ($scope.researchSettings.alerts.rows.length - 1)) { // last record
          if(operator.id != null) {
            // add another record
            $scope.researchSettings.alerts.rows.push({
              betType: null,
              alertLevel: null,
              numberOfAlerts: null,
              operator: ">=",
              range: null,
              conditionOperator: null
            });
          }
        } else if(index  < ($scope.researchSettings.alerts.rows.length - 1) && operator.id == null) {
          // remove all the items below
          var nextIndex = (index + 1);
          var numOfItems =  ($scope.researchSettings.alerts.rows.length - 1) - index;
          $scope.researchSettings.alerts.rows.splice(nextIndex, numOfItems);
        }
      }

      function changeScreenerMarketGrouping(grouping)
      {
        if(grouping.id != $scope.researchSettings.marketGrouping.id) {
          $scope.researchSettings.marketGrouping = grouping;
          // clear all old alerts
          $scope.researchSettings.alerts.rows = [];
        }
      }

      function deleteScreenerMarketQuery(ev, index)
      {

        var confirm = $mdDialog.confirm()
          .title('Delete Market')
          .textContent('Are you sure you want to delete this market?')
          .ariaLabel('Delete Market')
          .targetEvent(ev)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .ok('Yes')
          .cancel('No');

        $mdDialog.show(confirm).then(function() {
          $scope.researchSettings.markets.rows.splice(index, 1);
        }, function() {
        });
      }

      function exitScreenerWizard(ev, callback)
      {
        var confirm = $mdDialog.confirm()
          .title('Exit Screener')
          .textContent('Are you sure you want to close your current screener?')
          .ariaLabel('Exit Screener')
          .targetEvent(ev)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .ok('Yes')
          .cancel('No');

        $mdDialog.show(confirm).then(function() {
          callback(ev);
        }, function() {

        });

      }
      //</editor-fold>

      //<editor-fold desc="Misc Methods">
      /*function checkResearchSettingsChanged()
      {
        if(!angular.equals(vm.originalResearchSettings, $scope.researchSettings)) {
          vm.researchSettingsChanged = true;
        }

        // check the arrays too
        if(!vm.researchSettingsChanged) {
          if(vm.originalResearchSettings.markets.rows.length == $scope.researchSettings.markets.rows.length) {
            for(var i=0;i<$scope.researchSettings.markets.rows.length;i++) {
              if(!angular.equals(vm.originalResearchSettings.markets.rows[i], $scope.researchSettings.markets.rows[i])) {
                vm.researchSettingsChanged = true;
                break;
              }
            }
          } else {
            vm.researchSettingsChanged = true;
          }
        }

        if(!vm.researchSettingsChanged) {
          if (vm.originalResearchSettings.alerts.rows.length == $scope.researchSettings.alerts.rows.length) {
            for (var i = 0; i < $scope.researchSettings.alerts.rows.length; i++) {
              if (!angular.equals(vm.originalResearchSettings.alerts.rows[i], $scope.researchSettings.alerts.rows[i])) {
                vm.researchSettingsChanged = true;
                break;
              }
            }
          } else {
            vm.researchSettingsChanged = true;
          }
        }
      }*/

      function getAmChartByID(id)
      {
        var allCharts = AmCharts.charts;
        for (var i = 0; i < allCharts.length; i++) {
          if(allCharts[i].div) {
            if (id == allCharts[i].div.id) {
              return allCharts[i];
            }
          }
        }
      }

      function togglePanelContent(event)
      {
        var target = angular.element(event.target);
        var panel = $(target).parents('.wl-panel');
        panel.toggleClass('collapsed');

      }

      function getSelectedMarketGroupingMatchLength()
      {
        return $scope.selectedMarketGrouping.values[$scope.selectedMarketGrouping.values.length - 1];
      }

      function goHome()
      {
        $state.go("app.research", { home: true, newScreener: false, screener: null });
      }

      function goToScreeners()
      {
        $state.go("app.screener");
      }

      function resetHomeState()
      {
        setDefaultResearchSettings();
        if (ResearchData.matches.length > 0) {
          $scope.upcomingMatches.init(ResearchData.matches, ResearchData.matchCount);
        }
      }
      //</editor-fold>
    }
})();


(function ()
{
  'use strict';

  angular
    .module('app.papertrade')
    .controller('PapertradeController', PapertradeController);

  /** @ngInject */
  function PapertradeController($rootScope, $scope, api, $mdDialog, $mdMedia, $mdToast, $document, $analytics, $cacheFactory, wlUtil, PaperTradeData, PaperTradesList, ConstantsData)
  {
    // Data
    var vm = this;
    vm.title = "Paper Trades";
    vm.paperTradesList = PaperTradesList;
    vm.papertrades = PaperTradesList.paperTrades;
    vm.paperTradeData = PaperTradeData;
    vm.constants = ConstantsData;
    vm.isScreenLTESm = false;
    vm.loadingPaperTrades = false;

    vm.reportRanges = [
      {
        key: "all",
        name: "All"
      },
      {
        key: "today",
        name: "Today"
      },
      {
        key: "week",
        name: "This week"
      },
      {
        key: "month",
        name: "This month"
      },
      {
        key: "year",
        name: "This year"
      }
    ];

    vm.criteria = {
      limit: 10,
      page: 1,
      range: vm.reportRanges[0]
    };


    vm.paginator = new Array();
    setPaginator();

    if($mdMedia('xs') || $mdMedia('sm')) {
      vm.isScreenLTESm = true;
    }

    setPaperTradesOddsType();
    setPaperTradesSpreadInfo();

    //console.log(vm.papertrades);
    //console.log($rootScope.appData.matchStatuses);

    vm.tradeTotals = {
      volume: 0,
      earned: 0
    };

    vm.tradeTotals.volume = vm.paperTradesList.totalVolume;
    vm.tradeTotals.earned = vm.paperTradesList.totalEarned;

    // Methods
    vm.getMatchStatusById = getMatchStatusById;
    vm.editPaperTrade = editPaperTrade;
    vm.getAlertLevel = wlUtil.getAlertLevel;
    vm.getPaperTrades = getPaperTrades;
    vm.getPaperTradesByRange = getPaperTradesByRange;
    vm.togglePaperTradeWolfline = togglePaperTradeWolfline;
    vm.refreshPaperTrades = refreshPaperTrades;
    vm.pagePaperTradeResults = pagePaperTradeResults;
    vm.changeCriteriaLimit = changeCriteriaLimit;
    vm.getTradingBehaviorIndicator = wlUtil.getTradingBehaviorIndicator;
    vm.getTotalsTradingBehaviorIndicator = wlUtil.getTotalsTradingBehaviorIndicator;

    function editPaperTrade(ev, papertrade)
    {
      $mdDialog.show({
        controller         : 'PaperTradeDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/papertrade/dialogs/papertrade/papertrade-dialog.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: true,
        locals             : {
          event: ev,
          betTypes: PaperTradeData.oddsTypes,
          spreadTeams: PaperTradeData.spreadTeams,
          spreadWagerTypes: PaperTradeData.spreadWagerTypes,
          totalsWagerTypes: PaperTradeData.totalsWagerTypes,
          moneylineWagerTypes: PaperTradeData.wagerTypes,
          marketGroupings: PaperTradeData.marketGroupings,
          tradingBehaviors: PaperTradeData.tradingBehaviors,
          papertrade: papertrade,
          constants: ConstantsData
        }
      });
    }

    function changeCriteriaLimit(limit) {
      vm.criteria.page = 1;
      vm.criteria.limit = limit;
      getPaperTrades();
    }

    function getPaperTrades()
    {
      //console.log(vm.criteria);
      vm.loadingPaperTrades = true;
      api.papertrade.range.get({ range: vm.criteria.range.key, page: vm.criteria.page, limit: vm.criteria.limit },
        function(response)
        {
          //console.log(response);
          vm.paperTradesList = response;
          vm.papertrades = response.paperTrades;
          setPaperTradesOddsType();
          setPaperTradesSpreadInfo();
          setPaginator();
          vm.tradeTotals.volume = response.totalVolume;
          vm.tradeTotals.earned = response.totalEarned;
          vm.loadingPaperTrades = false;
        },
        function(response)
        {
          $mdToast.show(
            $mdToast.simple()
              .textContent($rootScope.constants.errors.default)
              .position('top right')
              .hideDelay(3000)
          );
          vm.loadingPaperTrades = false;
        }
      );

    }

    function getPaperTradesByRange(range)
    {
      vm.criteria.page = 1;
      vm.criteria.range = range;
      vm.tradeTotals.volume = null;
      vm.tradeTotals.earned = null;
      getPaperTrades();
    }

    function setPaginator() {
      //console.log(vm.paperTradesList);
      //console.log(vm.criteria);
      vm.paginator = new Array();
      if(vm.paperTradesList.paperTradeCount > vm.criteria.limit) {

        var pageCount = Math.ceil(vm.paperTradesList.paperTradeCount / vm.criteria.limit);
        for(var i=0;i< pageCount;i++) {
          vm.paginator.push({ active: false, page: (i + 1) })
        }

      }
    }

    function setPaperTradesOddsType()
    {
      //console.log(vm.papertrades);
      for(var i=0;i<vm.papertrades.length;i++) {
        vm.papertrades[i].oddsType = wlUtil.lookupEnumObjectByID(vm.papertrades[i].oddsType, vm.paperTradeData.oddsTypes);

        vm.papertrades[i].wagerType = wlUtil.lookupEnumObjectByID(vm.papertrades[i].wagerType, vm.paperTradeData.wagerTypes);

        /*if(vm.papertrades[i].oddsType.id == 0 || vm.papertrades[i].oddsType.id == 2) {
          vm.papertrades[i].wagerType = wlUtil.lookupEnumObjectByID(vm.papertrades[i].wagerType, vm.paperTradeData.wagerTypes);
        } else if(vm.papertrades[i].oddsType.id == 1) {
          vm.papertrades[i].wagerType = wlUtil.lookupEnumObjectByID(vm.papertrades[i].wagerType, vm.paperTradeData.wagerTypes);
        }*/
        vm.papertrades[i].marketGrouping = wlUtil.lookupEnumObjectByID(vm.papertrades[i].marketGrouping, vm.paperTradeData.marketGroupings);
        vm.papertrades[i].tradingBehavior = wlUtil.lookupEnumObjectByID(vm.papertrades[i].tradingBehavior, vm.paperTradeData.tradingBehaviors);
      }
    }

    function togglePaperTradeWolfline(papertrade)
    {
      if(papertrade.wolflineVisible === undefined) {
        papertrade.wolflineVisible = true;
      } else if(papertrade.wolflineVisible) {
        papertrade.wolflineVisible = false;
      } else {
        papertrade.wolflineVisible = true;
      }

    }

    function getPaperTradeSpreadInfo(papertrade)
    {
      var data = {
        team: null,
        juice: null
      };

      if(papertrade.wagerType.id==0) {
        data.team = papertrade.match.homeCompetitor;
        data.juice = papertrade.odds.homeJuicePrice;
        if(papertrade.odds.favorite == 0) {
          data.team.favorite = true;
        } else {
          data.team.favorite = false;
        }
      } else {
        data.team = papertrade.match.awayCompetitor;
        data.juice = papertrade.odds.awayJuicePrice;
        if(papertrade.odds.favorite == 1) {
          data.team.favorite = true;
        } else {
          data.team.favorite = false;
        }
      }

      return data;
    }

    function setPaperTradesSpreadInfo()
    {
      for(var i=0;i<vm.papertrades.length;i++) {
        if(vm.papertrades[i].oddsType.id == 0) {
          vm.papertrades[i].trade = getPaperTradeSpreadInfo(vm.papertrades[i]);
        }
      }
    }

    function refreshPaperTrades()
    {
      var $httpDefaultCache = $cacheFactory.get('$http');
      $httpDefaultCache.remove($rootScope.apiURL + 'api/papertrades');
      $httpDefaultCache.remove($rootScope.apiURL + 'api/app/papertradedata');
      for(var i=0;i<vm.reportRanges.length;i++) {
        $httpDefaultCache.remove($rootScope.apiURL + 'api/papertrades/range/' + vm.reportRanges[i].key);
      }

      getPaperTrades();
    }

    function getMatchStatusById(id) {
      for(var i=0;i<$rootScope.appData.matchStatuses.length;i++) {
        if(id == $rootScope.appData.matchStatuses[i].id) {
          return $rootScope.appData.matchStatuses[i];
        }
      }
    }

    function pagePaperTradeResults(page) {
     vm.criteria.page = page;
     getPaperTrades();
    }
  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.orderhistory', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider)
  {
    // State
    $stateProvider.state('app.orderhistory', {
      url      : '/orderhistory',
      views    : {
        'content@app': {
          templateUrl: 'app/main/orderhistory/orderhistory.html',
          controller : 'OrderHistoryController as vm'
        }
      },
      resolve: {
        OrderData: function (apiResolver)
        {
          return apiResolver.resolve('user.orders@query');
        }
      },
      bodyClass: 'order-history',
      authenticate: true,
      inactiveUserAccessible: false
    });
  }

})();

(function ()
{
  'use strict';

  angular
    .module('app.orderhistory')
    .controller('OrderHistoryController', OrderHistoryController);

  /** @ngInject */
  function OrderHistoryController($rootScope, OrderData, $location, $mdDialog, $mdToast, $analytics, api)
  {
    // Data
    var vm = this;
    vm.title = "Order History";
    vm.orders = OrderData;


  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.checkout', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
  {
    // State
    $stateProvider.state('app.checkout', {
      url      : '/checkout',
      views    : {
        'content@app': {
          templateUrl: 'app/main/checkout/checkout.html',
          controller : 'CheckoutController as vm'
        }
      },
      resolve: {
        SubscriptionData: function (apiResolver)
        {
          return apiResolver.resolve('subscription@query');
        },
        CreditCardData: function (apiResolver)
        {
          return apiResolver.resolve('user.credit_card.list@query', { status: 0 });
        }
      },
      bodyClass: 'checkout',
      authenticate: true,
      inactiveUserAccessible: true
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/pages/auth/profile');

      msNavigationServiceProvider.saveItem('checkout', {
        title : 'Checkout',
        weight: 5,
        icon: 'icon-cart-outline',
        state: 'app.checkout',
        hidden: true
      });

  }

})();

(function ()
{
  'use strict';

  angular
    .module('app.checkout')
    .controller('FaqController', FaqController);

  /** @ngInject */
  function FaqController($rootScope, $scope, $mdToast, $analytics, $cacheFactory, $window, msNavigationService, api, $state)
  {
    // Data
    var vm = this;
    vm.title = "Faq";
  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.checkout')
    .controller('CheckoutController', CheckoutController);

  /** @ngInject */
  function CheckoutController($rootScope, $scope, $mdToast, $analytics, $cacheFactory, $window, msNavigationService, SubscriptionData, CreditCardData, api, $state)
  {
    // Data
    var vm = this;
    vm.title = "Checkout";
    vm.subscriptions = SubscriptionData;
    // console.log(SubscriptionData)
    // vm.sessionUser = JSON.parse($window.sessionStorage.user);
    // console.log(vm.sessionUser.paypalSubscriptionID)
    // vm.selectedSubscription = vm.subscriptions[0];
    vm.earlyBirdSubscription = vm.subscriptions[3];
    vm.montlySubscription = vm.subscriptions[4];
    vm.yearlySubscription = vm.subscriptions[5];

    vm.creditCards = CreditCardData;
    vm.existingCreditCard = null;
    vm.selectedSubscriptionID = null;
    vm.selectedSubscription = null;
    vm.step = 1;
    vm.countries = $rootScope.appData.countries;
    vm.cardTypes = $rootScope.appData.creditCardTypes;
    vm.submitting = false;
    vm.date = new Date();
    vm.user = $rootScope.user;
    // console.log(vm.user.paypalSubscriptionID)
    // console.log($rootScope.user.subscriptionExpirationDate)
    vm.cart = {
      items: [],
      tax: 0,
      total: 0,
      update: function() {
        this.total = 0;

        for(var i=0;i<this.items.length;i++) {
          this.total += this.items[i].price;
        }

        // if(vm.existingCreditCard == null) {
        //   this.setTax(vm.creditCardForm.province);
        // } else {
        //   this.setTax(vm.existingCreditCard.billingAddress.province);
        // }

        this.total += this.tax;
      },
      setTax: function (province) {
        if(province.toLowerCase() == 'new jersey' || province.toLowerCase() == 'nj' || province.toLowerCase() == 'newjersey') {
          this.tax = vm.selectedSubscription.price * .07;
        }
      }
    };

    vm.creditCardForm = {};
    vm.creditCardForm.defaultCard = true;
    vm.accountPastExpiration = true;
    if(moment().isBefore($rootScope.user.subscriptionExpirationDate)) {
      vm.accountPastExpiration = false;
    }

    $scope.constants = $rootScope.constants;

    vm.nextStep = nextStep;
    vm.previousStep = previousStep;
    vm.checkout = checkout;
    vm.useNewCreditCard = useNewCreditCard;
    vm.reviewCheckout = reviewCheckout;
    vm.test = test;

    function previousStep()
    {
      if(vm.step > 1) {
        vm.step--;
      }
    }

    function nextStep()
    {
      vm.step++;
    }

    function test()
    {
      console.log(vm.selectedSubscription)
      console.log(vm.selectedSubscriptionID)

      if(vm.existingCreditCard != null && vm.selectedSubscriptionID != null)
      {
        console.log(vm.subscriptions)
        // vm.selectedSubscription = vm.subscriptions.find(x => x.id === vm.selectedSubscriptionID)
        console.log(vm.selectedSubscription)

        return true
      }
      else{
        return false
      }
    }

    function reviewCheckout()
    {
      // vm.cart.creditCardID = vm.existingCreditCard.id;
      // vm.cart.creditCard = vm.existingCreditCard;
      vm.cart.items = [];
      // vm.selectedSubscription = vm.subscriptions.find(x => x.id === vm.selectedSubscriptionID)

      vm.selectedSubscription = vm.subscriptions.find(function(x){
        return x.id == vm.selectedSubscriptionID
      });

      vm.cart.items.push(vm.selectedSubscription);
      vm.cart.update();

      sessionStorage.selectedSubscription = JSON.stringify(vm.selectedSubscription);

      nextStep();
    }

    $scope.checkoutRedirect = function(paypalSubscriptionID) {
      // console.log(paypalSubscriptionID)
      var profileInfo = {
        email: $rootScope.user.email,
        timezone: $rootScope.user.timezone,
        paypalSubscriptionID: paypalSubscriptionID,
        subscriptionStatus: 0
      };
      //save to user
      api.user.editSubscriptionPlan.update(profileInfo,
        function(response)
        {
          // console.log('success')
          // console.log(response)
          // console.log('logout')

          delete $window.sessionStorage.token;
          delete $window.sessionStorage.user;
          var $httpDefaultCache = $cacheFactory.get('$http');
          $httpDefaultCache.removeAll();
          $rootScope.screenerSummary = null;
          $rootScope.user = null;

          $state.go("app.pages_auth_login");
        },
        function(response)
        {
          // console.log('error')
          // console.log(response)
        }
      );
      // $state.go("app.research");
    }

    function useNewCreditCard()
    {
      vm.selectedSubscription = vm.subscriptions.find(function(x){
        return x.id == vm.selectedSubscriptionID
      });
      vm.cart.items = [];
      vm.cart.items.push(vm.selectedSubscription);
      vm.cart.update();

      vm.cart.creditCardID = null;
      vm.cart.creditCard = {
        description: vm.creditCardForm.description,
        firstName: vm.creditCardForm.firstName,
        lastName: vm.creditCardForm.lastName,
        company: vm.creditCardForm.company,
        billingAddress: {
          streetAddress: vm.creditCardForm.address1,
          streetAddress2: vm.creditCardForm.address2,
          city: vm.creditCardForm.city,
          province: vm.creditCardForm.province,
          postalCode: vm.creditCardForm.postalCode,
          countryID: vm.creditCardForm.country.id
        },
        cardType: vm.creditCardForm.cardType.id,
        expirationMonth: vm.creditCardForm.cardExpirationMonth,
        expirationYear: vm.creditCardForm.cardExpirationYear,
        cardNumber: vm.creditCardForm.cardNumber,
        cardCvv: vm.creditCardForm.cardCvv,
        userID: $rootScope.user.id,
        default: vm.creditCardForm.defaultCard,
        lastFour: vm.creditCardForm.cardNumber.substr(vm.creditCardForm.cardNumber.length - 4, 4)
      };

      nextStep();
    }

    function checkout()
    {
      var productIds = [];

      for(var i=0;i<vm.cart.items.length;i++) {
        productIds.push(vm.cart.items[i].id);
      }

      vm.cart.productIds = productIds;
      vm.cart.subscriptionID = vm.selectedSubscription.id;

      vm.submitting = true;
      $rootScope.loadingProgress = true;

      api.cart.checkout.save(vm.cart,
        function(response)
        {
          var $httpDefaultCache = $cacheFactory.get('$http');
          $httpDefaultCache.remove($rootScope.apiURL + 'api/paymenttransactions');
          $httpDefaultCache.remove($rootScope.apiURL + 'api/creditcards');
          nextStep();
          vm.submitting = false;
          $rootScope.loadingProgress = false;

          msNavigationService.saveItem('checkout', { hidden: true });
          msNavigationService.saveItem('home', { hidden: false });
          msNavigationService.saveItem('research', { hidden: false });
          msNavigationService.saveItem('screeners', { hidden: false });
          msNavigationService.saveItem('papertrade', { hidden: false });
          msNavigationService.saveItem('faq', { hidden: false });

          $rootScope.user.subscriptionStatus = 0;

          if($rootScope.constants.debugMode) {
            $window.sessionStorage.user = JSON.stringify($rootScope.user);
          }

          var transaction = {
            id: response.id,
            affiliation: 'TheWolfline App',
            revenue: response.totalAmount,
            tax: response.tax,
            shipping: 0,
            currency: 'USD'
          };

          //console.log(transaction);
          ga('require', 'ecommerce');
          ga('ecommerce:addTransaction', transaction);

          for (var i = 0; i < vm.cart.items.length; i++) {
            var item = vm.cart.items[i];

            var transactionItem = {
              id: transaction.id,
              name: item.name,
              sku: item.sku,
              category: 'Subscription',
              price: item.price,
              quantity: 1,
              currency: 'USD'
            };

            //console.log(transactionItem);

            ga('ecommerce:addItem', transactionItem);
          }

          ga('ecommerce:send');
          //console.log(vm.cart.items);
          //console.log(response);

        },
        function(response)
        {
          //console.log(response);
          $mdToast.show(
            $mdToast.simple()
              .textContent($rootScope.constants.errors.creditCardError)
              .position('top right')
              .hideDelay(10000)
          );
          vm.submitting = false;
          $rootScope.loadingProgress = false;
        }
      );
    }
  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.dashboard', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
  {
    // State
    $stateProvider.state('app.dashboard', {
      url      : '/dashboard',
      views    : {
        'content@app': {
          templateUrl: 'app/main/dashboard/dashboard.html',
          controller : 'DashboardController as vm'
        }
      },
      resolve: {
        DashboardData: function (apiResolver)
        {
          return apiResolver.resolve('dashboard@get');
        }
      },
      bodyClass: 'dashboard',
      authenticate: true
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/dashboard');

    // Navigation

    /*msNavigationServiceProvider.saveItem('dashboard', {
      title : 'Dashboard',
      weight: 1,
      icon: 'icon-speedometer',
      state: 'app.dashboard'
    });*/

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController($mdSidenav, DashboardData)
    {
        var vm = this;

        vm.dashboardData = DashboardData;
        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        vm.widget7 = vm.dashboardData.widget7;

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
          $mdSidenav(sidenavId).toggle();
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '='
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();

(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  :   {"primary":{"name":"fuse-pale-blue","hues":{"default":"700","hue-1":"500","hue-2":"600","hue-3":"400"}},"accent":{"name":"indigo","hues":{"default":"600","hue-1":"400","hue-2":"700","hue-3":"A100"}},"warn":{"name":"red","hues":{"default":"500","hue-1":"300","hue-2":"800","hue-3":"A100"}},"background":{"name":"grey","hues":{"default":"A100","hue-1":"100","hue-2":"50","hue-3":"300"}}},
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();

(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-border {\n  border:solid 1px @accentDefaultColor !important;\n}\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('wlUtil', wlUtil);

    /** @ngInject */
    function wlUtil($window, $mdMedia)
    {
        var service = {
          serialChartOptionDefaults: serialChartOptionDefaults,
          prepareMatchChartData: prepareMatchChartData,
          getAlertLevel: getAlertLevel,
          getAlertLevelByWolfline: getAlertLevelByWolfline,
          getMarketQueryColumns: getMarketQueryColumns,
          getAlertQueryColumns: getAlertQueryColumns,
          lookupEnumObjectByID: lookupEnumObjectByID,
          formatWolflineNumber: formatWolflineNumber,
          sumPropertyOfObjectArray: sumPropertyOfObjectArray,
          findById: findById,
          findBy: findBy,
          getTradingBehaviorIndicator: getTradingBehaviorIndicator,
          getTotalsTradingBehaviorIndicator: getTotalsTradingBehaviorIndicator,
          createNewScreenerName: createNewScreenerName,
          convertAmericanPriceToDecimal: convertAmericanPriceToDecimal,
          convertDecimalPriceToAmerican: convertDecimalPriceToAmerican
        };

        var greenLineColor = "#5fb503";
        var redLineColor = "#FF0707";

        return service;

        function serialChartOptionDefaults(options) {

          var defaultOptions = {
            type: "serial",
            pathToImages: '/bower_components/amcharts/dist/amcharts/images/',
            legend: {
              enabled: true
            },
            chartScrollbar: {
              enabled: false,
            },
            chartCursor: {
              cursorAlpha: 1,
              zoomable: false
            },
            categoryAxis: {
              gridPosition: "start",
              parseDates: false,
              axisAlpha: 0
            },
            balloon: {
              textAlign: "left"
            }

          };

          for(var i=0; i<options.graphs.length; i++) {
            if(!options.graphs[i].lineThickness) {
              options.graphs[i].lineThickness = 2;

            }

            if(!options.graphs[i].bullet) {
              options.graphs[i].bullet = "round";
            }

          }

          return angular.extend(options, defaultOptions);
        }

        function prepareMatchChartData(match, numberOfGames, tradingBehavior)
        {
          var totalsTitle = "Volatility Action";
          if($mdMedia('xs')) {
            totalsTitle += " (Away+Home)";
          } else {
            totalsTitle += " (" + match.awayCompetitor.name + "+" + match.homeCompetitor.name + ")";
          }
          var chartData = {
            ats: {
              title: "Spread/Price/Relative Strength",
              graphs: [
                {
                  id: "g2",
                  title: 'A: ' + match.awayCompetitor.name + ' (Price Action)',
                  valueField: "awayVolatility",
                  lineThickness: 2,
                  bullet: "round"
                },
                {
                  id: "g1",
                  title: 'H: ' + match.homeCompetitor.name + ' (Price Action)',
                  valueField: "homeVolatility",
                  lineThickness: 2,
                  bullet: "round"
                }
              ],
              data: []
            },
            totals: {
              title: "Totals/Volatility",
              graphs: [
                {
                  id: "g1",
                  title: totalsTitle,
                  valueField: "volatility",
                  lineThickness: 2,
                  bullet: "round"
                }
              ],
              data: []
            },
            moneyline: {
              title: "Moneyline/Probability Delta %",
              graphs: [
                {
                  id: "g2",
                  title: 'A: ' + match.awayCompetitor.name,
                  valueField: "awayVolatility",
                  lineThickness: 2,
                  bullet: "round"
                },
                {
                  id: "g1",
                  title: 'H: ' + match.homeCompetitor.name,
                  valueField: "homeVolatility",
                  lineThickness: 2,
                  bullet: "round"
                }
              ],
              data: []
            }
          };

          var matchVolatilityData = getMatchVolatilityData(match, numberOfGames);
          chartData.ats.data = matchVolatilityData.ats;
          chartData.totals.data = matchVolatilityData.totals;
          chartData.moneyline.data = matchVolatilityData.moneyline;
          // set the graph info

          var lastAtsRecord = chartData.ats.data[chartData.ats.data.length - 1];
          var atsLineColors = getChartLineColors(tradingBehavior, lastAtsRecord.homeVolatility, lastAtsRecord.awayVolatility);
          chartData.ats.graphs[0].lineColor = atsLineColors.away;
          chartData.ats.graphs[1].lineColor = atsLineColors.home;

          var lastMoneylineRecord = chartData.moneyline.data[chartData.moneyline.data.length - 1];
          var moneylineLineColors = getChartLineColors(tradingBehavior, lastMoneylineRecord.homeVolatility, lastMoneylineRecord.awayVolatility);
          chartData.moneyline.graphs[0].lineColor = moneylineLineColors.away;
          chartData.moneyline.graphs[1].lineColor = moneylineLineColors.home;

          var lastTotalsRecord = chartData.totals.data[chartData.totals.data.length - 1];
          if(lastTotalsRecord.volatility >= 0) {
            chartData.totals.graphs[0].lineColor = greenLineColor;
          } else {
            chartData.totals.graphs[0].lineColor = redLineColor ;
          }

          //console.log(atsLineColors);
          //console.log(marketingGroup);
          //console.log(chartData);
          return chartData;
        }

        function getMatchVolatilityData(match, numberOfGames)
        {
          var data = {
            ats: [],
            totals: [],
            moneyline: []
          };

          if(match.homeCompetitorResults.length > 0 && match.awayCompetitorResults.length > 0) {
            var homeData = match.homeCompetitorResults.slice(0, numberOfGames).reverse(); // get the oldest match first
            var awayData = match.awayCompetitorResults.slice(0, numberOfGames).reverse();

            var matchesBack;
            for(var i=0; i<homeData.length; i++) {

              matchesBack = (homeData.length - i);
              if(matchesBack <= numberOfGames) {

                // sum home/away results
                /*var atsHomeSum = sumPropertyOfObjectArray(data.HomeCompetitor[i], 'SpreadOutcome');
                 var atsAwaySum = sumPropertyOfObjectArray(data.AwayCompetitor[i], 'SpreadOutcome');
                 var atsDivergence = Math.abs(atsHomeSum - atsAwaySum);
                 var atsWl = atsDivergence / matchesBack;*/
                //console.log(data.HomeCompetitor.slice(0,i));

                // ATS
                var atsHomeVolatility = sumPropertyOfObjectArray(homeData.slice(0, (i + 1)), 'spreadOutcome');
                var atsAwayVolatility = sumPropertyOfObjectArray(awayData.slice(0, (i + 1)), 'spreadOutcome');

                data.ats.push({
                  //id: homeData[i].id + '/' + awayData[i].id,
                  matchesBack: matchesBack,
                  homeVolatility: atsHomeVolatility,
                  awayVolatility: atsAwayVolatility
                });

                // Totals
                var totalsHomeVolatility = sumPropertyOfObjectArray(homeData.slice(0, (i + 1)), 'totalsOutcome');
                var totalsAwayVolatility = sumPropertyOfObjectArray(awayData.slice(0, (i + 1)), 'totalsOutcome');

                data.totals.push({
                  //id: homeData[i].id + '/' + awayData[i].id,
                  matchesBack: matchesBack,
                  volatility: totalsHomeVolatility + totalsAwayVolatility,
                  homeVolatility: totalsHomeVolatility,
                  awayVolatility: totalsAwayVolatility
                });

                // Moneyline
                var moneylineHomeVolatility = sumPropertyOfObjectArray(homeData.slice(0, (i + 1)), 'matchOutcome');
                var moneylineAwayVolatility = sumPropertyOfObjectArray(awayData.slice(0, (i + 1)), 'matchOutcome');

                data.moneyline.push({
                  //id: homeData[i].id + '/' + awayData[i].id,
                  matchesBack: matchesBack,
                  homeVolatility: moneylineHomeVolatility,
                  awayVolatility: moneylineAwayVolatility
                });
              }
            }
          }

          return data;
        }

        function getChartLineColors(tradingBehavior, homeValue, awayValue)
        {
          var lineColors = {};
          if(tradingBehavior.id == 0) { // correction trading

            if (homeValue < awayValue) {

              lineColors.home = redLineColor;
              lineColors.away = greenLineColor;
            } else {
              lineColors.home = greenLineColor;
              lineColors.away = redLineColor;
            }

          } else { // momentum trading
            if (homeValue < awayValue) {

              lineColors.home = redLineColor;
              lineColors.away = greenLineColor;
            } else {
              lineColors.home = greenLineColor;
              lineColors.away = redLineColor;
            }
          }

          return lineColors;
        }

        function sumPropertyOfObjectArray(a, property) {
          var sum = 0;
          for(var i=0; i < a.length; i++) {
            //console.log('Sum: ' + sum + '+' + a[i][property] + '=' + (sum + parseFloat(a[i][property])));
            sum += parseFloat(a[i][property]);
          }

          return sum;
        }

        function getAlertLevel(n) {
          var alert = '';
          n = parseInt(n);
          switch(n) {
            case 1:
              alert = 'low';
              break;
            case 2:
              alert = 'medium';
              break;
            case 3:
              alert = 'high';
              break;
          }

          return alert;
        }

        function getAlertLevelByWolfline(n) {
          var alert = 'normal';
          n = parseFloat(n);

          if(n >= .80 && n <= 1.19 || n <= -.80 && n >= -1.19) {
            alert = 'low';
          } else if(n > 1.19 && n <= 1.59 || n < -1.19 && n >= -1.59) {
            alert = 'medium';
          } else if(n > 1.59 && n <= 2 || n < -1.59 && n >= -2) {
            alert = 'high';
          }

          return alert;
        }

        function getMarketQueryColumns()
        {
          var columns = [
            { title: 'Sport' },
            { title: 'League' },
            { title: 'Odds' }
          ];

          return columns;
        }

        function getAlertQueryColumns()
        {
          var columns = [
            {title: 'Odds'},
            {title: 'Alert'},
            {title: 'Range'},
            {title: 'Operator'}
          ];

          return columns;
        }

        function lookupEnumObjectByID(id, objects)
        {
          for(var i=0;i<objects.length;i++) {
            if(objects[i].id == id) {
              return objects[i];
            }
          }
        }

        function formatWolflineNumber(decimal)
        {
          decimal = parseFloat(decimal);

          if (decimal !== undefined || decimal !== null) {
            if (decimal != 0) {
              decimal = decimal.toFixed(2);
              if (decimal.charAt(0) == '0') {
                decimal = decimal.substr(1, decimal.length - 1);
              }
            }

            return decimal;
          }
        }

        function findById(a, id)
        {
          var o = null;
          for(var i=0; i<a.length; i++) {
            if(a[i].id == id) {
              o = a[i];
              break;
            }
          }
          return o;
        }

        function findBy(a, params)
        {
          var o = null;
          for(var i=0; i<a.length; i++) {
            if(a[i][params.prop] == params.value) {
              o = a[i];
              break;
            }
          }
          return o;
        }

        function getTradingBehaviorIndicator(match, numberOfGames, tradingBehavior, type)
        {
          var indicator = '';
          var volatilityData = getMatchVolatilityData(match, numberOfGames);
          var typeVolatilityData = volatilityData[type];
          var lastVolatilityRecord = typeVolatilityData[typeVolatilityData.length - 1];
          if(tradingBehavior.id == 0) { // correction trading
            if(lastVolatilityRecord.homeVolatility > lastVolatilityRecord.awayVolatility) {
              indicator = 'A';
            } else if(lastVolatilityRecord.homeVolatility == lastVolatilityRecord.awayVolatility) {
              indicator = '-';
            } else {
              indicator = 'H';
            }
          } else { // momentum trading
            if(lastVolatilityRecord.homeVolatility > lastVolatilityRecord.awayVolatility) {
              indicator = 'H';
            } else if(lastVolatilityRecord.homeVolatility == lastVolatilityRecord.awayVolatility) {
                indicator = '-';
            } else {
              indicator = 'A';
            }
          }


          return indicator;
        }

        function getTotalsTradingBehaviorIndicator(value, tradingBehavior)
        {
          var indicator = '';
          value = parseFloat(value);

          if(tradingBehavior.id == 0) { // correction trading

            if (value > 0) {
              indicator = 'U';
            } else if(value === 0) {
              indicator = '-';
            } else {
              indicator = 'O';
            }
          } else { // momentum trading
            if (value > 0) {
              indicator = 'O';
            } else if(value === 0) {
              indicator = '-';
            } else {
              indicator = 'U';
            }
          }

          //console.log(value + ' ' + indicator);
          return indicator;
        }

        function createNewScreenerName(screeners, name, increment)
        {
          if (increment === undefined || increment === null) {
            increment = 0;
          }

          if(increment > 0) {
            var lastSuffix = ' (' + (increment - 1) + ')';
            var newSuffix = ' (' + increment + ')';
            if(name.indexOf(lastSuffix) >= 0) {
              name.replace(lastSuffix, newSuffix);
            } else {
              name += newSuffix;
            }
          }
          for(var i=0;i<screeners.length;i++) {

            if(screeners[i].name.trim() == name) {
              increment += 1;
              return createNewScreenerName(screeners, name, increment);
            }
          }
          return name;
        }

        function convertAmericanPriceToDecimal(price)
        {
          if(price) {
            price = parseFloat(price);

            if(price > 0) {
              price = (price / 100) + 1;
            } else if(price < 0) {
              price = (100 / Math.abs(price)) + 1;
            } else {
              return price; // 0
            }

            return price.toFixed(2);
          }
        }

        function convertDecimalPriceToAmerican(price)
        {
          if(price) {
            price = parseFloat(price);
            if(price >= 2) {
              price = (price - 1) * 100;
            } else {
              price = -100/(price - 1);
            }

            return Math.round(price);

          }
        }
    }
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Edge",
                    versionSearch: "Edge",
                    identity     : "Edge"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Chrome",
                    identity : "Chrome"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "OmniWeb",
                    versionSearch: "OmniWeb/",
                    identity     : "OmniWeb"
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : "Apple",
                    versionSearch: "Version",
                    identity     : "Safari"
                },
                {
                    prop    : $window.opera,
                    identity: "Opera"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "iCab",
                    identity : "iCab"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "KDE",
                    identity : "Konqueror"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Firefox",
                    identity : "Firefox"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "Camino",
                    identity : "Camino"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Netscape",
                    identity : "Netscape"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "MSIE",
                    identity     : "Explorer",
                    versionSearch: "MSIE"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Trident/7",
                    identity     : "Explorer",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Gecko",
                    identity     : "Mozilla",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Mozilla",
                    identity     : "Netscape",
                    versionSearch: "Mozilla"
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: "Win",
                    identity : "Windows"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Mac",
                    identity : "Mac"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Linux",
                    identity : "Linux"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPhone",
                    identity : "iPhone"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPod",
                    identity : "iPod"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPad",
                    identity : "iPad"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Android",
                    identity : "Android"
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) != -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index == -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || "unknown-browser";
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || "unknown-version";
            var os = searchString(osData) || "unknown-os";

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) == -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('wolflineNumberAlert', wolflineNumberAlertFilter)
        .filter('toWolflineNumber', toWolflineNumberFilter)
        .filter('formatOdds', formatOddsFilter);

    function toWolflineNumberFilter()
    {
      return function(decimal)
      {
        if (decimal !== undefined || decimal !== null) {
          if (decimal != 0) {
            decimal = decimal.toFixed(2);
            if (decimal.charAt(0) == '0') {
              decimal = decimal.substr(1, decimal.length - 1);
            }
          }

          return decimal;
        }

      }
    }

    function wolflineNumberAlertFilter()
    {
      return function(n)
      {
        var alert = '';
        switch(n) {
          case 1:
            alert = 'low';
                break;
          case 2:
            alert = 'medium';
                break;
          case 3:
            alert = 'high';
                break;
        }
        return alert;
      }
    }

    function formatOddsFilter()
    {


      return function(price, type)
      {
        if(price) {
          price = parseFloat(price);
          if(price > 1) {
            if (type == 0) { // odds come in as decimal so convert if american/0
              if (price >= 2) {
                price = (price - 1) * 100;
              } else {
                price = -100 / (price - 1);
              }

              price = Math.round(price);
              if (price > 0) {
                price = '+' + price;
              }

              return price;
            } else {
              price = price.toFixed(3);
            }
          } else {

            price = null;
          }
        }

        return price;
      }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter)
        .filter('reverseArray', reverseArrayFilter)
        .filter('formatDate', formatDateFilter)
        .filter('log', logFilter)
        .filter('isEmptyObject', isEmptyObjectFilter)
        .filter('emptyToText', emptyToTextFilter)
        .filter('toMoney', toMoneyFilter)
        .filter('truncate', truncate);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

    function reverseArrayFilter()
    {
      return function(a)
      {
        if(a) {
          if(a.length > 0) {
            return a.slice().reverse();
          } else {
            return a;
          }
        }
      }
    }

    function formatDateFilter()
    {
      return function(dateString, timezone, format)
      {
        if(format === undefined || format === null) {
          format = "MM-DD-YYYY hh:mmA";
        }
        if(dateString && timezone) {
          return moment.utc(dateString).tz(timezone).format(format);
        }

      }
    }

    function logFilter()
    {
      return function(obj)
      {
        console.log(obj);
      }
    }

    function isEmptyObjectFilter() {
      return function(obj) {
        if(Object.keys(obj).length > 0) {
          return true;
        } else {
          return false;
        }

      }
    }

    function emptyToTextFilter()
    {
      return function(val, emptyText)
      {
        if(val === undefined || val === null || val == '') {
          return emptyText;
        }

        return val;
      }
    }

    function toMoneyFilter()
    {
      return function(val)
      {
        if(val != null) {
          val = val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        }

        return val;
      }
    }

    function truncate()
    {
      return function(val, length, textAfter)
      {
        val = val.substring(0, length);
        if(textAfter !== undefined && textAfter !== null) {
          val += textAfter;
        }

        return val;
      }
    }
})();

(function ()
{
  'use strict';

  angular
    .module('app.core')
    .directive('odds', oddsDirective);

  /** @ngInject */
  function oddsDirective()
  {
    return {
      require:'ngModel',
      link:function (scope, elm, attrs, ctrl) {

        var oddsFormat = parseInt(attrs['oddsFormat']) || 0;
        var betType = parseInt(attrs['betType']) || 0;
        //console.log(oddsFormat);
        //console.log(betType);
        //console.log(attrs);

        ctrl.$formatters.unshift(function (price) {
          if(price && betType == 2) {

            price = parseFloat(price);
            if(price > 1) {
              if (oddsFormat == 0) { // odds come in as decimal so convert if american/0
                if (price >= 2) {
                  price = (price - 1) * 100;
                } else {
                  price = -100 / (price - 1);
                }

                price = Math.round(price);
                if (price > 0) {
                  price = price;
                }

                return price;

                //return Math.abs(price);
              } else {
                price = price.toFixed(3);
              }
            } else {
              price = null;
            }
          }
          return price;
        });
      }
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('amchart', amchartDirective);

    /** @ngInject */
    function amchartDirective($q)
    {
        return {
            restrict: 'E',
            scope   : {
              options: '=',
              height: '@',
              width: '@'
            },
            template: '<div class="amchart"></div>',
            link: function ($scope, $el) {
              var id = $el[0].id;// try to use existing outer id to create new id

              if (!id){//generate a UUID
                var guid = function guid() {
                  function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000)
                      .toString(16)
                      .substring(1);
                  }

                  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                    s4() + '-' + s4() + s4() + s4();
                };
                id = guid();
              }

              $el.attr('id', id);
              var chart;

              $q.when($scope.options).then(function(options){
                // we can't render a chart without any data
                var chart;
                if (options.dataProvider) {
                  var renderChart = function (amChartOptions) {
                    var o = amChartOptions || options;

                    // set height and width
                    var height = $scope.height || '100%';
                    var width = $scope.width || '100%';

                    $el.css({
                      'height': height,
                      'width': width
                    });

                    AmCharts.baseHref = true;
                    chart = AmCharts.makeChart(id, o);

                  };

                  renderChart();

                  $scope.$watch('options', function() {
                    //console.log('options changed');
                    chart.clear();
                    renderChart($scope.options);
                  });
                }
              });


            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/quick-panel');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(api)
    {
        var vm = this;



        // Methods

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $mdSidenav, $translate, $mdToast, $window, $state, $cacheFactory, api)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');

        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            }
        };

        vm.oddsFormat = $rootScope.user.oddsFormat;
        vm.oddsFormats = $rootScope.appData.oddsFormats;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.changeOddsFormat = changeOddsFormat;
        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            for(var i=0; i<vm.oddsFormats.length; i++) {
              if($rootScope.user.oddsFormat == vm.oddsFormats[i].id) {

                vm.selectedOddsFormat = vm.oddsFormats[i];
                break;
              }
            }

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Logout Function
         */
        function logout()
        {
            delete $window.sessionStorage.token;
            delete $window.sessionStorage.user;
            var $httpDefaultCache = $cacheFactory.get('$http');
            $httpDefaultCache.removeAll();
            $rootScope.screenerSummary = null;
            $rootScope.user = null;

            $state.go("app.pages_auth_login");
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        function changeOddsFormat(oddsFormat)
        {
          if(vm.selectedOddsFormat.id != oddsFormat.id) {
            vm.selectedOddsFormat = oddsFormat;

            api.user.set_odds_format.get({ id: oddsFormat.id },
              function(response)
              {
                $rootScope.user.oddsFormat = oddsFormat.id;
                // not necessary to display confirmation
              },
              function(response)
              {
                //console.log(response);
              }
            );
          }
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, $timeout)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [
            // analytics
            'angulartics',
            'angulartics.google.analytics',

            // idle logout
            'ngIdle',

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.quick-panel',

            // Pages
            'app.pages',

            //'angular-storage',
            //'angular-jwt',

            // Wolfline
            'app.dashboard',
            'app.research',
            'app.screener',
            'app.papertrade',
            'app.checkout',
            'app.profile',
            'app.orderhistory',
            'app.faq',
            'app.ui'
        ]).config(config);

    function config($httpProvider) {
      $httpProvider.interceptors.push('apiInterceptor');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $window, AppData, Constants, msNavigationService, api)
    {
        // Data
        $rootScope.appData = AppData;
        $rootScope.constants = Constants;
        //////////

        msNavigationService.saveItem('research', {
          title : 'Sports',
          weight: 2,
          icon: 'icon-trending-up'
        });

        for(var i=0;i<AppData.sports.length; i++) {
          var sport = {
            id: AppData.sports[i].id,
            icon: AppData.sports[i].icon,
            name: AppData.sports[i].name
          };

          if(!sport.icon) {
            sport.icon = 'icon-google-earth'; // default icon
          }

          msNavigationService.saveItem('research.' + sport.id, {
            title : sport.name,
            weight: i,
            icon: sport.icon,
            state: 'app.research',
            stateParams: { sport: sport, newScreener: false, home: false }
          });
        }

        $rootScope.$watch('checkoutMenu.visible', function () {

          if($rootScope.checkoutMenu && $rootScope.checkoutMenu.visible) {
            var checkoutMenuSettings = {
              hidden: false
            };

            if($rootScope.checkoutMenu.title) {
              checkoutMenuSettings.title = $rootScope.checkoutMenu.title;
              checkoutMenuSettings.badge = $rootScope.checkoutMenu.badge;
            }

            msNavigationService.saveItem('checkout', checkoutMenuSettings);

            if($rootScope.checkoutMenu.hideAllOthers) {
              msNavigationService.saveItem('home', { hidden: true });
              msNavigationService.saveItem('research', { hidden: true });
              msNavigationService.saveItem('screeners', { hidden: true });
              msNavigationService.saveItem('papertrade', { hidden: true });
              msNavigationService.saveItem('faq', { hidden: true });
            } else {
              msNavigationService.saveItem('home', { hidden: false });
              msNavigationService.saveItem('research', { hidden: false });
              msNavigationService.saveItem('screeners', { hidden: false });
              msNavigationService.saveItem('papertrade', { hidden: false });
              msNavigationService.saveItem('faq', { hidden: false });
            }
          } else {
            msNavigationService.saveItem('home', { hidden: false });
            msNavigationService.saveItem('research', { hidden: false });
            msNavigationService.saveItem('screeners', { hidden: false });
            msNavigationService.saveItem('papertrade', { hidden: false });
            msNavigationService.saveItem('faq', { hidden: false });
            msNavigationService.saveItem('checkout', { hidden: true });
          }
        });



        //$rootScope.screenerSummary = null;
      //console.log('main controller init');
        $rootScope.$watch('screenerSummary', function () {
          if($window.sessionStorage.token && $rootScope.screenerSummary == null) {
            //console.log('getting new screener summary');
            api.screener.summary.get({},
              function (response) {
                //console.log(response);
                $rootScope.screenerSummary = response;
                if(response.totalMatchCount > 0) {
                  msNavigationService.saveItem('screeners', {
                    badge      : {
                      content: response.totalMatchCount,
                      color  : 'red'
                    }
                  });
                } else {
                  msNavigationService.saveItem('screeners', {
                    badge : null
                  });
                }
              },
              function (response) {
                console.log(response);
              }
            );
          }
        });

        msNavigationService.saveItem('faq', {
          title : 'FAQ',
          weight: 6,
          icon: 'icon-question-mark-circle'
        });
        msNavigationService.saveLink('affiliate', {
          title : 'Affiliate',
          weight: 6,
          icon: 'icon-cash'
        }, 'https://affiliate.thewolfline.com');

      // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, uiGmapGoogleMapApiProvider, $translateProvider, $provide, fuseConfigProvider)
    {
        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Enable debug logging
        $logProvider.debugEnabled(true);

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            //    key: 'your api key',
            v        : '3.exp',
            libraries: 'weather,geometry,visualization'
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.quote.iconclass = 'icon-format-quote';

                return taTools;
            }
        ]);

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $window, $location, Idle)
    {
        Idle.watch();

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams)
        {
            $rootScope.loadingProgress = true;

        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {

          $timeout(function ()
          {
              $rootScope.loadingProgress = false;
          });

          //console.log($rootScope.user);

          if($rootScope.user) {
            //if($rootScope.user.subscriptionStatus == 0 || ($rootScope.user.subscriptionStatus == 1 && moment().isBefore($rootScope.user.subscriptionExpirationDate))) {
            // if(moment().isBefore($rootScope.user.subscriptionExpirationDate)) {
            if ($rootScope.user.subscriptionStatus == 0){
              $rootScope.checkoutMenu = {
                visible: false,
                hideAllOthers: false
              };
            } else {
              if (moment().isAfter($rootScope.user.subscriptionExpirationDate)){
                $rootScope.checkoutMenu = {
                  visible: true,
                  hideAllOthers: false
                };
  
                $rootScope.checkoutMenu.visible = true;
                $rootScope.checkoutMenu.hideAllOthers = true;
                $rootScope.checkoutMenu.title = "Continue Membership";
                $rootScope.checkoutMenu.badge = null;
              }
              // console.log($rootScope.user)
              // if($rootScope.user.subscriptionStatus == 3) { // trial

              //   var expirationDate = moment($rootScope.user.subscriptionExpirationDate, 'MM/DD/YYYY');
              //   var daysLeft = expirationDate.diff(moment.utc(), 'days');

              //   $rootScope.checkoutMenu.title = "Extend Trial";
              //   var badgeContent = daysLeft + 1;
              //   if(daysLeft == 1) {
              //     badgeContent += ' day left!';
              //   } else {
              //     badgeContent += ' days left!';
              //   }

              //   $rootScope.checkoutMenu.badge = {
              //     content: badgeContent,
              //     color  : 'red'
              //   };
              //   $rootScope.checkoutMenu.hideAllOthers = true;

              // } else {

              //   $rootScope.checkoutMenu.hideAllOthers = true;
              //   $rootScope.checkoutMenu.title = "Continue Membership";
              //   $rootScope.checkoutMenu.badge = null;
              // }
            }
          }

        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                },
                resolve: {
                  AppData: function (apiResolver)
                  {
                    return apiResolver.resolve('app@get');
                  },
                  Constants: function(apiResolver)
                  {
                    return apiResolver.resolve('app.constants@get');
                  }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, $rootScope, $scope, Idle, $mdDialog, $window, $cacheFactory, $state, $document)
    {
      var vm = this;

      vm.docTitle = $document[0].title;

      // Data
      vm.themes = fuseTheming.themes;
      //////////

      $scope.events = [];


      $scope.$on('IdleStart', function(ev) {
        if($window.sessionStorage.token) {
          // the user appears to have gone idle
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .title('You will be logged out in for inactivity')
              .textContent('Would you like to continue your session?')
              .ariaLabel('Idle')
              .ok('Yes')
              .targetEvent(ev)
          );
        }
      });

      $scope.$on('IdleWarn', function(e, countdown) {
        // follows after the IdleStart event, but includes a countdown until the user is considered timed out
        // the countdown arg is the number of seconds remaining until then.
        // you can change the title or display a warning dialog from here.
        // you can let them resume their session by calling Idle.watch()
        //alert('login timeout');

      });

      $scope.$on('IdleTimeout', function() {
        // the user has timed out (meaning idleDuration + timeout has passed without any activity)
        // this is where you'd log them
        if($window.sessionStorage.token) {
          delete $window.sessionStorage.token;
          delete $window.sessionStorage.user;
          var $httpDefaultCache = $cacheFactory.get('$http');
          $httpDefaultCache.removeAll();
          $rootScope.screenerSummary = null;
          $rootScope.user = null;
          $mdDialog.hide();
          // change title back after countdown
          $document[0].title = vm.docTitle;
          $state.go("app.pages_auth_login");
        }
      });

      $scope.$on('IdleEnd', function() {
        // the user has come back from AFK and is doing stuff. if you are warning them, you can use this to hide the dialog
      });

      $scope.$on('Keepalive', function() {
        // do something to keep the user's session alive
      });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config(IdleProvider, KeepaliveProvider)
    {
      // configure Idle settings
      IdleProvider.idle(900); // in seconds
      IdleProvider.timeout(60); // in seconds
      //KeepaliveProvider.interval(2); // in seconds
    }

})();

(function ()
{
  'use strict';

  angular
    .module('fuse')
    .factory('apiInterceptor', apiInterceptor);

  /** @ngInject */
  function apiInterceptor($rootScope, $q, $window, $location)
  {
    return {
      request: function (config) {
        //console.log(config);
        config.headers = config.headers || {};
        if ($window.sessionStorage.token) {
          config.headers.Authorization = 'Bearer ' + $window.sessionStorage.token;
        }
        return config;
      },
      response: function (response) {
        //console.log(response);
        if (response.status === 401) {
          // @todo setup refresh tokens
          $location.path('/login');

        }
        return response || $q.when(response);
      },
      responseError: function (response) {
        if (response.status === 401) {
          $location.path('/login');
        }
        return $q.reject(response);
      }
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, $rootScope)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allows you to
         * add hardcoded parameters to your API calls that you want them to be sent every
         * time you make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *          list     : $resource('http://api.example.com/blog);
         *          getById  : $resource('http://api.example.com/blog/:id', {id: '@id'});
         *          getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'},
         *              'get': {method: 'GET', params: {getByDate: true}}
         *          );
         *      }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        //$rootScope.apiURL = 'http://api.wolfline.localhost/';
        // $rootScope.apiURL = 'http://localhost:56519/';
         $rootScope.apiURL = 'https://api.thewolfline.com/';
        // $rootScope.apiURL = 'https://stagingapi.thewolfline.com/';

        // Base Url
        api.basePath = 'app/data/'; 

        api.app = $resource($rootScope.apiURL + 'api/app/appdata', null, { get: { cache: true, method: 'GET' } });
        api.app.constants = $resource(api.basePath + 'data.json', null, { get: { cache: true, method: 'GET' } });
        api.research = {
          data: $resource($rootScope.apiURL + 'api/app/researchdata', null, { get: { cache: false, method: 'GET' } }),
          constants: $resource(api.basePath + 'research/data.json', null, { get: { cache: true, method: 'GET' } })
        };

        api.subscription = $resource($rootScope.apiURL + 'api/productsubscriptions', null, { get: { cache: true, method: 'GET' } });
        api.cart = {
          checkout: $resource($rootScope.apiURL + 'api/cart/checkout')
        };

        api.sport = {
          list: $resource($rootScope.apiURL + 'api/sports', null, { query: { cache: true, method: 'GET', isArray: true } }),
          getById  : $resource($rootScope.apiURL + 'api/sports/:id', {id: '@id'}, { get: { cache: true, method: 'GET' } })
        };

        api.user = {
          login: $resource($rootScope.apiURL + 'token', {}, {
            save: {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          }),
          edit: $resource($rootScope.apiURL + 'api/account/edit', {}, {
            update: { method: 'PUT' }
          }),
          editSubscriptionInfo: $resource($rootScope.apiURL + 'api/account/editSubscriptionInfo', {}, {
            update: { method: 'PUT' }
          }),
          editSubscriptionPlan: $resource($rootScope.apiURL + 'api/account/editSubscriptionPlan', {}, {
            update: { method: 'PUT' }
          }),
          profile: $resource($rootScope.apiURL + 'api/account/userinfo'),
          forgot_password: $resource($rootScope.apiURL + 'api/account/forgotpassword'),
          reset_password: $resource($rootScope.apiURL + 'api/account/resetpassword'),
          set_odds_format: $resource($rootScope.apiURL + 'api/account/oddsformat/:id', {id: '@id'}),
          set_alert_frequency: $resource($rootScope.apiURL + 'api/account/alert/frequency/:id', {id: '@id'}),
          credit_card: {
            list: $resource($rootScope.apiURL + 'api/creditcards', null, { query: { cache: true, method: 'GET', isArray: true } }),
            add: $resource($rootScope.apiURL + 'api/creditcards'),
            edit: $resource($rootScope.apiURL + 'api/creditcards/:id', {id: '@id'}, {
              update: { method: 'PUT' }
            }),
            delete: $resource($rootScope.apiURL + 'api/creditcards/:id', {id: '@id'}),
            default: $resource($rootScope.apiURL + 'api/account/defaultcreditcard/:id', {id: '@id'}, {
              update: { method: 'PUT' }
            })
          },
          orders: $resource($rootScope.apiURL + 'api/paymenttransactions', null, { query: { cache: true, method: 'GET', isArray: true } }),
          cancel: $resource($rootScope.apiURL + 'api/account/cancelsubscription'),
          paypalSubscriptionDetails: $resource($rootScope.apiURL + 'api/account/PayPalSubcriptionDetails/:id', {id: '@id'}),
        };

        api.screener = {
          list: $resource($rootScope.apiURL + 'api/screeners', null, { query: { cache: true, method: 'GET', isArray: true } }),
          add: $resource($rootScope.apiURL + 'api/screeners'),
          edit: $resource($rootScope.apiURL + 'api/screeners/:id', {id: '@id'}, {
            update: { method: 'PUT' }
          }),
          partial: $resource($rootScope.apiURL + 'api/screeners/:id', {id: '@id'}, {
            update: {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/json-patch+json'
              }
            }
          }),
          delete: $resource($rootScope.apiURL + 'api/screeners/:id', {id: '@id'}),
          summary: $resource($rootScope.apiURL + 'api/screeners/summary'),
          matches: {
            list: $resource($rootScope.apiURL + 'api/screeners/matches', null, { query: { cache: false, method: 'GET', isArray: true } }),
            getById: $resource($rootScope.apiURL + 'api/screeners/matches/:id', {id: '@id'}, { query: { cache: false, method: 'GET' } }),
            add: $resource($rootScope.apiURL + 'api/screeners/matches'),
            edit: $resource($rootScope.apiURL + 'api/screeners/matches/:id', {id: '@id'}, {
              update: { method: 'PUT' }
            }),
            preview: $resource($rootScope.apiURL + 'api/screeners/matches/preview?page=:page&limit=:limit&search=:search', { page: '@page', limit: '@limit', search: '@search' }),
          }
        };

        api.papertrade = {
          data: $resource($rootScope.apiURL + 'api/app/papertradedata', null, { get: { cache: true, method: 'GET' } }),
          list: $resource($rootScope.apiURL + 'api/papertrades', null, { query: { cache: false, method: 'GET', isArray: true } }),
          range: $resource($rootScope.apiURL + 'api/papertrades/range/:range', { range: '@range'}, { query: { cache: false, method: 'GET', isArray: true } }),
          edit: $resource($rootScope.apiURL + 'api/papertrades/:id', {id: '@id'}, {
            update: { method: 'PUT' }
          }),
          ats: {
            add: $resource($rootScope.apiURL + 'api/papertrades/spread'),
            list: $resource($rootScope.apiURL + 'api/papertrades/spread'),
            edit: $resource($rootScope.apiURL + 'api/papertrades/spread/:id', {id: '@id'}, {
              update: { method: 'PUT' }
            })
          },
          totals: {
            add: $resource($rootScope.apiURL + 'api/papertrades/totals'),
            list: $resource($rootScope.apiURL + 'api/papertrades/totals'),
            edit: $resource($rootScope.apiURL + 'api/papertrades/totals/:id', {id: '@id'}, {
              update: { method: 'PUT' }
            })
          },
          moneyline: {
            add: $resource($rootScope.apiURL + 'api/papertrades/moneyline'),
            list: $resource($rootScope.apiURL + 'api/papertrades/moneyline'),
            edit: $resource($rootScope.apiURL + 'api/papertrades/moneyline/:id', {id: '@id'}, {
              update: { method: 'PUT' }
            })
          }
        };

        return api;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.ui', [
            'app.ui.theme-colors'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        /*msNavigationServiceProvider.saveItem('theme-colors', {
            title: 'Theme Colors',
            icon : 'icon-palette-advanced',
            state: 'app.ui_theme-colors',
            weight: 10
        });*/
    }
})();

(function ()
{
  'use strict';

  angular
    .module('app.faq', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
  {
    // State
    $stateProvider.state('app.faq', {
      url      : '/faq',
      views    : {
        'content@app': {
          templateUrl: 'app/main/faq/faq.html',
          controller : 'FaqController as vm'
        }
      },
      resolve: {
      },
      bodyClass: 'checkout',
      authenticate: true,
      inactiveUserAccessible: true
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/pages/auth/profile');

      msNavigationServiceProvider.saveItem('faq', {
        title : 'FAQ',
        weight: 6,
        icon: 'icon-question-mark-circle',
        state: 'app.faq'
      });

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login',
            'app.pages.auth.forgot-password',
            'app.pages.auth.reset-password',
            'app.pages.error-404',
            'app.pages.error-500',
            'app.pages.maintenance'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {

    }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content>Quick panel content</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex=\"\"></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex=\"\"></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" ui-view=\"navigation\"></div><div id=\"content-container\" flex=\"\" layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll=\"\" ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div class=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" class=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div class=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button><md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button value=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">Wide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\"><md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" ng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" ng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\"></md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/main/checkout/checkout.html","<div id=\"checkout-wrapper\" class=\"page-layout simple\" layout=\"row\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"wl-panel\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 mb-8 border-bottom md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"h3\"><md-icon md-font-icon=\"icon-cart-outline\"></md-icon>{{vm.title}}</div></div></div><div><div ng-if=\"vm.step == 1\" class=\"p-16\" flex=\"\"><div><div class=\"p-16 grey-800-bg white-fg\">Your account <span ng-if=\"!vm.accountPastExpiration\">will expire</span><span ng-if=\"vm.accountPastExpiration\">expired</span> on {{user.subscriptionExpirationDate| date:\'MM/dd/yyyy\'}}</div></div><div layout=\"row\"><div flex=\"\" layout=\"column\"><form name=\"selectedSubscriptionForm\" novalidate=\"\" flex=\"\"><div class=\"subscription-container\"><div layout-align=\"start end\" hide-sm=\"\" hide-xs=\"\"><div class=\"price-tables earlyBird-subscription\"><div class=\"price-table style-3 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">{{vm.earlyBirdSubscription.name}}</div><div ng-if=\"vm.earlyBirdSubscription.shortDescription\" class=\"subtitle\">{{vm.earlyBirdSubscription.shortDescription}}</div></div><div class=\"price md-primary-bg\" layout=\"row\" layout-align=\"center start\"><div class=\"currency md-white-fg\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value md-white-fg\">{{vm.earlyBirdSubscription.price | number: 2}}</div><div class=\"period\" ng-if=\"vm.earlyBirdSubscription.periodInMonths == 1\">per month</div><div class=\"period\" ng-if=\"vm.earlyBirdSubscription.periodInMonths > 1\">for {{vm.montlySubscription.periodInMonths}} months</div></div></div><div ng-if=\"vm.earlyBirdSubscription.description\" ng-bind-html=\"vm.earlyBirdSubscription.description\" class=\"terms\" layout=\"column\"></div><div layout=\"row\" layout-align=\"center start\"><div><input type=\"radio\" id=\"earlyBirdSubscription\" name=\"productSelect\" ng-model=\"vm.selectedSubscriptionID\" ng-value=\"vm.earlyBirdSubscription.id\" required=\"\"> <label for=\"earlyBirdSubscription\" class=\"clickable\"><span class=\"checked-box\">&#10004;</span></label></div></div></div></div></div><div layout-align=\"start end\" hide-sm=\"\" hide-xs=\"\"><div class=\"price-tables monthly-subscription\"><div class=\"price-table style-3 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">{{vm.montlySubscription.name}}</div><div ng-if=\"vm.montlySubscription.shortDescription\" class=\"subtitle\">{{vm.montlySubscription.shortDescription}}</div></div><div class=\"price md-primary-bg\" layout=\"row\" layout-align=\"center start\"><div class=\"currency md-white-fg\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value md-white-fg\">{{vm.montlySubscription.price | number: 2}}</div><div class=\"period\" ng-if=\"vm.montlySubscription.periodInMonths == 1\">per month</div><div class=\"period\" ng-if=\"vm.montlySubscription.periodInMonths > 1\">for {{vm.montlySubscription.periodInMonths}} months</div></div></div><div ng-if=\"vm.montlySubscription.description\" ng-bind-html=\"vm.montlySubscription.description\" class=\"terms\" layout=\"column\"></div><div layout=\"row\" layout-align=\"center start\"><div><input type=\"radio\" id=\"monthlyProduct\" name=\"productSelect\" ng-model=\"vm.selectedSubscriptionID\" ng-value=\"vm.montlySubscription.id\" required=\"\"> <label for=\"monthlyProduct\" class=\"clickable\"><span class=\"checked-box\">&#10004;</span></label></div></div></div></div></div><div layout-align=\"start end\" hide-sm=\"\" hide-xs=\"\"><div class=\"price-tables yearly-subscription\"><div class=\"price-table style-3 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">{{vm.yearlySubscription.name}}</div><div ng-if=\"vm.yearlySubscription.shortDescription\" class=\"subtitle\">{{vm.yearlySubscription.shortDescription}}</div></div><div class=\"price md-primary-bg\" layout=\"row\" layout-align=\"center start\"><div class=\"currency md-white-fg\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value md-white-fg\">{{vm.yearlySubscription.price | number: 2}}</div><div class=\"period\" ng-if=\"vm.yearlySubscription.periodInMonths == 1\">per month</div><div class=\"period\" ng-if=\"vm.yearlySubscription.periodInMonths > 1\">for {{vm.yearlySubscription.periodInMonths}} months</div></div></div><div ng-if=\"vm.yearlySubscription.description\" ng-bind-html=\"vm.yearlySubscription.description\" class=\"terms\" layout=\"column\"></div><div layout=\"row\" layout-align=\"center start\"><div><input type=\"radio\" id=\"yearlyProduct\" name=\"productSelect\" ng-model=\"vm.selectedSubscriptionID\" ng-value=\"vm.yearlySubscription.id\" required=\"\"> <label for=\"yearlyProduct\" class=\"clickable\"><span class=\"checked-box\">&#10004;</span></label></div></div></div></div></div></div></form><md-card hide-gt-sm=\"\"><div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"title h1\">{{vm.earlyBirdSubscription.name}}</div><div ng-if=\"vm.earlyBirdSubscription.shortDescription\" class=\"subtitle secondary-text\">{{vm.earlyBirdSubscription.shortDescription}}</div><div class=\"text pt-16\"><p class=\"md-accent-fg h3\"><b><span>${{vm.earlyBirdSubscription.price | number: 2}}</span> <span ng-if=\"vm.earlyBirdSubscription.periodInMonths == 1\">per month</span><span ng-if=\"vm.earlyBirdSubscription.periodInMonths > 1\">for {{vm.earlyBirdSubscription.periodInMonths}} months</span></b></p><div ng-if=\"vm.earlyBirdSubscription.description\" ng-bind-html=\"vm.earlyBirdSubscription.description\" class=\"terms\"></div><div layout=\"row\" layout-align=\"center start\"><div flex=\"\" layout-align=\"center center\"><input style=\"height:2em; width:500%\" type=\"radio\" id=\"monthlyProduct\" name=\"productSelect\" ng-model=\"vm.selectedSubscriptionID\" ng-value=\"vm.earlyBirdSubscription.id\" required=\"\"></div></div></div></div></div></md-card><md-card hide-gt-sm=\"\"><div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"title h1\">{{vm.montlySubscription.name}}</div><div ng-if=\"vm.montlySubscription.shortDescription\" class=\"subtitle secondary-text\">{{vm.montlySubscription.shortDescription}}</div><div class=\"text pt-16\"><p class=\"md-accent-fg h3\"><b><span>${{vm.montlySubscription.price | number: 2}}</span> <span ng-if=\"vm.montlySubscription.periodInMonths == 1\">per month</span><span ng-if=\"vm.montlySubscription.periodInMonths > 1\">for {{vm.montlySubscription.periodInMonths}} months</span></b></p><div ng-if=\"vm.montlySubscription.description\" ng-bind-html=\"vm.montlySubscription.description\" class=\"terms\"></div><div layout=\"row\" layout-align=\"center start\"><div flex=\"\" layout-align=\"center center\"><input style=\"height:2em; width:500%\" type=\"radio\" id=\"monthlyProduct\" name=\"productSelect\" ng-model=\"vm.selectedSubscriptionID\" ng-value=\"vm.montlySubscription.id\" required=\"\"></div></div></div></div></div></md-card><md-card hide-gt-sm=\"\"><div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"title h1\">{{vm.yearlySubscription.name}}</div><div ng-if=\"vm.yearlySubscription.shortDescription\" class=\"subtitle secondary-text\">{{vm.yearlySubscription.shortDescription}}</div><div class=\"text pt-16\"><p class=\"md-accent-fg h3\"><b><span>${{vm.yearlySubscription.price | number: 2}}</span> <span ng-if=\"vm.yearlySubscription.periodInMonths == 1\">per month</span><span ng-if=\"vm.yearlySubscription.periodInMonths > 1\">for {{vm.yearlySubscription.periodInMonths}} months</span></b></p><div ng-if=\"vm.yearlySubscription.description\" ng-bind-html=\"vm.yearlySubscription.description\" class=\"terms\"></div><div layout=\"row\" layout-align=\"center start\"><div flex=\"\" layout-align=\"center center\"><input style=\"height:2em; width:500%\" type=\"radio\" id=\"yearlyProduct\" name=\"productSelect\" ng-model=\"vm.selectedSubscriptionID\" ng-value=\"vm.yearlySubscription.id\" required=\"\"></div></div></div></div></div></md-card><div class=\"checkout-button-container\"><form name=\"existingCreditCardForm\" novalidate=\"\"><div><md-button type=\"submit\" ng-click=\"vm.reviewCheckout();\" class=\"send-button md-accent md-raised\" ng-disabled=\"vm.selectedSubscriptionID == null;\" aria-label=\"Checkout\">Checkout</md-button></div></form></div></div></div></div><div ng-if=\"vm.step == 2\" class=\"p-16\" flex=\"\"><div layout-gt-sm=\"row\"><div layout-gt-sm=\"column\" flex=\"\"><table class=\"simple\"><thead><th>Product</th><th>Description</th><th>Price</th></thead><tbody><tr ng-repeat=\"item in vm.cart.items\"><td>{{item.name}}</td><td>{{item.shortDescription}}</td><td>${{item.price | number: 2}}</td></tr><tr><td></td><td class=\"text-right\">Tax</td><td>${{vm.cart.tax | number: 2}}</td></tr><tr><td></td><td class=\"text-right\"><b>Total</b></td><td><b>${{vm.cart.total | number: 2}}</b></td></tr></tbody></table></div></div><script>\r\n              const paypalButtonsComponent = paypal.Buttons({\r\n                  // optional styling for buttons\r\n                  // https://developer.paypal.com/docs/checkout/standard/customize/buttons-style-guide/\r\n                  style: {\r\n                      height: 40,\r\n                      shape: \'rect\',\r\n                      color: \'blue\',\r\n                      layout: \'vertical\',\r\n                      label: \'paypal\'\r\n                  },\r\n      \r\n                  // revise subscription\r\n                  // createSubscription: (data, actions) => {\r\n                  //     // console.log(sessionStorage.user[\'paypalSubscriptionID\'])\r\n                  //     var user = JSON.parse(sessionStorage.user)\r\n                  //     var paypalSubscriptionID = user.paypalSubscriptionID;\r\n                  //     console.log(user)\r\n                  //     console.log(paypalSubscriptionID)\r\n                  //     // replace with your subscription plan id\r\n                  //     // https://developer.paypal.com/docs/subscriptions/#link-createplan\r\n                  //     return actions.subscription.revise(paypalSubscriptionID, {\r\n                  //       plan_id: \'P-1WE635011X7362124MLRTOQI\'\r\n                  //     });\r\n                  // },\r\n                  createSubscription: function (data, actions) {\r\n                        var selectedSubscription = JSON.parse(sessionStorage.selectedSubscription)\r\n                        var scope = $(\'#paypal-button-container\').scope();\r\n                        return actions.subscription.create({\r\n                            /* Creates the subscription */\r\n                            plan_id: selectedSubscription.payPalPlanID\r\n                        });\r\n                    },\r\n      \r\n                  // notify the buyer that the subscription is successful\r\n                  onApprove: (data, actions) => {\r\n                      var scope = $(\'#paypal-button-container\').scope();\r\n                      scope.checkoutRedirect(data.subscriptionID)\r\n                      console.log(\'You have successfully created subscription\');\r\n                  },\r\n      \r\n                  // handle unrecoverable errors\r\n                  onError: (err) => {\r\n                      console.error(\'An error prevented the buyer from checking out with PayPal\');\r\n                  }\r\n              });\r\n      \r\n              paypalButtonsComponent\r\n                  .render(\"#paypal-button-container\")\r\n                  .catch((err) => {\r\n                      console.error(\'PayPal Buttons failed to render\');\r\n                  });\r\n            </script><div class=\"paypal-button-container\"><div id=\"paypal-button-container\"></div></div><div class=\"navigation-buttons\" layout=\"row\" layout-align=\"left left\" flex=\"\"><md-button ng-click=\"vm.previousStep()\" class=\"md-accent md-raised\" aria-label=\"Back\" ng-disabled=\"vm.submitting\">Back</md-button></div></div><div ng-if=\"vm.step == 3\" class=\"p-16\" flex=\"\"><p>Thank you for your payment!</p><p><md-button type=\"submit\" ui-sref=\"app.research({ home: true })\" class=\"md-accent md-raised\" aria-label=\"Get Started\">Get Started</md-button></p></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"content\">Dashboard</div></div></div>");
$templateCache.put("app/main/orderhistory/orderhistory.html","<div id=\"order-history-wrapper\" class=\"page-layout simple\" layout=\"row\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"wl-panel\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 mb-8 border-bottom md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"h3\"><md-icon md-font-icon=\"icon-timer\"></md-icon>{{vm.title}}</div></div></div><div><div class=\"p-16\" flex=\"\"><table hide-sm=\"\" hide-xs=\"\" ng-if=\"vm.orders.length > 0\" class=\"simple\"><thead><th>Order Number</th><th>Credit Card</th><th>Item</th><th>Total Amount</th><th>Date</th></thead><tbody><tr ng-repeat=\"order in vm.orders\"><td>{{order.authorizeNetID}}</td><td>{{order.creditCard.description}}<br>XXXX-{{order.creditCard.lastFour}}<br>Exp. {{order.creditCard.expirationMonth}}/{{order.creditCard.expirationYear}}</td><td>{{order.productSubscription.name}}</td><td>${{order.totalAmount.toFixed(2)}}</td><td>{{order.created|formatDate: user.timezone}}</td></tr></tbody></table><md-list hide-gt-sm=\"\" flex=\"\"><md-list-item class=\"md-3-line\" ng-repeat=\"order in vm.orders\"><div class=\"md-list-item-text p-16\" layout=\"column\"><h3>{{order.productSubscription.name}}</h3><h4>Order #: {{order.authorizeNetID}}</h4><p>{{order.creditCard.description}} (XXXX-{{order.creditCard.lastFour}})<br>Exp. {{order.creditCard.expirationMonth}}/{{order.creditCard.expirationYear}}<br><b>Total:</b> ${{order.totalAmount.toFixed(2)}}<br><b>Date:</b> {{order.created|formatDate: user.timezone}}</p></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list><div ng-if=\"vm.orders.length == 0\">No Orders Found</div></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/faq/faq.html","<div id=\"faq-wrapper\" class=\"page-layout simple\" layout=\"row\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"wl-panel\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 mb-8 border-bottom md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"h3\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon>{{vm.title}}</div></div></div><div><div class=\"p-16 flex\"><div class=\"flex\"><div layout=\"row\"><div><span class=\"numbered-circle\">1</span></div><div><h3 class=\"title\">Which is better, \"momentum\" or \"correction\"?</h3><p>One is not necessarily better than the other. Different situations call for different styles. A correction trade is a trading method of buying low and selling high. A momentum trade is a trading method of buying high and selling low.</p><p>Some examples of less liquid markets/sectors/leagues that tend to trade with momentum longer term and correct later are NHL, MLB, smaller CBB conference totals/volatility, Nippon Baseball League. While some examples of markets/sectors/leagues that tend to trade with momentum shorter term and correct sooner are NFL, CFB, NBA, larger CBB conferences and believe it or not, WNBA. This is consistent with any other form of quantitative financial market trading. Different sectors/asset classes have different volatilities and must be artistically traded accordingly</p></div></div><div layout=\"row\"><div><span class=\"numbered-circle\">2</span></div><div><h3 class=\"title\">Are the colors more important or the time it shows indicators?</h3><p>All sports betting markets are short term irrational and long term rational. Colored Alerts in the short term are not as significant as they are in the longer term (farther back in time or to the right). The hotter the color the more significant, the further back in time the more significant, the significance is the probability of mispricing. The number of alerts also makes a difference.</p></div></div><div layout=\"row\"><div><span class=\"numbered-circle\">3</span></div><div><h3 class=\"title\">Why are moneylines alerted so often?</h3><p>Because the Moneyline products only represent straight up wins/losses of the two halves of the relationship that have had moneyline markets made on them historically. This is a \"probability bet\" just like \"In the money\" or \"out of the money\" options. ML is not a 50/50 market minus the \"juice\" like the binary markets are (\"spread\" and \"totals\"). The market irrationality has to go somewhere. In moneyline, that irrationality probability occurs in the market probability and NOT in the market \"barrier numbers\"/\"strike price\"</p></div></div><div layout=\"row\"><div><span class=\"numbered-circle\">4</span></div><div><h3 class=\"title\">Why are moneylines different?</h3><p>TheWolfLine moneyline indicators and alerts quantify and represent in a graduated color format of extremes the probability of irrationality of the market price in the probability of the particular relationship being skewed based on if the same exact fundamental \"game\" were to be played an infinite number of times. Thus representing theoretical market edge. TWL can never endorse using technical drawings (eg support and resistance) in ML, puckline, runline, etc BUT if that works for you, then do it.</p></div></div><div layout=\"row\"><div><span class=\"numbered-circle\">5</span></div><div><h3 class=\"title\">Do the markets work the same for all sports?</h3><p>No, each market works a bit differently and each sport/league trades differently, just like each sector in finance has it\'s own nuance.<br><strong>More Liquid Markets:</strong> Markets/sports that typically gather more volume/handle thereby having a TENDENCY for the relationships to correct earlier and trade in a narrower/less volatile range (eg utility stock sector/NFL spread).<br><strong>Less Liquid Markets:</strong> Markets/sports that typically gather less volume/handle thereby having a TENDENCY for the relationships to correct later and trade in a wider/more volatile range (eg small cap biotech stock sector/MLB totals).</p><p>A potential “shortcut” to determine the tendency for a sport/league/sector to be “more liquid” or “less liquid” is to check the television ratings. When television ratings are higher, then the sector/league will tend to behave as “more liquid”. When television ratings are lower, then the sector/league will tend to behave as “less liquid”.</p></div></div><div layout=\"row\"><div><span class=\"numbered-circle\">6</span></div><div><h3 class=\"title\">What is Wolfline and how does it help with sports betting?</h3><p>At TheWolfLine.com, we use our patented technology to supply proprietary market analysis to trade sports markets like a Wall Street Pro! TheWolfLine.com can teach you to trade sports just like professional traders and hedge fund managers trade stocks, options, and futures!</p></div></div><div layout=\"row\"><div><span class=\"numbered-circle\">7</span></div><div><h3 class=\"title\">Do you offer picks?</h3><p>No, The Wolfline does not offer picks. We provide quantitative and technical analysis tools for our users to \"be your own expert.\" All of the Wolfline data is completely objective with no subjectivity whatsoever, eg Power Rankings.</p></div></div><div layout=\"row\"><div><span class=\"numbered-circle\">8</span></div><div><h3 class=\"title\">Should I bet the red alerts?</h3><p>TheWolfLine users “bet” whatever they are comfortable with based on their personal risk tolerance and confidence interval. A \"red alert\" simply represents extreme probability of market irrationality in the study period. Nothing else. Significance of alerts strengthen when:<ol><li>Alerts are hotter.</li><li>Higher Number of Alerts.</li><li>Alerts are further to the right of the grid.</li></ol></p></div></div><div layout=\"row\"><div><span class=\"numbered-circle\">9</span></div><div><h3 class=\"title\">Why is there only one line on the totals chart?</h3><p>TheWolfLine quantitatively measures the probability of irrational market skew over time. That answers the question \"how do I tell what is irrationally cheap to be bought or irrationally expensive to be sold\". \"Totals\"/volatility are an aggregated measure of the relationship and that is represented as a divergence from zero over time. \"Totals\" does not care about the price or probability of the relationship, only the amount of scoring relative to market implied expected amount of scoring. Same as buying/selling volatility in options markets. Supply and demand.</p><p>Totals charts are a combined performance for both teams in the selected time frame (periods/games back). If both teams go over in a game there is an uptick of 2, both under downtick of 2, sideways ticks one over, one under or both push, like a market being unchanged.</p></div></div><div layout=\"row\"><div><span class=\"numbered-circle\">10</span></div><div><h3 class=\"title\">Are there a minimum number of Support or Resistance points that you like to see to dig deeper into a given matchup?</h3><p>No, The bigger point here is the further back in time the support or resistance is, the more significant. The levels of significance for price action and volatility action represent inflection points where market perception of price/volatility became too high/low relative to value and subsequent realized price/volatility. Support and resistance can occur at straight horizontal levels or along trendlines. Levels become more significant the more times they are touched (tested), when periods between the touching (testing) of the level is longer and when the level is higher on the y axis for resistance or lower on the y axis for support. The charts are the quantified and graphically displayed history of the collective behavioral economics of the market regarding the asset(s) of the relationship in question.</p></div></div><div layout=\"row\"><div><span class=\"numbered-circle\">11</span></div><div><h3 class=\"title\">How do the alerts work and what does it mean?</h3><p>TheWolfLine indicators are calculated by historical closing market prices relative to realized prices/performance over time. These indicators are put into a bivariate/joint probability distribution over time. The indicators are assigned to alert colors that represent standard deviations into the self evident accepted color graduation of levels of extremity. In absolute values, Gray = 0.00-0.79, yellow = 0.80-1.19, orange = 1.20-1.59 and red = 1.60-2.00. The indicators can never be higher than 2.00 (absolute value) regardless of sample study size. The max study period of 24 periods was determined by years of research and development/data collection that proved that the finite stanzas of study period end at that point and then the serial behavior of the market \"starts over.\" So somewhere between 6 gray boxes and 6 red boxes, in the default grids, the \"moneyball moment\" is identified. This is the subjective \"art\" of TWL interpretation and practical application by the user.</p></div></div><div layout=\"row\"><div><span class=\"numbered-circle\">12</span></div><div><h3 class=\"title\">Do you use alerts, or a number of other indicators when considering making a bet?</h3><p>There are no set rules, each bettor will have his or her own criteria and trading method. One may find a stronger level of confidence with multiple factors such as a particular alert pattern, indicators, or support/resistance levels.</p></div></div><div layout=\"row\"><div><span class=\"numbered-circle\">13</span></div><div><h3 class=\"title\">What is the minimum divergence, between two teams that would have you consider a possible bet?</h3><p>While the smaller the divergence (difference in performance on charts) the smaller the indicator will be with alerts starting at .80. There may be other factors such as support and/or resistance that would indicate a possible play.</p></div></div><div layout=\"row\"><div><span class=\"numbered-circle\">14</span></div><div><h3 class=\"title\">What if the line moves, should I cancel my bet? Meaning...if I was +4 and now it\'s only +3.5 or +3, is it still ok to bet?</h3><p>We would encourage all users to shop for their best execution price. Just because the execution price may move, doesn\'t mean the price you purchased won\'t still win. Keep in mind all TheWolfLine data is pegged off of the historical realized prices relative to the historical market implied closing prices.</p></div></div></div></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/papertrade/papertrades.html","<div id=\"papertrades-wrapper\" class=\"page-layout simple\" layout=\"row\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"wl-panel\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget-front><div class=\"white-bg\"><div class=\"p-16 mb-8 border-bottom md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"h3\"><md-icon md-font-icon=\"icon-note-outline\"></md-icon>{{vm.title}}</div></div></div><div><div class=\"p-16\" flex=\"\"><div flex=\"\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Net Profit/Loss</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.criteria.range\" ng-model-options=\"{trackBy: \'$value.key\'}\" aria-label=\"Change range\"><md-option ng-repeat=\"range in vm.reportRanges\" ng-value=\"range\" ng-click=\"vm.getPaperTradesByRange(range)\">{{range.name}}</md-option></md-select></div></div><div class=\"p-8\" layout=\"column\" layout-gt-xs=\"row\"><div class=\"p-8\"><div class=\"h4 secondary-text\">Volume</div><div class=\"pt-8 h3 font-weight-300\" ng-if=\"vm.tradeTotals.volume != null\"><span>{{ vm.tradeTotals.volume|toMoney }} <span class=\"wolfbucks-tm\">WolfBucks<sup>TM</sup></span></span></div></div><div class=\"p-8\"><div class=\"h4 secondary-text\">Profit/Loss Balance</div><div ng-if=\"vm.tradeTotals.earned != null\" class=\"pt-8 h3 font-weight-300\"><span ng-if=\"vm.tradeTotals.earned == 0\">{{ vm.tradeTotals.earned|toMoney }} <span class=\"wolfbucks-tm\">WolfBucks<sup>TM</sup></span></span> <span ng-if=\"vm.tradeTotals.earned > 0\" class=\"green-fg\">{{ vm.tradeTotals.earned|toMoney }} <span class=\"wolfbucks-tm\">WolfBucks<sup>TM</sup></span></span> <span ng-if=\"vm.tradeTotals.earned < 0\" class=\"red-fg\">{{ vm.tradeTotals.earned|toMoney }} <span class=\"wolfbucks-tm\">WolfBucks<sup>TM</sup></span></span></div></div><div class=\"p-8\" layout=\"column\" layout-align=\"center end\" layout-align-xs=\"center center\" flex=\"\"><md-button ng-click=\"vm.refreshPaperTrades()\" aria-label=\"Refresh\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>Refresh Paper Trades</md-button></div></div></div><div ng-if=\"vm.loadingPaperTrades\" layout=\"row\" layout-align=\"center start\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><h3>Loading...please wait</h3></div><p ng-if=\"vm.papertrades.length == 0 && !vm.loadingPaperTrades\">Sorry, no paper trades were found.</p><div id=\"papertrades-list\" ng-if=\"vm.papertrades.length > 0 && !vm.loadingPaperTrades\" flex=\"\"><md-content ng-include=\"\'app/main/papertrade/includes/paginator.html\'\"></md-content><md-list hide-gt-xs=\"\" flex=\"\"><md-list-item ng-repeat=\"pt in vm.papertrades\" class=\"md-3-line\" show-xs=\"\"><div class=\"md-list-item-text\" layout=\"column\"><div class=\"mt-16\"><p>Match Date: {{ pt.match.matchDate|formatDate: user.timezone}}</p></div><p ng-if=\"pt.match.matchStatus == 1\"><span ng-if=\"pt.tradeResult > 0\" class=\"text-boxed green-bg white-fg\">Won {{pt.tradeResult|toMoney }} WolfBucks<sup>TM</sup></span> <span ng-if=\"pt.tradeResult == 0\" class=\"text-boxed grey-bg white-fg\">{{pt.tradeResult|toMoney}} WolfBucks<sup>TM</sup></span> <span ng-if=\"pt.tradeResult < 0\" class=\"text-boxed red-bg white-fg\">Lost {{pt.wagerAmount|toMoney }} WolfBucks<sup>TM</sup></span></p><p ng-if=\"pt.match.matchStatus != 1\">{{ pt.wagerAmount|toMoney }} WolfBucks<sup>TM</sup></p><p ng-if=\"pt.match.matchStatus > 1\" class=\"mt-8\"><span class=\"text-boxed grey-bg white-fg\">{{vm.getMatchStatusById(pt.match.matchStatus).label}}</span></p><div ng-if=\"pt.match.finalScore\" class=\"mt-16\"><span class=\"team-indicator\">A</span> <span ng-class=\"{ \'text-bold\': pt.match.finalScore.awayValue > pt.match.finalScore.homeValue}\">({{ pt.match.finalScore.awayValue }}) {{ pt.match.awayCompetitor.name }}</span><br><span class=\"team-indicator\">H</span> <span ng-class=\"{ \'text-bold\': pt.match.finalScore.homeValue > pt.match.finalScore.awayValue}\">({{ pt.match.finalScore.homeValue }}) {{ pt.match.homeCompetitor.name }}</span></div><div class=\"mt-16\" ng-if=\"!pt.match.finalScore\"><span class=\"team-indicator\">A</span> {{ pt.match.awayCompetitor.name }}<br><span class=\"team-indicator\">H</span> {{ pt.match.homeCompetitor.name }}</div><p><span ng-if=\"pt.oddsType.id == 0\">{{pt.oddsType.name}}: {{pt.trade.team.name}} <span ng-if=\"pt.trade.team.favorite\"><span ng-if=\"pt.odds.marketPrice != 0\">-</span>{{pt.odds.marketPrice}}</span> <span ng-if=\"!pt.trade.team.favorite\"><span ng-if=\"pt.odds.marketPrice != 0\">+</span>{{pt.odds.marketPrice}}</span> <span ng-if=\"pt.trade.juice > 1\">({{pt.trade.juice|formatOdds:user.oddsFormat}})</span></span> <span ng-if=\"pt.oddsType.id == 1\">{{pt.oddsType.name}}: <span ng-if=\"pt.wagerType.id == 0\">Over {{pt.odds.marketPrice}} ({{pt.odds.overJuicePrice|formatOdds:user.oddsFormat}})</span> <span ng-if=\"pt.wagerType.id == 1\">Under {{pt.odds.marketPrice}} ({{pt.odds.underJuicePrice|formatOdds:user.oddsFormat}})</span></span> <span ng-if=\"pt.oddsType.id == 2\">{{pt.oddsType.name}}: (<span ng-if=\"pt.wagerType.id == 0\">{{pt.odds.homeMarketPrice|formatOdds:user.oddsFormat}}</span><span ng-if=\"pt.wagerType.id == 1\">{{pt.odds.awayMarketPrice|formatOdds:user.oddsFormat}}</span>)<br><span ng-if=\"pt.wagerType.id == 0\">{{ pt.match.homeCompetitor.name }} to win</span> <span ng-if=\"pt.wagerType.id == 1\">{{ pt.match.awayCompetitor.name }} to win</span></span></p><md-content ng-include=\"\'app/main/papertrade/includes/wolflineData.html\'\"></md-content></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list><table class=\"simple paper-trade-table striped\" hide-xs=\"\"><thead><tr><th>Match Date</th><th>Trade Amount</th><th>Competitors</th><th>Trade Type</th><th class=\"text-center\">Trade</th></tr></thead><tbody><tr ng-repeat-start=\"pt in vm.papertrades\"><td>{{ pt.match.matchDate|formatDate: user.timezone}}</td><td><span ng-if=\"pt.match.matchStatus != 1\">{{ pt.wagerAmount|toMoney }} WolfBucks<sup>TM</sup></span> <span ng-if=\"pt.match.matchStatus == 1\"><span ng-if=\"pt.tradeResult > 0\" class=\"text-boxed green-bg white-fg\">Won {{pt.tradeResult|toMoney}} WolfBucks<sup>TM</sup></span> <span ng-if=\"pt.tradeResult == 0\" class=\"text-boxed grey-bg white-fg\">{{pt.tradeResult|toMoney}} WolfBucks<sup>TM</sup></span> <span ng-if=\"pt.tradeResult < 0\" class=\"text-boxed red-bg white-fg\">Lost {{pt.wagerAmount|toMoney}} WolfBucks<sup>TM</sup></span></span><p ng-if=\"pt.match.matchStatus > 1\" class=\"mt-8\"><span class=\"text-boxed grey-bg white-fg\">{{vm.getMatchStatusById(pt.match.matchStatus).label}}</span></p></td><td><span ng-if=\"pt.match.finalScore\"><span class=\"team-indicator\">A</span> <span ng-class=\"{ \'text-bold\': pt.match.finalScore.awayValue > pt.match.finalScore.homeValue}\">({{ pt.match.finalScore.awayValue }}) {{ pt.match.awayCompetitor.name }}</span><br><span class=\"team-indicator\">H</span> <span ng-class=\"{ \'text-bold\': pt.match.finalScore.homeValue > pt.match.finalScore.awayValue}\">({{ pt.match.finalScore.homeValue }}) {{ pt.match.homeCompetitor.name }}</span></span> <span ng-if=\"!pt.match.finalScore\"><span class=\"team-indicator\">A</span> {{ pt.match.awayCompetitor.name }}<br><span class=\"team-indicator\">H</span> {{ pt.match.homeCompetitor.name }}</span></td><td>{{pt.oddsType.name}}</td><td class=\"text-center\"><span ng-if=\"pt.oddsType.id == 0\">{{pt.trade.team.name}}<br><span ng-if=\"pt.trade.team.favorite\"><span ng-if=\"pt.odds.marketPrice != 0\">-</span>{{pt.odds.marketPrice}}</span> <span ng-if=\"!pt.trade.team.favorite\"><span ng-if=\"pt.odds.marketPrice != 0\">+</span>{{pt.odds.marketPrice}}</span> <span ng-if=\"pt.trade.juice > 1\">({{pt.trade.juice|formatOdds:user.oddsFormat}})</span></span> <span ng-if=\"pt.oddsType.id == 1\"><span ng-if=\"pt.wagerType.id == 0\">Over {{pt.odds.marketPrice}}<br>{{pt.odds.overJuicePrice|formatOdds:user.oddsFormat}}</span> <span ng-if=\"pt.wagerType.id == 1\">Under {{pt.odds.marketPrice}}<br>{{pt.odds.underJuicePrice|formatOdds:user.oddsFormat}}</span></span> <span ng-if=\"pt.oddsType.id == 2\"><span ng-if=\"pt.wagerType.id == 0\">{{ pt.match.homeCompetitor.name }}<br>{{pt.odds.homeMarketPrice|formatOdds:user.oddsFormat}}</span> <span ng-if=\"pt.wagerType.id == 1\">{{ pt.match.awayCompetitor.name }}<br>{{pt.odds.awayMarketPrice|formatOdds:user.oddsFormat}}</span></span></td></tr><tr ng-repeat-end=\"\"><td colspan=\"6\"><md-content ng-include=\"\'app/main/papertrade/includes/wolflineData.html\'\"></md-content></td></tr></tbody></table><md-content ng-include=\"\'app/main/papertrade/includes/paginator.html\'\"></md-content></div></div></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/profile/profile.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\"><div class=\"user-info\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img class=\"profile-image avatar huge\" src=\"assets/images/avatars/profile.jpg\"><h3 class=\"name white-fg\">{{ vm.user.firstName }} {{ vm.user.lastName }}</h3></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>{{ vm.title }}</span></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div layout-gt-sm=\"row\"><div layout-gt-sm=\"column\" layout=\"row\" flex-gt-sm=\"50\" flex=\"\"><div class=\"p-16\" flex=\"\"><form name=\"profileForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><label>First Name</label> <input name=\"firstName\" ng-model=\"vm.profileForm.firstName\" required=\"\"><div ng-messages=\"profileForm.firstName.$error\" ng-show=\"profileForm.firstName.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><label>Last Name</label> <input name=\"lastName\" ng-model=\"vm.profileForm.lastName\" required=\"\"><div ng-messages=\"profileForm.lastName.$error\" ng-show=\"profileForm.lastName.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><label>Email</label> <input name=\"email\" ng-model=\"vm.profileForm.email\" disabled=\"\" required=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><label>Phone</label> <input ng-model=\"vm.profileForm.phonenumber\"></md-input-container><md-input-container class=\"md-block md-select-block\" md-no-float=\"\" flex=\"\"><label>Timezone</label><md-select ng-model=\"vm.profileForm.timezone\" ng-model-options=\"{trackBy: \'$value.zoneId\'}\" required=\"\"><md-option ng-repeat=\"t in vm.timezones\" ng-value=\"t\">{{t.countryName}}<span ng-if=\"t.comment != \'\'\">/{{t.comment}}</span></md-option></md-select><div ng-messages=\"profileForm.timezone.$error\" ng-show=\"profileForm.timezone.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div></div></md-input-container><md-input-container class=\"md-block md-select-block\" md-no-float=\"\" flex=\"\"><label>Email Alert Frequency</label><md-select ng-model=\"vm.profileForm.alertFrequency\" ng-model-options=\"{trackBy: \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"f in appData.alertFrequencies\" ng-value=\"f\">{{f.label}}</md-option></md-select><div ng-messages=\"profileForm.alertFrequency.$error\" ng-show=\"profileForm.alertFrequency.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"oldPassword\" ng-model=\"vm.profileForm.oldPassword\" placeholder=\"Current Password\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.profileForm.newPassword\" placeholder=\"New Password\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.profileForm.passwordConfirm\" placeholder=\"New Password (Confirm)\" match=\"{{vm.profileForm.newPassword}}\"><div ng-messages=\"profileForm.passwordConfirm.$error\" ng-show=\"profileForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"match\">Password do not match</div></div></md-input-container><md-button type=\"submit\" ng-click=\"vm.saveProfile()\" class=\"save-button md-accent md-raised\" ng-disabled=\"profileForm.$invalid\" aria-label=\"SAVE\">SAVE</md-button></form></div></div><div layout-gt-sm=\"column\" layout=\"row\" flex-gt-sm=\"50\" flex=\"\"><div id=\"credit-cards\" flex=\"\"><md-content ng-if=\"vm.userProductInfo.productSubscriptionID == \'\'\" class=\"text-center\"><h2>No PayPal Subscription Found</h2></md-content><div ng-if=\"vm.userProductInfo.productSubscriptionID == \'\'\" class=\"red-50-fg red-500-bg p-16 ml-10 mr-10 mb-24\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert\" class=\"red-50-fg mr-16\"></md-icon><p>You don\'t have a PayPal Subscription. Please purchase a new subscriotion below by clicking &quot;Checkout&quot;.</p></div><ms-widget flippable=\"false\" layout=\"row\" flex-sm=\"50\" flex=\"\"><ms-widget-front ng-if=\"!vm.userProductInfo.productSubscriptionID == \'\'\" class=\"white-bg\"><div class=\"ph-16 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><h3>Current Subscription: {{vm.userProductInfo.productName}}</h3></div><div class=\"p-16\" layout=\"row\">{{vm.userProductInfo.firstName}} {{vm.userProductInfo.lastName}}<br>{{vm.userProductInfo.productSubscriptionID}}</div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"h4 secondary-text text-truncate\">Exp:</span> <span class=\"h4 ml-8\">{{vm.userProductInfo.subscriptionExpirationDate | date:\'MM/dd/yyyy\'}}</span></div></div></ms-widget-front></ms-widget><div layout=\"row\" class=\"ml-16\"><md-button ng-if=\"vm.userProductInfo.productSubscriptionID == \'\'\" ng-click=\"vm.checkout()\" class=\"md-raised md-accent\" aria-label=\"Checkout\">Checkout</md-button></div><div ng-if=\"$root.user.subscriptionStatus != 1\" class=\"p-16 grey-50-bg mt-16\"><md-button ng-click=\"vm.cancelAccount($event)\" class=\"md-raised md-warn\" aria-label=\"Cancel Account\">Cancel Account</md-button></div><div ng-if=\"$root.user.subscriptionStatus == 1\" class=\"p-16 grey-50-bg mt-16\"><h3><b>Your account is set to expire on {{$root.user.subscriptionExpirationDate}}.</b></h3><md-button ui-sref=\"app.checkout\" class=\"md-raised md-warn\" aria-label=\"Re-Enable Account\">Re-enable Account</md-button></div></div></div></div></md-content></div></div></div>");
$templateCache.put("app/main/research/research.html","<div id=\"research\" class=\"page-layout simple\" layout=\"row\"><div class=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"content\"><ms-widget id=\"screener-config\" ng-if=\"!researchSettings.wizard.enabled\" class=\"wl-panel\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 mb-8 border-bottom md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\"><md-icon md-font-icon=\"icon-compass-outline\"></md-icon>{{vm.constants.welcome.title}}</div></div><div class=\"wl-panel-content\"><div class=\"text-center\"><h2>{{vm.constants.welcome.subTitle}}</h2><h3>{{vm.constants.welcome.content}}</h3></div><div class=\"action-buttons\" layout=\"row\" layout-align=\"center center\" flex=\"\"><md-button ng-if=\"!vm.home\" class=\"md-raised md-primary\" ng-click=\"vm.startNewScreenerWizard()\">{{vm.constants.screener.newButtonTitle}}</md-button><md-button ng-if=\"vm.home\" class=\"md-raised md-primary\" ui-sref=\"app.research({newScreener: true, home: false})\">{{vm.constants.screener.newButtonTitle}}</md-button><md-button ng-if=\"vm.screeners.length > 0\" class=\"md-raised md-primary\" ui-sref=\"app.screener()\">{{vm.constants.screener.existingButtonTitle}}</md-button></div></div></ms-widget-front></ms-widget><ms-widget ng-if=\"researchSettings.wizard.enabled\" class=\"wl-panel\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 mb-8 border-bottom md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\"><span ng-if=\"!researchSettings.name\"><md-icon md-font-icon=\"icon-binoculars\"></md-icon>{{vm.constants.screener.newButtonTitle}}</span> <span ng-if=\"researchSettings.name\"><md-button ng-click=\"vm.openScreenerDialog($event, screener)\" class=\"md-icon-button\" aria-label=\"Edit Screener\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.editScreenerName}}</md-tooltip></md-button><md-button ng-if=\"researchSettings.description\" class=\"md-icon-button\" aria-label=\"Description\" ng-click=\"vm.openDialog($event, researchSettings.name, researchSettings.description)\"><md-icon md-font-icon=\"icon-information\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{researchSettings.description}}</md-tooltip></md-button><span hide-xs=\"\">{{researchSettings.name}}</span> <span hide-gt-xs=\"\">{{researchSettings.name|truncate:15:\'...\'}}</span></span></div><div layout=\"row\" layout-align=\"start center\"><md-button ng-if=\"upcomingMatches.screener.id\" ng-click=\"vm.togglePanelContent($event)\" class=\"md-icon-button\" aria-label=\"Toggle Visibility\"><md-icon md-font-icon=\"icon-minus\" class=\"show-expanded\"></md-icon><md-icon md-font-icon=\"icon-plus\" class=\"show-collapsed\"></md-icon></md-button><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button aria-label=\"New Screener\" ng-click=\"vm.exitScreenerWizard($event, vm.startNewScreenerWizard)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{vm.constants.screener.newButtonTitle}}</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Existing Screener\" ng-click=\"vm.exitScreenerWizard($event, vm.gotoScreeners)\"><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon>{{vm.constants.screener.existingButtonTitle}}</md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"vm.exitScreenerWizard($event, vm.goHome)\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.exitScreener}}</md-tooltip></md-button></div></div><div class=\"wl-panel-content\"><div ng-if=\"!researchSettings.wizard.editMode\" flex=\"\"><md-content ng-include=\"\'app/main/research/includes/researchSettingsSummary.html\'\"></md-content></div><div ng-if=\"researchSettings.wizard.editMode\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-form-wizard id=\"screener-wizard\" flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">1</span> <span class=\"ms-form-wizard-step-text\">{{vm.constants.screener.wizard.step1.title}}</span></span></md-tab-label><md-tab-body><div class=\"p-16\"><h2 hide-gt-xs=\"\">{{vm.constants.screener.wizard.step1.title}}</h2><h3>{{vm.constants.screener.wizard.step1.content}}</h3></div><form name=\"wizardStep1\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"market-condition-row\" ng-repeat=\"row in researchSettings.markets.rows\"><div layout=\"row\" layout-align=\"end start\" class=\"text-right\" ng-if=\"researchSettings.markets.rows.length > 1 && !$first\"><md-button class=\"md-icon-button\" aria-label=\"Delete\" ng-click=\"vm.deleteScreenerMarketQuery($event, $index)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div layout-gt-sm=\"row\"><div layout-gt-sm=\"column\" flex-gt-sm=\"50\" layout-lt-md=\"row\"><md-input-container><label>{{vm.constants.screener.wizard.step1.labels.selectMarket}}</label><md-select name=\"market\" ng-model=\"row.sport\" ng-model-options=\"{trackBy: \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"s in vm.sports\" ng-value=\"s\" ng-click=\"vm.selectScreenerMarket($event, row, s)\">{{s.name}}</md-option></md-select><div ng-messages=\"wizardStep1.market.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div></div><div class=\"hint\">{{vm.constants.screener.wizard.step1.hints.market}}</div></md-input-container></div><div layout-gt-sm=\"column\" flex-gt-sm=\"50\" layout-lt-md=\"row\"><md-input-container ng-if=\"row.sport && row.sport.id != null\"><label>{{vm.constants.screener.wizard.step1.labels.selectTournament}}</label><md-select ng-model=\"row.tournament\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"t in row.sport.tournamentGroups\" ng-value=\"t\">{{t.name}}</md-option></md-select></md-input-container></div></div><md-button class=\"md-primary md-hue-1\" ng-click=\"vm.toggleScreenerAdvancedMarketSettings(row)\"><md-icon ng-if=\"row.advancedSettingsVisible\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-if=\"!row.advancedSettingsVisible\" md-font-icon=\"icon-chevron-right\"></md-icon>Advanced</md-button><div ng-if=\"row.advancedSettingsVisible\"><div layout-gt-sm=\"row\" layout-align-gt-sm=\"start start\" ng-repeat=\"q in row.conditions\" class=\"market-condition-form\"><ng-form name=\"wizardStep1MarketConditionTradeTypeForm\" layout-gt-sm=\"column\" layout=\"row\" flex=\"\"><md-input-container><label>{{vm.constants.screener.wizard.step1.labels.tradeType}}</label><md-select ng-model=\"q.betType\" ng-model-options=\"{trackBy: \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"b in vm.betTypes\" ng-value=\"b\">{{b.name}}</md-option></md-select><div ng-messages=\"wizardStep1MarketConditionTradeTypeForm.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div></div></md-input-container></ng-form><ng-form ng-if=\"q.betType.id != 1\" name=\"wizardStep1MarketConditionTeamForm\" layout-gt-sm=\"column\" layout=\"row\" flex=\"\"><md-input-container><label>{{vm.constants.screener.wizard.step1.labels.team}}</label><md-select ng-model=\"q.team\" ng-model-options=\"{trackBy: \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"t in vm.spreadWagerTypes\" ng-value=\"t\">{{t.label}}</md-option></md-select><div ng-messages=\"wizardStep1MarketConditionTeamForm.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div></div></md-input-container></ng-form><ng-form name=\"wizardStep1MarketConditionOperatorForm\" layout-gt-sm=\"column\" layout=\"row\" flex=\"\"><md-input-container><label>{{vm.constants.screener.wizard.step1.labels.operator}}</label><md-select ng-model=\"q.operator\" ng-model-options=\"{trackBy: \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"o in vm.mathOperators\" ng-value=\"o\">{{o.value}}</md-option></md-select><div ng-messages=\"wizardStep1MarketConditionOperatorForm.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div></div></md-input-container></ng-form><ng-form name=\"wizardStep1MarketConditionValueForm\" layout-gt-sm=\"column\" layout=\"row\" class=\"md-block\" flex=\"\"><div layout=\"row\"><md-input-container class=\"md-icon-float md-block\"><label>{{vm.constants.screener.wizard.step1.labels.value}}</label> <input name=\"query-value[]\" type=\"number\" ng-blur=\"wizardStep1MarketConditionValueForm.my_field.$validate()\" ng-model=\"q.value\" odds=\"\" odds-format=\"{{$root.user.oddsFormat}}\" bet-type=\"{{q.betType.id}}\" required=\"\" marketvalue=\"\" team=\"{{q.team.id}}\"><div ng-messages=\"wizardStep1MarketConditionValueForm.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div><div ng-message=\"marketvalue\" ng-if=\"q.team.id == 1 && $root.user.oddsFormat == 0\">{{constants.errors.positiveNumber}}</div><div ng-message=\"marketvalue\" ng-if=\"q.team.id == 0 && $root.user.oddsFormat == 0\">{{constants.errors.negativeNumber}}</div><div ng-message=\"marketvalue\" ng-if=\"q.team.id == 0 && $root.user.oddsFormat == 1\">{{constants.errors.positiveNumber}}</div></div><div class=\"hint\" ng-if=\"q.betType.id == 0\">{{vm.constants.screener.wizard.step1.hints.tradeTypes.spread}}</div><div class=\"hint\" ng-if=\"q.betType.id == 1\">{{vm.constants.screener.wizard.step1.hints.tradeTypes.totals}}</div><div class=\"hint\" ng-if=\"q.betType.id == 2\">{{vm.constants.screener.wizard.step1.hints.tradeTypes.moneyline}}</div></md-input-container></div></ng-form><div layout-gt-sm=\"column\" layout=\"row\" class=\"btn-delete-market-query\" flex=\"3\"><md-button hide-xs=\"\" hide-sm=\"\" class=\"md-icon-button\" aria-label=\"Delete\" ng-click=\"vm.deleteScreenerMarketQueryCondition(row, $index)\"><md-icon md-font-icon=\"icon-cancel\"></md-icon></md-button><md-button hide-md=\"\" hide-lg=\"\" class=\"md-raised md-accent\" aria-label=\"Delete\" ng-click=\"vm.deleteScreenerMarketQueryCondition(row, $index)\">Delete</md-button></div><md-divider hide-md=\"\" hide-lg=\"\" ng-if=\"!$last\"></md-divider></div><div layout=\"row\"><md-button class=\"md-fab md-mini md-primary\" ng-click=\"vm.addScreenerMarketQueryCondition(row)\" aria-label=\"Add Market Condition\"><md-icon md-font-icon=\"icon-playlist-plus\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span>{{vm.constants.tooltips.addMarketCondition}}</span></md-tooltip></md-button></div></div></div><div layout=\"row\"><md-button ng-show=\"researchSettings.markets.multiple\" class=\"md-raised md-primary\" ng-click=\"vm.addScreenerMarketQuery()\" aria-label=\"Add Market\">{{vm.constants.tooltips.addMarket}}</md-button></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">2</span> <span class=\"ms-form-wizard-step-text\">{{vm.constants.screener.wizard.step2.title}}</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div class=\"p-16\"><h2 hide-gt-xs=\"\">{{vm.constants.screener.wizard.step2.title}}</h2><h3>{{vm.constants.screener.wizard.step2.content}}</h3></div><div layout-gt-sm=\'=\"row\"\'><div layout-gt-sm=\"column\" layout=\"row\" flex-gt-sm=\"50\" flex=\"\"><div layout=\"row\" layout-align=\"center center\"><md-input-container layout=\"column\" flex=\"\"><label>{{vm.constants.screener.wizard.step2.labels.grouping}}</label><md-select ng-model=\"researchSettings.marketGrouping\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"g in alertMarketGroupings\" ng-value=\"g\" ng-click=\"vm.changeScreenerMarketGrouping(g)\">{{g.label}}</md-option></md-select></md-input-container><div layout=\"column\" flex=\"7\"><md-button ng-click=\"vm.openHelpDialog($event, \'marketGrouping\')\" class=\"md-icon-button\" aria-label=\"{{vm.constants.tooltips.help}}\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.help}}</md-tooltip></md-button></div></div></div><div layout-gt-sm=\"column\" layout=\"row\" flex-gt-sm=\"50\" flex=\"\"><div layout=\"row\" layout-align=\"center center\"><md-input-container layout=\"column\" flex=\"\"><label>{{vm.constants.screener.wizard.step2.labels.behavior}}</label><md-select ng-model=\"researchSettings.tradingBehavior\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"b in vm.tradingBehaviors\" ng-value=\"b\" ng-click=\"vm.changeScreenerTradingBehavior(b)\">{{b.label}}</md-option></md-select></md-input-container><div layout=\"column\" flex=\"7\"><md-button ng-click=\"vm.openHelpDialog($event, \'tradingBehavior\')\" class=\"md-icon-button\" aria-label=\"Help\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.help}}</md-tooltip></md-button></div></div></div></div><div class=\"p-16\" ng-if=\"researchSettings.alerts.rows.length == 0\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.addScreenerAlert()\" aria-label=\"{{vm.constants.screener.wizard.step2.buttons.addAlert}}\">{{vm.constants.screener.wizard.step2.buttons.addAlert}}</md-button><md-button ng-click=\"vm.openHelpDialog($event, \'alertDescription\')\" class=\"md-icon-button\" aria-label=\"{{vm.constants.tooltips.help}}\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.help}}</md-tooltip></md-button></div><div layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\" ng-repeat=\"a in researchSettings.alerts.rows\" class=\"alert-form\"><ng-form name=\"wizardStep2AlertTradeTypeForm\" layout-gt-sm=\"column\" layout=\"row\" flex=\"\"><md-input-container><label>{{vm.constants.screener.wizard.step2.labels.tradeType}}</label><md-select ng-model=\"a.betType\" ng-model-options=\"{trackBy: \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"b in vm.betTypes\" ng-value=\"b\">{{b.name}}</md-option></md-select><div ng-messages=\"wizardStep2AlertTradeTypeForm.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div></div></md-input-container></ng-form><ng-form name=\"wizardStep2AlertLevelForm\" layout-gt-sm=\"column\" layout=\"row\" flex=\"\"><md-input-container flex-xs=\"40\"><label>{{vm.constants.screener.wizard.step2.labels.alertLevel}}</label><md-select ng-model=\"a.alertLevel\" ng-model-options=\"{trackBy: \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"a in vm.alertLevels\" ng-value=\"a\">{{a.name}}</md-option></md-select><div ng-messages=\"wizardStep2AlertLevelForm.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div></div></md-input-container></ng-form><div hide-sm=\"\" hide-xs=\"\" layout=\"column\" layout-align=\"center center\" class=\"text-center\" flex=\"4\">&gt;=</div><ng-form name=\"wizardStep2AlertNumberForm\" layout-gt-sm=\"column\" layout=\"row\" flex=\"\"><md-input-container flex-xs=\"40\"><label>{{vm.constants.screener.wizard.step2.labels.numberOfAlerts}}</label><md-select ng-model=\"a.numberOfAlerts\" required=\"\"><md-option ng-repeat=\"i in [1,2,3,4,5,6]\" ng-value=\"i\">{{i}}</md-option></md-select><div ng-messages=\"wizardStep2AlertNumberForm.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div></div></md-input-container></ng-form><ng-form name=\"wizardStep2AlertRangeForm\" layout-gt-sm=\"column\" layout=\"row\" flex=\"\"><md-input-container><label>{{vm.constants.screener.wizard.step2.labels.range}}</label><md-select ng-model=\"a.range\" ng-model-options=\"{trackBy: \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"r in researchSettings.marketGrouping.ranges\" ng-value=\"r\">{{r.label}}</md-option></md-select><div ng-messages=\"wizardStep2AlertRangeForm.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div></div></md-input-container></ng-form><md-input-container layout-gt-sm=\"column\" layout=\"row\" flex=\"\"><label>{{vm.constants.screener.wizard.step2.labels.operator}}</label><md-select ng-model=\"a.conditionOperator\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"o in vm.queryOperators\" ng-value=\"o\" ng-click=\"vm.screenerAlertOperatorSelected($parent.$index, o)\">{{o.name}}</md-option></md-select></md-input-container><div layout-gt-sm=\"column\" layout-align=\"start center\" layout=\"row\" flex=\"7\"><div layout=\"row\"><md-button hide-sm=\"\" hide-xs=\"\" ng-click=\"vm.openHelpDialog($event, \'alertDescription\')\" class=\"md-icon-button\" aria-label=\"{{vm.constants.tooltips.help}}\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.help}}</md-tooltip></md-button><md-button hide-sm=\"\" hide-xs=\"\" class=\"md-icon-button\" aria-label=\"Delete\" ng-click=\"vm.deleteScreenerAlert($index)\"><md-icon md-font-icon=\"icon-cancel\"></md-icon></md-button></div><md-button hide-md=\"\" hide-lg=\"\" class=\"md-raised md-accent\" aria-label=\"Delete\" ng-click=\"vm.deleteScreenerAlert($index)\">Delete</md-button></div><md-divider ng-if=\"!$last\" hide-md=\"\" hide-lg=\"\"></md-divider></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">3</span> <span class=\"ms-form-wizard-step-text\">{{vm.constants.screener.wizard.step3.title}}</span></span></md-tab-label><md-tab-body><div hide-gt-xs=\"\" class=\"p-16\"><h2>{{vm.constants.screener.wizard.step3.title}}</h2></div><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><md-content ng-include=\"\'app/main/research/includes/researchSettingsSummary.html\'\"></md-content></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">{{vm.constants.screener.wizard.navigation.labels.previous}}</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button hide-xs=\"\" class=\"md-raised white-fg green-500-bg md-accent btn-preview\" ng-click=\"vm.previewScreener()\" ng-disabled=\"researchSettings.wizard.searching || wizardStep1.$invalid || wizardStep2.$invalid\">{{vm.constants.screener.wizard.navigation.labels.preview}}</md-button><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">{{vm.constants.screener.wizard.navigation.labels.next}}</md-button><md-button hide-xs=\"\" class=\"md-raised md-accent md-warn btn-run-save\" ng-click=\"vm.saveAndRunScreener($event);\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete(); researchSettings.wizard.searching\">{{vm.constants.screener.wizard.navigation.labels.run}}</md-button></div><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button hide-gt-xs=\"\" class=\"md-raised white-fg green-500-bg md-accent btn-preview\" ng-click=\"vm.previewScreener()\" ng-disabled=\"researchSettings.wizard.searching || wizardStep1.$invalid || wizardStep2.$invalid\">{{vm.constants.screener.wizard.navigation.labels.preview}}</md-button><md-button hide-gt-xs=\"\" class=\"md-raised md-accent md-warn btn-run-save\" ng-click=\"vm.saveAndRunScreener($event);\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete(); researchSettings.wizard.searching\">{{vm.constants.screener.wizard.navigation.labels.run}}</md-button></div></ms-form-wizard></div></div></ms-widget-front></ms-widget><ms-widget ng-if=\"researchSettings.matchResults.showResultsPanel\" id=\"results-widget\" flippable=\"true\" class=\"wl-panel initial-load\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 mb-8 border-bottom md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\"><md-icon md-font-icon=\"icon-grid\"></md-icon>{{researchSettings.matchResults.title}}</div><div><md-menu><md-button aria-label=\"more\" ng-click=\"$mdOpenMenu($event)\" ng-class=\"{ \'md-icon-button\': vm.isScreenLTESm }\"><md-icon md-font-icon=\"icon-format-line-spacing\"></md-icon><span hide-xs=\"\" hide-sm=\"\">{{selectedTradingBehavior.label}}</span><md-tooltip md-delay=\"300\" hide-xs=\"\" hide-sm=\"\">{{vm.constants.tooltips.tradingBehavior}}</md-tooltip></md-button><md-menu-content width=\"2\"><md-menu-item ng-repeat=\"b in vm.tradingBehaviors\"><md-button ng-click=\"vm.changeResultsTradingBehavior(b)\" aria-label=\"Change Trading Behavior\">{{b.label}}</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-click=\"vm.openHelpDialog($event, \'tradingBehavior\')\" class=\"md-icon-button\" aria-label=\"Help\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.help}}</md-tooltip></md-button><md-menu><md-button aria-label=\"more\" ng-click=\"$mdOpenMenu($event)\" ng-class=\"{ \'md-icon-button\': vm.isScreenLTESm }\"><md-icon md-font-icon=\"icon-apps\"></md-icon><span hide-xs=\"\" hide-sm=\"\">{{selectedMarketGrouping.label}}</span><md-tooltip md-delay=\"300\" hide-xs=\"\" hide-sm=\"\">{{vm.constants.tooltips.marketGrouping}}</md-tooltip></md-button><md-menu-content width=\"2\"><md-menu-item ng-repeat=\"g in vm.marketGroupings\"><md-button ng-click=\"vm.changeResultsMarketGrouping(g)\" aria-label=\"Change Market Grouping\">{{g.label}}</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-click=\"vm.openHelpDialog($event, \'marketGrouping\')\" class=\"md-icon-button\" aria-label=\"{{vm.constants.tooltips.help}}\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.help}}</md-tooltip></md-button></div></div><div class=\"wl-panel-content\"><div id=\"match-loader\" ng-if=\"researchSettings.wizard.searching\" layout=\"row\" layout-align=\"center start\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><h3>Loading...please wait</h3></div><div ng-if=\"!researchSettings.wizard.searching\" layout=\"row\"><div hide-gt-md=\"\" flex=\"\"><div class=\"p-16\" flex-md=\"50\" flex=\"\"><md-content ng-include=\"\'app/main/research/includes/matchSearchForm.html\'\"></md-content></div><div flex=\"\" layout=\"row\" layout-align=\"space-around center\"><div layout=\"column\"><div><md-icon md-font-icon=\"icon-flag-variant\" class=\"wl-alert-low\"></md-icon>{{vm.constants.matchResults.legend.alerts.low}}<br><md-icon md-font-icon=\"icon-flag-variant\" class=\"wl-alert-medium\"></md-icon>{{vm.constants.matchResults.legend.alerts.medium}}<br><md-icon md-font-icon=\"icon-flag-variant\" class=\"wl-alert-high\"></md-icon>{{vm.constants.matchResults.legend.alerts.high}}</div></div><div layout=\"column\"><md-button ng-click=\"vm.openHelpDialog($event, \'alertDescription\')\" class=\"md-icon-button\" aria-label=\"{{vm.constants.tooltips.help}}\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip md-delay=\"300\">{{vm.constants.tooltips.help}}</md-tooltip></md-button></div><div layout=\"column\"><div><span class=\"team-indicator\">H</span> {{vm.constants.matchResults.legend.home}}</div><div><span class=\"team-indicator\">A</span> {{vm.constants.matchResults.legend.away}}</div><div><span class=\"team-indicator\">O</span> {{vm.constants.matchResults.legend.over}}</div><div><span class=\"team-indicator\">U</span> {{vm.constants.matchResults.legend.under}}</div><div>{{vm.constants.matchResults.legend.periodsBack}}</div></div></div><div ng-if=\"upcomingMatches.rows.length == 0\" flex=\"\" class=\"wl-panel-content\"><div class=\"p-16\"><h3>{{vm.constants.matchResults.noResults}}</h3></div></div><div ng-if=\"upcomingMatches.rows.length > 0\" id=\"upcoming-matches-lt-lg\" flex=\"\"><md-content ng-include=\"\'app/main/research/includes/paginator.html\'\"></md-content><md-list flex=\"\"><md-list-item class=\"md-3-line md-long-text\" ng-repeat=\"row in upcomingMatches.rows track by row.id\"><div class=\"md-list-item-text\"><div layout=\"row\"><div layout=\"column\" flex=\"\"><h3 class=\"competitors-header\"><span class=\"team-indicator\">A</span> {{row.awayCompetitor.name}}<br><span class=\"team-indicator\">H</span> {{row.homeCompetitor.name}}</h3><p class=\"secondary-text\">{{row.sport.name}} ({{row.tournament.name}}) <span ng-if=\"row.sport.hasAsianHandicap\">*</span> - {{row.matchDate|formatDate: user.timezone}} <span ng-if=\"row.inProgress\" class=\"text-boxed blue-bg white-fg in-progress\">In Progress</span></p></div><div layout=\"column\" layout-align=\"center end\" flex=\"\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.viewMatchDetail(row, \'ats\', $index)\" aria-label=\"View Detail\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">View Detail</md-tooltip></md-button></div></div><div class=\"wolfline-table-container\"><table class=\"center condensed wl-values-table has-grouping {{selectedMarketGrouping.name.toLowerCase()}}\"><thead><tr><th class=\"secondary-text\"><span hide-xs=\"\">Market</span></th><th class=\"secondary-text\" ng-repeat=\"d in row.matchWolfline.data.ats|reverseArray\">{{$index + 1}} SP</th></tr></thead><tbody><tr><td><div layout=\"row\" layout-align=\"start center\" hide-xs=\"\"><md-button ng-disabled=\"!row.spreadOdds || row.spreadOdds.status > 0 || row.inProgress\" class=\"md-fab md-mini btn-papertrade\" ng-click=\"vm.openPaperTradeDialog($event, row, 0)\" aria-label=\"Add Paper Trade\" style=\"display: flex; align-items: center; justify-content: center;\"><md-icon md-font-icon=\"icon-coin\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span>{{vm.constants.matchResults.paperTrade.btnLabel}}</span></md-tooltip></md-button><div class=\"ml-8\">{{vm.constants.matchResults.tabs.ats.shortTitle}}</div></div></td><td ng-repeat=\"d in row.matchWolfline.data.ats|reverseArray\"><span ng-class=\"[\'wl-label\', \'wl-alert-\' + vm.getAlertLevel(d.level)]\">{{d.displayValue}}</span> <span class=\"team-indicator\">{{vm.getTradingBehaviorIndicator(row, ($index + 1), selectedTradingBehavior, \'ats\')}}</span></td></tr><tr><td><div layout=\"row\" layout-align=\"start center\" hide-xs=\"\"><md-button ng-disabled=\"!row.totalsOdds || row.totalsOdds.status > 0 || row.inProgress\" class=\"md-fab md-mini btn-papertrade\" ng-click=\"vm.openPaperTradeDialog($event, row, 1)\" aria-label=\"Add Paper Trade\" style=\"display: flex; align-items: center; justify-content: center;\"><md-icon md-font-icon=\"icon-coin\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span>{{vm.constants.matchResults.paperTrade.btnLabel}}</span></md-tooltip></md-button><div class=\"ml-8\">{{vm.constants.matchResults.tabs.totals.shortTitle}}</div></div></td><td ng-repeat=\"d in row.matchWolfline.data.totals|reverseArray\"><span ng-class=\"[\'wl-label\', \'wl-alert-\' + vm.getAlertLevel(d.level)]\">{{d.displayValue}}</span> <span class=\"team-indicator\">{{vm.getTotalsTradingBehaviorIndicator(d.value, selectedTradingBehavior)}}</span></td></tr><tr><td><div layout=\"row\" layout-align=\"start center\" hide-xs=\"\"><md-button ng-disabled=\"!row.moneylineOdds || row.moneylineOdds.status > 0 || row.inProgress\" class=\"md-fab md-mini btn-papertrade\" ng-click=\"vm.openPaperTradeDialog($event, row, 2)\" aria-label=\"Add Paper Trade\" style=\"display: flex; align-items: center; justify-content: center;\"><md-icon md-font-icon=\"icon-coin\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span>{{vm.constants.matchResults.paperTrade.btnLabel}}</span></md-tooltip></md-button><div class=\"ml-8\">{{vm.constants.matchResults.tabs.moneyline.shortTitle}}</div></div></td><td ng-repeat=\"d in row.matchWolfline.data.moneyline|reverseArray\"><span ng-class=\"[\'wl-label\', \'wl-alert-\' + vm.getAlertLevel(d.level)]\">{{d.displayValue}}</span> <span class=\"team-indicator\">{{vm.getTradingBehaviorIndicator(row, ($index + 1), selectedTradingBehavior, \'moneyline\')}}</span></td></tr></tbody></table><div class=\"wolfline-table-period-btn\"><md-button ng-if=\"!row.noGroupingVisible\" ng-click=\"vm.toggleNoGrouping($event, row)\" aria-label=\"{{vm.constants.matchResults.buttons.showAllPeriods}}\">{{vm.constants.matchResults.buttons.showAllPeriods}}</md-button><md-button ng-if=\"row.noGroupingVisible\" ng-click=\"vm.toggleNoGrouping($event, row)\" aria-label=\"{{vm.constants.matchResults.buttons.hideAllPeriods}}\">{{vm.constants.matchResults.buttons.hideAllPeriods}}</md-button></div></div></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list><md-content ng-include=\"\'app/main/research/includes/paginator.html\'\"></md-content></div></div><div class=\"p-16\" hide-xs=\"\" hide-sm=\"\" hide-md=\"\" flex=\"\"><md-content id=\"upcoming-matches-content\" flex=\"\"><div layout=\"row\"><div layout=\"column\" hide-sm=\"\" hide-xs=\"\" flex=\"15\"><div><md-icon md-font-icon=\"icon-flag-variant\" class=\"wl-alert-low\"></md-icon>{{vm.constants.matchResults.legend.alerts.low}}<br><md-icon md-font-icon=\"icon-flag-variant\" class=\"wl-alert-medium\"></md-icon>{{vm.constants.matchResults.legend.alerts.medium}}<br><md-icon md-font-icon=\"icon-flag-variant\" class=\"wl-alert-high\"></md-icon>{{vm.constants.matchResults.legend.alerts.high}}</div></div><div layout=\"column\" hide-sm=\"\" hide-xs=\"\" flex=\"5\"><md-button ng-click=\"vm.openHelpDialog($event, \'alertDescription\')\" class=\"md-icon-button\" aria-label=\"{{vm.constants.tooltips.help}}\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.help}}</md-tooltip></md-button></div><div layout=\"column\" hide-sm=\"\" hide-xs=\"\" flex=\"10\"><div><span class=\"team-indicator\">H</span> {{vm.constants.matchResults.legend.home}}</div><div><span class=\"team-indicator\">A</span> {{vm.constants.matchResults.legend.away}}</div><div><span class=\"team-indicator\">O</span> {{vm.constants.matchResults.legend.over}}</div><div><span class=\"team-indicator\">U</span> {{vm.constants.matchResults.legend.under}}</div><div>{{vm.constants.matchResults.legend.periodsBack}}</div></div><div layout=\"column\" flex=\"30\" flex-offset=\"45\"><md-content ng-include=\"\'app/main/research/includes/matchSearchForm.html\'\"></md-content></div></div><div ng-if=\"upcomingMatches.rows.length == 0\" class=\"wl-panel-content\"><div class=\"p-16\"><h3>{{vm.constants.matchResults.noResults}}</h3></div></div><div ng-if=\"upcomingMatches.rows.length > 0\"><md-content ng-include=\"\'app/main/research/includes/paginator.html\'\"></md-content><div id=\"upcoming-matches-container\"><table ng-class=\"[\'simple\', \'row-border\', \'hover\', \'clickable-odd-rows\', \'upcoming-matches-table\', selectedMarketGrouping.name.toLowerCase()]\" ng-cloak=\"\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in upcomingMatches.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr class=\"match-row\" ng-repeat-start=\"row in upcomingMatches.rows track by row.id\" ng-click=\"vm.viewMatchDetail(row, \'ats\', $index)\"><td><md-button ng-disabled=\"!row.hasOdds\" class=\"md-fab md-mini\" ng-click=\"vm.openPaperTradeDialog($event, row, 0)\" aria-label=\"Add Paper Trade\" style=\"display: flex; align-items: center; justify-content: center;\"><md-icon md-font-icon=\"icon-coin\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span ng-if=\"row.hasOdds\">{{vm.constants.matchResults.paperTrade.btnLabel}}</span> <span ng-if=\"!row.hasOdds\">{{vm.constants.matchResults.paperTrade.btnLabelDisabled}}</span></md-tooltip></md-button></td><td>{{row.matchDate|formatDate: user.timezone}}<div ng-if=\"row.inProgress\" class=\"text-boxed blue-bg white-fg in-progress\">In Progress</div></td><td><div layout=\"row\"><div ng-if=\"row.sport.icon\" layout=\"column\" flex=\"20\" class=\"mr-8\"><i class=\"{{row.sport.icon}}\"></i></div><div class=\"column\" flex=\"\">{{row.sport.name}}<br>{{row.tournament.tournamentGroup.name}}<md-icon ng-if=\"row.sport.hasAsianHandicap\" md-font-icon=\"icon-multiplication\"><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.asianBet}}</md-tooltip></md-icon></div></div></td><td><div class=\"team-indicator\">A<md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.matchResults.legend.away}}</md-tooltip></div>{{row.awayCompetitor.name}}<br><div class=\"team-indicator\">H<md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.matchResults.legend.home}}</md-tooltip></div>{{row.homeCompetitor.name}}</td><td><div><span class=\"wl-label\">{{vm.constants.matchResults.tabs.ats.title}}</span></div><div><span class=\"wl-label\">{{vm.constants.matchResults.tabs.totals.title}}</span></div><div><span class=\"wl-label\">{{vm.constants.matchResults.tabs.moneyline.title}}</span></div></td><td ng-repeat=\"d in row.matchWolfline.data.ats\"><div><span ng-class=\"[\'wl-label\', \'wl-alert-\' + vm.getAlertLevel(row.matchWolfline.data.ats[(row.matchWolfline.data.ats.length - 1) - $index].level)]\">{{row.matchWolfline.data.ats[(row.matchWolfline.data.ats.length - 1) - $index].displayValue}}</span> <span class=\"team-indicator\">{{vm.getTradingBehaviorIndicator(row, ($index + 1), selectedTradingBehavior, \'ats\')}}</span></div><div><span ng-class=\"[\'wl-label\', \'wl-alert-\' + vm.getAlertLevel(row.matchWolfline.data.totals[(row.matchWolfline.data.totals.length - 1) - $index].level)]\">{{row.matchWolfline.data.totals[(row.matchWolfline.data.totals.length - 1) - $index].displayValue}}</span> <span class=\"team-indicator\">{{vm.getTotalsTradingBehaviorIndicator(row.matchWolfline.data.totals[(row.matchWolfline.data.totals.length - 1) - $index].value, selectedTradingBehavior)}}</span></div><div><span ng-class=\"[\'wl-label\', \'wl-alert-\' + vm.getAlertLevel(row.matchWolfline.data.moneyline[(row.matchWolfline.data.moneyline.length - 1) - $index].level)]\">{{row.matchWolfline.data.moneyline[(row.matchWolfline.data.moneyline.length - 1) - $index].displayValue}}</span> <span class=\"team-indicator\">{{vm.getTradingBehaviorIndicator(row, ($index + 1), selectedTradingBehavior, \'moneyline\')}}</span></div></td></tr><tr class=\"no-grouping-row collapsed\" ng-repeat-end=\"\"><td colspan=\"29\" class=\"text-center\"><md-button class=\"md-accent\" ng-if=\"!row.noGroupingVisible\" ng-click=\"vm.toggleNoGroupingRow($event, row)\" aria-label=\"{{vm.constants.matchResults.buttons.showAllPeriods}}\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon>{{vm.constants.matchResults.buttons.showAllPeriods}}</md-button><div class=\"no-grouping-container\"></div><md-button class=\"md-accent\" ng-if=\"row.noGroupingVisible\" ng-click=\"vm.toggleNoGroupingRow($event, row)\" aria-label=\"{{vm.constants.matchResults.buttons.hideAllPeriods}}\"><md-icon md-font-icon=\"icon-chevron-up\"></md-icon>{{vm.constants.matchResults.buttons.hideAllPeriods}}</md-button></td></tr></tbody></table></div><md-content ng-include=\"\'app/main/research/includes/paginator.html\'\"></md-content></div><div ng-if=\"upcomingMatches.rowCount > 0\" layout=\"row\"><div layout=\"column\" class=\"text-center\" flex=\"\">{{upcomingMatches.startingRow}} to {{upcomingMatches.endingRow}} of {{upcomingMatches.rowCount}} matches</div></div></md-content></div></div></div></ms-widget-front><ms-widget-back id=\"match-detail\"><div layout=\"row\" layout-align=\"space-between center\"><md-button ng-disabled=\"vm.isFirstMatch() || researchSettings.wizard.searching\" ng-click=\"vm.loadPreviousMatch()\" aria-label=\"{{vm.constants.matchResults.buttons.previousMatch}}\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>{{vm.constants.matchResults.buttons.previousMatch}}</md-button><md-button ng-disabled=\"vm.isLastMatch() || researchSettings.wizard.searching\" ng-click=\"vm.loadNextMatch()\" aria-label=\"{{vm.constants.matchResults.buttons.nextMatch}}\">{{vm.constants.matchResults.buttons.nextMatch}}<md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div><div class=\"white-bg\"><div class=\"p-16 mb-8 border-bottom md-accent-bg\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{ selectedMatch.awayCompetitor.name }} @<br hide-md=\"\" hide-lg=\"\">{{ selectedMatch.homeCompetitor.name }}<br hide-gt-md=\"\"><span class=\"secondary-text match-date\">{{selectedMatch.matchDate|formatDate: user.timezone}}</span> <span ng-if=\"selectedMatch.inProgress\" class=\"text-boxed blue-bg white-fg in-progress\">In Progress</span></div><div layout=\"row\" layout-align=\"start center\"><md-menu><md-button aria-label=\"more\" ng-click=\"$mdOpenMenu($event)\" ng-class=\"{ \'md-icon-button\': vm.isScreenLTESm }\"><md-icon md-font-icon=\"icon-format-line-spacing\"></md-icon><span hide-sm=\"\" hide-xs=\"\">{{selectedTradingBehavior.label}}</span><md-tooltip md-delay=\"300\" hide-xs=\"\" hide-sm=\"\">{{vm.constants.tooltips.tradingBehavior}}</md-tooltip></md-button><md-menu-content width=\"2\"><md-menu-item ng-repeat=\"b in vm.tradingBehaviors\"><md-button ng-click=\"vm.changeResultsTradingBehavior(b)\" aria-label=\"Change Trading Behavior\">{{b.label}}</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-click=\"vm.openHelpDialog($event, \'tradingBehavior\')\" class=\"md-icon-button\" aria-label=\"Help\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.help}}</md-tooltip></md-button><md-menu><md-button aria-label=\"more\" ng-click=\"$mdOpenMenu($event)\" ng-class=\"{ \'md-icon-button\': vm.isScreenLTESm }\"><md-icon md-font-icon=\"icon-apps\"></md-icon><span hide-sm=\"\" hide-xs=\"\">{{selectedMarketGrouping.label}}</span><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span hide-gt-sm=\"\">{{selectedMarketGrouping.label}}:</span>{{vm.constants.tooltips.marketGrouping}}</md-tooltip></md-button><md-menu-content width=\"2\"><md-menu-item ng-repeat=\"g in vm.marketGroupings\"><md-button ng-click=\"vm.changeResultsMarketGrouping(g)\" aria-label=\"Change Market Grouping\">{{g.label}}</md-button></md-menu-item></md-menu-content></md-menu><md-button ng-click=\"vm.openHelpDialog($event, \'marketGrouping\')\" class=\"md-icon-button\" aria-label=\"{{vm.constants.tooltips.help}}\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.help}}</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.closeMatchDetail()\" aria-label=\"Close Match Detail\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span>{{vm.constants.tooltips.closeMatch}}</span></md-tooltip></md-button></div></div></div><div ng-if=\"researchSettings.wizard.searching\" layout=\"row\" layout-align=\"center start\" class=\"p-16 min-height-500\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><h3>Loading...please wait</h3></div><div ng-if=\"selectedMatch && !researchSettings.wizard.searching\" class=\"p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" flex=\"\"><table class=\"simple odds-table condensed\"><thead><tr><th>{{vm.constants.matchResults.team}}</th><th>{{vm.constants.betTypes.ats}}</th><th>{{vm.constants.betTypes.moneyline}}</th><th colspan=\"2\">{{vm.constants.betTypes.totals}}</th></tr></thead><tbody><tr><td><span class=\"team-indicator\">A</span>&nbsp;<br hide-gt-xs=\"\">{{ selectedMatch.awayCompetitor.name }}</td><td><span ng-if=\"selectedMatch.spreadOdds && selectedMatch.spreadOdds.status == 0\" class=\"spread-odds\"><span ng-if=\"selectedMatch.spreadOdds.favorite == 0\">+</span><span ng-if=\"selectedMatch.spreadOdds.favorite == 1\">-</span>{{selectedMatch.spreadOdds.marketPrice}}</span> <span ng-if=\"selectedMatch.spreadOdds && selectedMatch.spreadOdds.status == 0\" class=\"spread-price\">{{selectedMatch.spreadOdds.awayJuicePrice|formatOdds:user.oddsFormat}}</span> <span ng-if=\"!selectedMatch.spreadOdds || selectedMatch.spreadOdds.status > 0\">N/A</span></td><td><span ng-if=\"selectedMatch.moneylineOdds && selectedMatch.moneylineOdds.status == 0\">{{selectedMatch.moneylineOdds.awayMarketPrice|formatOdds:user.oddsFormat}}</span> <span ng-if=\"!selectedMatch.moneylineOdds || selectedMatch.moneylineOdds.status > 0\">N/A</span></td><td rowspan=\"2\"><span ng-if=\"selectedMatch.totalsOdds && selectedMatch.totalsOdds.status == 0\">Over {{selectedMatch.totalsOdds.marketPrice}}<br>{{selectedMatch.totalsOdds.overJuicePrice|formatOdds:user.oddsFormat}}</span> <span ng-if=\"!selectedMatch.totalsOdds || selectedMatch.totalsOdds.status > 0\">N/A</span></td><td rowspan=\"2\"><span ng-if=\"selectedMatch.totalsOdds && selectedMatch.totalsOdds.status == 0\">Under {{selectedMatch.totalsOdds.marketPrice}}<br>{{selectedMatch.totalsOdds.underJuicePrice|formatOdds:user.oddsFormat}}</span> <span ng-if=\"!selectedMatch.totalsOdds || selectedMatch.totalsOdds.status > 0\">N/A</span></td></tr><tr><td><span class=\"team-indicator\">H</span>&nbsp;<br hide-gt-xs=\"\">{{ selectedMatch.homeCompetitor.name }}</td><td><span ng-if=\"selectedMatch.spreadOdds && selectedMatch.spreadOdds.status == 0\" class=\"spread-odds\"><span ng-if=\"selectedMatch.spreadOdds.favorite == 1\">+</span><span ng-if=\"selectedMatch.spreadOdds.favorite == 0\">-</span>{{selectedMatch.spreadOdds.marketPrice}}</span> <span ng-if=\"selectedMatch.spreadOdds && selectedMatch.spreadOdds.status == 0\" class=\"spread-price\">{{selectedMatch.spreadOdds.homeJuicePrice|formatOdds:user.oddsFormat}}</span> <span ng-if=\"!selectedMatch.spreadOdds || selectedMatch.spreadOdds.status > 0\">N/A</span></td><td><span ng-if=\"selectedMatch.moneylineOdds && selectedMatch.moneylineOdds.status == 0\">{{selectedMatch.moneylineOdds.homeMarketPrice|formatOdds:user.oddsFormat}}</span> <span ng-if=\"!selectedMatch.moneylineOdds || selectedMatch.moneylineOdds.status > 0\">N/A</span></td></tr></tbody></table></div><div layout=\"column\" hide-sm=\"\" hide-xs=\"\" flex=\"10\"></div><div layout=\"column\" hide-sm=\"\" hide-xs=\"\" flex=\"15\"><div><md-icon md-font-icon=\"icon-flag-variant\" class=\"wl-alert-low\"></md-icon>{{vm.constants.matchResults.legend.alerts.low}}<br><md-icon md-font-icon=\"icon-flag-variant\" class=\"wl-alert-medium\"></md-icon>{{vm.constants.matchResults.legend.alerts.medium}}<br><md-icon md-font-icon=\"icon-flag-variant\" class=\"wl-alert-high\"></md-icon>{{vm.constants.matchResults.legend.alerts.high}}</div></div><div layout=\"column\" hide-sm=\"\" hide-xs=\"\" flex=\"5\"><md-button ng-click=\"vm.openHelpDialog($event, \'alertDescription\')\" class=\"md-icon-button\" aria-label=\"{{vm.constants.tooltips.help}}\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.help}}</md-tooltip></md-button></div><div layout=\"column\" hide-sm=\"\" hide-xs=\"\" flex=\"10\"><div><span class=\"team-indicator\">H</span> {{vm.constants.matchResults.legend.home}}</div><div><span class=\"team-indicator\">A</span> {{vm.constants.matchResults.legend.away}}</div><div><span class=\"team-indicator\">O</span> {{vm.constants.matchResults.legend.over}}</div><div><span class=\"team-indicator\">U</span> {{vm.constants.matchResults.legend.under}}</div><div>{{vm.constants.matchResults.legend.periodsBack}}</div></div></div><div class=\"wolfline-table-container\"><table id=\"match-detail-wl-results-table\" class=\"row-border clickable-rows wl-values-table {{selectedMarketGrouping.name.toLowerCase()}}\" ng-class=\"{ \'simple\': !vm.isScreenLTESm, \'condensed\': vm.isScreenLTESm }\" flex=\"\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in matchDetailColumns\"><div class=\"table-header\"><span class=\"column-title\">{{column}}</span></div></th></tr></thead><tbody ng-if=\"selectedMatch\"><tr ng-click=\"vm.selectMatchBetType($event, \'ats\')\" ng-class=\"{\'active\': selectedMatch.betType == \'ats\'}\"><td><div layout=\"row\" layout-align=\"start center\" layout-sm=\"column\" layout-xs=\"column\"><md-button ng-disabled=\"!selectedMatch.spreadOdds || selectedMatch.spreadOdds.status > 0 || selectedMatch.inProgress\" class=\"md-fab md-mini btn-papertrade\" ng-click=\"vm.openPaperTradeDialog($event, selectedMatch, 0)\" aria-label=\"{{vm.constants.matchResults.paperTrade.btnLabel}}\" style=\"display: flex; align-items: center; justify-content: center;\"><md-icon md-font-icon=\"icon-coin\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span ng-if=\"selectedMatch.spreadOdds && selectedMatch.spreadOdds.status == 0\">{{vm.constants.matchResults.paperTrade.btnLabel}}</span> <span ng-if=\"!selectedMatch.spreadOdds || selectedMatch.spreadOdds.status > 0\">{{vm.constants.matchResults.paperTrade.btnLabelDisabled}}</span></md-tooltip></md-button><div ng-class=\"{\'ml-8\': !vm.isScreenLTESm}\"><div>{{vm.constants.betTypes.ats}}</div><md-icon ng-if=\"selectedMatch.sport.hasAsianHandicap\" md-font-icon=\"icon-multiplication\"><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.asianBet}}</md-tooltip><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.asianBet}}</md-tooltip></md-icon></div></div></td><td ng-repeat=\"d in selectedMatch.matchWolfline.data.ats|reverseArray\"><span ng-class=\"[\'wl-label\', \'wl-alert-\' + vm.getAlertLevel(d.level)]\" ng-click=\"vm.selectChartDataPoint($event, \'ats\', d.periodBack)\" ng-mouseover=\"vm.highlightChartCursor($event, d.periodBack)\" ng-mouseleave=\"vm.unhighlightChartCursor($event)\">{{d.displayValue}}</span> <span class=\"team-indicator\">{{vm.getTradingBehaviorIndicator(selectedMatch, ($index + 1), selectedTradingBehavior, \'ats\')}}</span></td></tr><tr ng-click=\"vm.selectMatchBetType($event, \'totals\')\" ng-class=\"{\'active md-accent-border\': selectedMatch.betType == \'totals\'}\"><td><div layout=\"row\" layout-align=\"start center\" layout-sm=\"column\" layout-xs=\"column\"><md-button ng-disabled=\"!selectedMatch.totalsOdds || selectedMatch.totalsOdds.status > 0 || selectedMatch.inProgress\" class=\"md-fab md-mini btn-papertrade\" ng-click=\"vm.openPaperTradeDialog($event, selectedMatch, 1)\" aria-label=\"Add Paper Trade\" style=\"display: flex; align-items: center; justify-content: center;\"><md-icon md-font-icon=\"icon-coin\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span ng-if=\"selectedMatch.totalsOdds && selectedMatch.totalsOdds.status == 0\">{{vm.constants.matchResults.paperTrade.btnLabel}}</span> <span ng-if=\"!selectedMatch.totalsOdds || selectedMatch.totalsOdds.status > 0\">{{vm.constants.matchResults.paperTrade.btnLabelDisabled}}</span></md-tooltip></md-button><div ng-class=\"{\'ml-8\': !vm.isScreenLTESm}\"><div>{{vm.constants.betTypes.totals}}</div><md-icon ng-if=\"selectedMatch.sport.hasAsianHandicap\" md-font-icon=\"icon-multiplication\"><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.asianBet}}</md-tooltip></md-icon></div></div></td><td ng-repeat=\"d in selectedMatch.matchWolfline.data.totals|reverseArray\"><span ng-class=\"[\'wl-label\', \'wl-alert-\' + vm.getAlertLevel(d.level)]\" ng-click=\"vm.selectChartDataPoint($event, \'totals\', d.periodBack)\" ng-mouseover=\"vm.highlightChartCursor($event, d.periodBack)\" ng-mouseleave=\"vm.unhighlightChartCursor($event)\">{{d.displayValue}}</span> <span class=\"team-indicator\">{{vm.getTotalsTradingBehaviorIndicator(d.value, selectedTradingBehavior)}}</span></td></tr><tr ng-click=\"vm.selectMatchBetType($event, \'moneyline\')\" ng-class=\"{\'active md-accent-border\': selectedMatch.betType == \'moneyline\'}\"><td><div layout=\"row\" layout-align=\"start center\" layout-sm=\"column\" layout-xs=\"column\"><md-button ng-disabled=\"!selectedMatch.totalsOdds || selectedMatch.totalsOdds.status > 0 || selectedMatch.inProgress\" class=\"md-fab md-mini btn-papertrade\" ng-click=\"vm.openPaperTradeDialog($event, selectedMatch, 1)\" aria-label=\"Add Paper Trade\" style=\"display: flex; align-items: center; justify-content: center;\"><md-icon md-font-icon=\"icon-coin\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span ng-if=\"selectedMatch.totalsOdds && selectedMatch.totalsOdds.status == 0\">{{vm.constants.matchResults.paperTrade.btnLabel}}</span> <span ng-if=\"!selectedMatch.totalsOdds || selectedMatch.totalsOdds.status > 0\">{{vm.constants.matchResults.paperTrade.btnLabelDisabled}}</span></md-tooltip></md-button><div ng-class=\"{\'ml-8\': !vm.isScreenLTESm}\">{{vm.constants.betTypes.moneyline}}</div></div></td><td ng-repeat=\"d in selectedMatch.matchWolfline.data.moneyline|reverseArray\"><span ng-class=\"[\'wl-label\', \'wl-alert-\' + vm.getAlertLevel(d.level)]\" ng-click=\"vm.selectChartDataPoint($event, \'moneyline\', d.periodBack)\" ng-mouseover=\"vm.highlightChartCursor($event, d.periodBack)\" ng-mouseleave=\"vm.unhighlightChartCursor($event)\">{{d.displayValue}}</span> <span class=\"team-indicator\">{{vm.getTradingBehaviorIndicator(selectedMatch, ($index + 1), selectedTradingBehavior, \'moneyline\')}}</span></td></tr></tbody></table><div class=\"wolfline-table-period-btn\"><md-button class=\"md-accent\" ng-if=\"!selectedMatch.noGroupingVisible\" ng-click=\"vm.toggleNoGrouping($event, selectedMatch)\" aria-label=\"{{vm.constants.matchResults.buttons.showAllPeriods}}\">{{vm.constants.matchResults.buttons.showAllPeriods}}</md-button><md-button class=\"md-accent\" ng-if=\"selectedMatch.noGroupingVisible\" ng-click=\"vm.toggleNoGrouping($event, selectedMatch)\" aria-label=\"{{vm.constants.matchResults.buttons.hideAllPeriods}}\">{{vm.constants.matchResults.buttons.hideAllPeriods}}</md-button></div></div><div id=\"chart-widget\" ng-class=\"{\'edit-mode\': vm.chartLine.enabled}\"><div ng-if=\"vm.chartLine.enabled\" class=\"text-center help-text\">{{vm.constants.matchResults.chart.instructions}} {{vm.chartLine.type}}.</div><div class=\"chart-controls active\" ng-class=\"{ \'text-right\': !vm.isScreenLTESm, \'text-center\': vm.isScreenLTESm }\"><span class=\"h3\">{{vm.constants.matchResults.chart.controlsLabel}}</span> <span ng-if=\"!vm.chartLine.enabled\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Support/Resistance Line\" ng-click=\"vm.enableLineDrawing(\'guide\')\"><md-icon md-font-icon=\"icon-border-horizontal\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span>{{vm.constants.tooltips.supportResistance}}</span></md-tooltip></md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Trend Line\" ng-click=\"vm.enableLineDrawing(\'trendline\')\"><md-icon md-font-icon=\"icon-elevation-rise\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span>{{vm.constants.tooltips.trendline}}</span></md-tooltip></md-button></span> <span ng-if=\"vm.chartLine.enabled && vm.chartLine.type == \'trendline\'\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Clear\" ng-click=\"vm.clearTrendLines(\'match-chart\')\"><md-icon md-font-icon=\"icon-eraser\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span>{{vm.constants.tooltips.clearTrendlines}}</span></md-tooltip></md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Done\" ng-click=\"vm.disableLineDrawing()\"><md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span>{{vm.constants.tooltips.done}}</span></md-tooltip></md-button></span> <span ng-if=\"vm.chartLine.enabled && vm.chartLine.type == \'guide\'\"><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Clear\" ng-click=\"vm.clearGuideLines(\'match-chart\')\"><md-icon md-font-icon=\"icon-eraser\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span>{{vm.constants.tooltips.clearGuides}}</span></md-tooltip></md-button><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Done\" ng-click=\"vm.disableLineDrawing()\"><md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\"><span>{{vm.constants.tooltips.done}}</span></md-tooltip></md-button></span><md-button ng-click=\"vm.openHelpDialog($event, \'chartDescription\')\" class=\"md-fab md-mini md-primary help\" aria-label=\"{{vm.constants.tooltips.help}}\">?<md-tooltip md-delay=\"300\" hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.help}}</md-tooltip></md-button></div><amchart id=\"match-chart\" options=\"matchChartOptions\" ng-if=\"selectedMatch\" ng-cloak=\"\" class=\"wl-chart\" width=\"100%\" height=\"400\" ng-mousemove=\"vm.chartMouseMove($event)\"></amchart></div></div></div></ms-widget-back></ms-widget></div></div></div>");
$templateCache.put("app/main/screener/screeners.html","<div id=\"screener-wrapper\" class=\"page-layout simple\" layout=\"row\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"wl-panel\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget-front class=\"white-bg\"><div class=\"p-16 mb-8 border-bottom md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"h3\"><md-icon md-font-icon=\"icon-binoculars\"></md-icon>{{vm.title}}</div></div><div><md-button ui-sref=\"app.research({newScreener: true, home: false})\" class=\"md-icon-button\" aria-label=\"Add Screener\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-delay=\"300\"><span>Add Screener</span></md-tooltip></md-button></div></div><div><div class=\"p-16\" flex=\"\"><p ng-if=\"vm.screeners.length == 0\">No screeners found.</p><md-list ng-if=\"vm.screeners.length > 0\" flex=\"\"><md-list-item class=\"md-2-line\" ng-repeat=\"s in vm.screeners\"><div class=\"md-list-item-text\"><h3><span class=\"badge red-bg white-fg\">{{s.matchCount}}</span> <a ui-sref=\"app.research({ screener: s, home: false })\">{{ s.name }}</a></h3><p class=\"secondary-text\">Created on {{ s.created|formatDate: user.timezone }}</p><p>{{ s.description }}</p></div><md-menu class=\"md-secondary\"><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button aria-label=\"Edit\" ui-sref=\"app.research({ screener: s, home: false })\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>Edit/View</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delete\" ng-click=\"vm.deleteScreener($event, s)\"><md-icon md-font-icon=\"icon-trash\"></md-icon>Delete</md-button></md-menu-item></md-menu-content></md-menu></md-list-item></md-list></div></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/pages/maintenance/maintenance.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"maintenance-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"MAINTENANCE.TITLE\">Closed for scheduled maintenance!</div><div class=\"subtitle\" translate=\"MAINTENANCE.SUBTITLE\">We\'re sorry for the inconvenience.<br>Please check back later.</div></div></div></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex=\"\" layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon id=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label> <input id=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate=\"\" translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex=\"\"></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"center start\"><img ng-src=\"assets/images/logos/wolfline.png\" alt=\"The Wolfline. Quant sports trading analytics\" class=\"logo\"></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/profile/dialogs/creditcard-dialog.html","<md-dialog class=\"credit-card-dialog\" aria-label=\"{{vm.title}}\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form name=\"creditCardForm\" novalidate=\"\"><md-dialog-content><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><label>Description</label> <input type=\"text\" name=\"description\" ng-model=\"vm.creditCardForm.description\" required=\"\"><div ng-messages=\"creditCardForm.description.$error\" ng-show=\"creditCardForm.description.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><label>First Name</label> <input type=\"text\" name=\"firstName\" ng-model=\"vm.creditCardForm.firstName\" required=\"\"><div ng-messages=\"creditCardForm.firstName.$error\" ng-show=\"creditCardForm.firstName.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><label>Last Name</label> <input type=\"text\" name=\"lastName\" ng-model=\"vm.creditCardForm.lastName\" required=\"\"><div ng-messages=\"creditCardForm.lastName.$error\" ng-show=\"creditCardForm.lastName.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><label>Company</label> <input type=\"text\" name=\"company\" ng-model=\"vm.creditCardForm.company\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><label>Address 1</label> <input type=\"text\" name=\"address1\" ng-model=\"vm.creditCardForm.address1\" required=\"\"><div ng-messages=\"creditCardForm.address1.$error\" ng-show=\"creditCardForm.address1.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><label>Address 2</label> <input type=\"text\" name=\"address2\" ng-model=\"vm.creditCardForm.address2\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"50\"><label>City</label> <input type=\"text\" name=\"city\" ng-model=\"vm.creditCardForm.city\" required=\"\"><div ng-messages=\"creditCardForm.city.$error\" ng-show=\"creditCardForm.city.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"40\"><label>Province</label> <input type=\"text\" name=\"province\" ng-model=\"vm.creditCardForm.province\" required=\"\"><div ng-messages=\"creditCardForm.province.$error\" ng-show=\"creditCardForm.province.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\" md-no-float=\"\"><label>Postal Code</label> <input type=\"text\" name=\"postalCode\" ng-model=\"vm.creditCardForm.postalCode\" required=\"\"><div ng-messages=\"creditCardForm.postalCode.$error\" ng-show=\"creditCardForm.postalCode.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div></div></md-input-container><div class=\"md-block\" md-no-float=\"\" flex=\"50\"><md-input-container flex=\"\"><label>Country</label><md-select name=\"country\" ng-model=\"vm.creditCardForm.country\" ng-model-options=\"{trackBy: \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"c in vm.countries\" ng-value=\"c\">{{c.name}}</md-option></md-select><div ng-messages=\"creditCardForm.country.$error\" ng-show=\"creditCardForm.country.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div></div></md-input-container></div><div class=\"md-block\" md-no-float=\"\" flex=\"40\"><md-input-container flex=\"\"><label>Card Type</label><md-select name=\"cardType\" ng-model=\"vm.creditCardForm.cardType\" ng-model-options=\"{trackBy: \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"c in vm.cardTypes\" ng-value=\"c\">{{c.label}}</md-option></md-select><div ng-messages=\"creditCardForm.cardType.$error\" ng-show=\"creditCardForm.cardType.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div></div></md-input-container></div><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><label>Card Number</label> <input type=\"text\" name=\"cardNumber\" ng-model=\"vm.creditCardForm.cardNumber\" required=\"\" minlength=\"13\" maxlength=\"16\"><div ng-messages=\"creditCardForm.cardNumber.$error\" ng-show=\"creditCardForm.cardNumber.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div><div ng-message=\"minlength\"><span>{{constants.errors.creditCardLength}}</span></div><div ng-message=\"maxlength\"><span>{{constants.errors.creditCardLength}}</span></div></div></md-input-container><div class=\"md-block\" md-no-float=\"\" flex=\"\"><md-input-container><label>Expiration Month</label> <input type=\"number\" name=\"cardExpirationMonth\" ng-model=\"vm.creditCardForm.cardExpirationMonth\" required=\"\" minlength=\"2\" maxlength=\"2\" min=\"1\" max=\"12\"><div ng-messages=\"creditCardForm.cardExpirationMonth.$error\" ng-show=\"creditCardForm.cardExpirationMonth.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div><div ng-message=\"minlength\"><span>{{constants.errors.monthLength}}</span></div><div ng-message=\"maxlength\"><span>{{constants.errors.monthLength}}</span></div><div ng-message=\"min\"><span>{{constants.errors.monthRange}}</span></div><div ng-message=\"max\"><span>{{constants.errors.monthRange}}</span></div></div><div class=\"hint\">2 digit month</div></md-input-container><md-input-container><label>Expiration Year</label> <input type=\"number\" name=\"cardExpirationYear\" ng-model=\"vm.creditCardForm.cardExpirationYear\" required=\"\" minlength=\"4\" maxlength=\"4\" min=\"{{vm.date|date:\'yyyy\'}}\" max=\"3000\"><div ng-messages=\"creditCardForm.cardExpirationYear.$error\" ng-show=\"creditCardForm.cardExpirationYear.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div><div ng-message=\"minlength\"><span>{{constants.errors.yearLength}}</span></div><div ng-message=\"maxlength\"><span>{{constants.errors.yearLength}}</span></div><div ng-message=\"min\"><span>{{constants.errors.yearPast}}</span></div><div ng-message=\"max\"><span>{{constants.errors.yearRange}}</span></div></div><div class=\"hint\">4 digit year</div></md-input-container></div><md-input-container class=\"md-block\" flex=\"20\" md-no-float=\"\"><label>CVV</label> <input type=\"text\" name=\"cardCvv\" ng-model=\"vm.creditCardForm.cardCvv\" minlength=\"3\" maxlength=\"4\" required=\"\"><div ng-messages=\"creditCardForm.cardCvv.$error\" ng-show=\"creditCardForm.cardCvv.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>{{constants.errors.required}}</span></div><div ng-message=\"minlength\"><span>{{constants.errors.creditCardCvvLength}}</span></div><div ng-message=\"maxlength\"><span>{{constants.errors.creditCardCvvLength}}</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"\" md-no-float=\"\"><md-checkbox ng-model=\"vm.creditCardForm.defaultCard\" aria-label=\"Use this card for future payments\">Use this card for future payments</md-checkbox></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveCreditCard()\" class=\"send-button md-accent md-raised\" ng-disabled=\"creditCardForm.$invalid || vm.submitting;\" aria-label=\"SAVE\">SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/papertrade/includes/paginator.html","<div layout=\"row\" hide-xs=\"\" hide-sm=\"\" hide-md=\"\" flex=\"\" class=\"p-16\"><div layout=\"column\"><md-input-container><label>No. Results</label><md-select ng-model=\"vm.criteria.limit\" required=\"\"><md-option ng-repeat=\"l in [10,20]\" ng-value=\"l\" ng-click=\"vm.changeCriteriaLimit(l)\">{{l}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-align=\"center end\" flex=\"\"><div layout=\"row\" layout-align=\"center end\"><md-button class=\"md-icon-button\" ng-disabled=\"vm.criteria.page <= 1\" ng-click=\"vm.pagePaperTradeResults(vm.criteria.page - 1)\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-disabled=\"vm.criteria.page >= vm.paginator.length\" ng-click=\"vm.pagePaperTradeResults(vm.criteria.page + 1)\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div><div class=\"mr-16\">Page {{vm.criteria.page}} of {{vm.paginator.length}}</div></div></div><div layout=\"row\" layout-align=\"space-between center\" hide-lg=\"\" flex=\"\"><div layout=\"column\" layout-align=\"center start\" flex=\"\"><md-button ng-disabled=\"vm.criteria.page <= 1\" ng-click=\"vm.pagePaperTradeResults(vm.criteria.page - 1)\" aria-label=\"Previous Page\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>Previous Page</md-button></div><div layout=\"column\" layout-align=\"center end\" flex=\"\"><md-button ng-disabled=\"vm.criteria.page >= vm.paginator.length\" ng-click=\"vm.pagePaperTradeResults(vm.criteria.page + 1)\" aria-label=\"Next Page\">Next Page<md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/papertrade/includes/wolflineData.html","<div ng-if=\"!pt.wolflineVisible\" class=\"text-center\"><md-button class=\"md-accent\" ng-click=\"vm.togglePaperTradeWolfline(pt)\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon>Show Wolfline</md-button></div><div ng-if=\"pt.wolflineVisible\"><div layout=\"row\" flex=\"\"><div class=\"trading-grouping-container\"><span class=\"item\"><md-icon md-font-icon=\"icon-format-line-spacing\"></md-icon><b>{{ pt.marketGrouping.label }}</b><md-tooltip md-delay=\"300\">{{vm.constants.tooltips.tradingBehavior}}</md-tooltip></span> <span class=\"item\"><md-icon md-font-icon=\"icon-apps\"></md-icon><b>{{ pt.tradingBehavior.label }}</b><md-tooltip md-delay=\"300\">{{vm.constants.tooltips.marketGrouping}}</md-tooltip></span></div></div><div layout=\"row\" flex=\"\"><table class=\"condensed wl-values-table center {{ pt.marketGrouping.name.toLowerCase() }}\" ng-class=\"{ \'simple\': !vm.isScreenLTESm, \'condensed\': vm.isScreenLTESm }\" flex=\"\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Market</span></div></th><th class=\"secondary-text\" ng-repeat=\"column in pt.match.matchWolfline.data.ats|reverseArray\"><div class=\"table-header\"><span class=\"column-title\">{{ $index + 1 }} SP</span></div></th></tr></thead><tbody><tr><td>{{ pt.oddsType.name }}</td><td ng-if=\"pt.oddsType.id == 0\" ng-repeat=\"d in pt.match.matchWolfline.data.ats|reverseArray\"><span ng-class=\"[\'wl-label\', \'wl-alert-\' + vm.getAlertLevel(d.level)]\">{{d.displayValue}}</span> <span class=\"team-indicator\">{{vm.getTradingBehaviorIndicator(pt.match, ($index + 1), pt.tradingBehavior, \'ats\')}}</span></td><td ng-if=\"pt.oddsType.id == 1\" ng-repeat=\"d in pt.match.matchWolfline.data.totals|reverseArray\"><span ng-class=\"[\'wl-label\', \'wl-alert-\' + vm.getAlertLevel(d.level)]\">{{d.displayValue}}</span> <span class=\"team-indicator\">{{vm.getTotalsTradingBehaviorIndicator(d.value, pt.tradingBehavior)}}</span></td><td ng-if=\"pt.oddsType.id == 2\" ng-repeat=\"d in pt.match.matchWolfline.data.moneyline|reverseArray\"><span ng-class=\"[\'wl-label\', \'wl-alert-\' + vm.getAlertLevel(d.level)]\">{{d.displayValue}}</span> <span class=\"team-indicator\">{{vm.getTradingBehaviorIndicator(pt.match, ($index + 1), pt.tradingBehavior, \'moneyline\')}}</span></td></tr></tbody></table></div><div ng-if=\"pt.wolflineVisible\" class=\"text-center\"><md-button class=\"md-accent\" ng-click=\"vm.togglePaperTradeWolfline(pt)\"><md-icon md-font-icon=\"icon-chevron-up\"></md-icon>Hide Wolfline</md-button></div></div>");
$templateCache.put("app/main/research/includes/matchSearchForm.html","<form ng-submit=\"upcomingMatches.search()\" class=\"search\" flex=\"\" layout=\"row\"><md-input-container flex=\"\"><input class=\"search-input\" ng-model=\"upcomingMatches.criteria.search\" type=\"text\" placeholder=\"Search\" flex=\"\"></md-input-container><md-button ng-click=\"upcomingMatches.search()\" class=\"md-icon-button btn-search-submit\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon></md-button><md-button ng-if=\"upcomingMatches.criteria.search\" ng-click=\"upcomingMatches.clearSearch()\" class=\"md-icon-button btn-search-submit\" aria-label=\"Clear Search\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon clear-search-icon\"></md-icon></md-button></form>");
$templateCache.put("app/main/research/includes/paginator.html","<div layout=\"row\" hide-xs=\"\" hide-sm=\"\" hide-md=\"\" flex=\"\" class=\"p-16\"><div layout=\"column\"><md-input-container><label>No. Results</label><md-select ng-model=\"upcomingMatches.criteria.limit\" required=\"\"><md-option ng-repeat=\"l in [10,20]\" ng-value=\"l\" ng-click=\"upcomingMatches.setLimit(l)\">{{l}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-align=\"center end\" flex=\"\"><ul ng-if=\"upcomingMatches.paginator.length > 0\" class=\"paginator\"><li><a ng-disabled=\"upcomingMatches.criteria.page <= 1\" ng-click=\"vm.pageMatchResults(upcomingMatches.criteria.page - 1)\">Previous</a></li><li ng-class=\"{\'active\': upcomingMatches.criteria.page == l.page}\" ng-repeat=\"l in upcomingMatches.paginator\"><a ng-click=\"vm.pageMatchResults(l.page)\">{{l.page}}</a></li><li><a ng-disabled=\"upcomingMatches.criteria.page >= upcomingMatches.paginator.length\" ng-click=\"vm.pageMatchResults(upcomingMatches.criteria.page + 1)\">Next</a></li></ul></div></div><div layout=\"row\" hide-lg=\"\" flex=\"\"><div layout=\"column\" layout-align=\"center start\" flex=\"\"><md-button ng-disabled=\"upcomingMatches.criteria.page <= 1\" ng-click=\"vm.pageMatchResults(upcomingMatches.criteria.page - 1)\" aria-label=\"Previous Page\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>Previous Page</md-button></div><div layout=\"column\" layout-align=\"center end\" flex=\"\"><md-button ng-disabled=\"upcomingMatches.criteria.page >= upcomingMatches.paginator.length\" ng-click=\"vm.pageMatchResults(upcomingMatches.criteria.page + 1)\" aria-label=\"Next Page\">Next Page<md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/research/includes/researchSettingsSummary.html","<div id=\"research-settings-summary\"><div layout=\"row\" layout-align-gt-sm=\"end start\" layout-align=\"start start\"><div class=\"p-8 trading-grouping-container\"><span class=\"item\"><md-icon md-font-icon=\"icon-format-line-spacing\"></md-icon>{{researchSettings.tradingBehavior.label}}<md-tooltip hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.tradingBehavior}}</md-tooltip></span> <span class=\"item\"><md-icon md-font-icon=\"icon-apps\"></md-icon>{{researchSettings.marketGrouping.label}}<md-tooltip hide-sm=\"\" hide-xs=\"\">{{vm.constants.tooltips.marketGrouping}}</md-tooltip></span></div></div><div layout-gt-sm=\"row\"><div layout-gt-sm=\"column\" layout=\"row\" class=\"p-16\" flex=\"\"><div ng-if=\"researchSettings.markets.rows.length == 0\"><p>{{vm.constants.screener.markets.noMarkets}}</p></div><div ng-if=\"researchSettings.markets.rows.length > 0\" flex=\"\"><div class=\"h3\">{{vm.constants.screener.markets.title}}</div><table class=\"row-border hover\" ng-class=\"{ \'simple\': !vm.isScreenLTESm, \'condensed\': vm.isScreenLTESm }\" flex=\"\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in researchSettings.markets.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in researchSettings.markets.rows\"><td><md-icon ng-if=\"row.sport.icon\" md-font-icon=\"{{ row.sport.icon }}\"></md-icon>{{ row.sport.name }}</td><td><span ng-if=\"row.tournament\">{{ row.tournament.name }}</span> <span ng-if=\"!row.tournament\">All</span></td><td><div ng-if=\"row.conditions.length > 0\" ng-repeat=\"c in row.conditions\">{{ c.betType.name }} <span ng-if=\"c.betType.id == 2\"><span ng-if=\"c.team.id == 0\">(Favorite)</span><span ng-if=\"c.team.id == 1\">(Underdog)</span></span> {{ c.operator.value }} <span ng-if=\"c.betType.id == 0 && c.team\"><span ng-if=\"c.team.id == 0\">-</span><span ng-if=\"c.team.id == 1\">+</span></span><span ng-if=\"c.betType.id != 2\">{{ c.value }}</span><span ng-if=\"c.betType.id == 2\">{{c.value|formatOdds:user.oddsFormat}}</span> <span ng-if=\"c.conditionOperator.id\">{{ c.conditionOperator.name }}</span> {{ c.wagerType.name}} <span ng-if=\"!$last\">AND<br></span></div><div ng-if=\"row.conditions.length == 0\">All</div></td></tr></tbody></table></div></div><div layout-gt-sm=\"column\" layout=\"row\" class=\"p-16\" flex=\"\"><div flex=\"\"><div class=\"h3\"><span class=\"wl-icon-thewolf\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span><span class=\"path5\"></span><span class=\"path6\"></span><span class=\"path7\"></span><span class=\"path8\"></span><span class=\"path9\"></span></span> {{vm.constants.screener.alerts.title}}</div><table class=\"row-border hover\" ng-class=\"{ \'simple\': !vm.isScreenLTESm, \'condensed\': vm.isScreenLTESm }\" flex=\"\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in researchSettings.alerts.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr ng-if=\"researchSettings.alerts.rows.length > 0\" ng-repeat=\"row in researchSettings.alerts.rows\"><td>{{ row.betType.name }}</td><td>&gt;= {{ row.numberOfAlerts }}<md-icon md-font-icon=\"icon-flag-variant\" ng-class=\"[\'wl-alert-\' + vm.getAlertLevel(row.alertLevel.id)]\"></md-icon></td><td>{{ row.range.label }}</td><td>{{ row.conditionOperator.name }}</td></tr><tr ng-if=\"researchSettings.alerts.rows.length == 0\"><td colspan=\"4\"><p>{{vm.constants.screener.alerts.noAlerts}}</p></td></tr></tbody></table></div></div></div><div ng-if=\"!researchSettings.wizard.editMode\" class=\"btn-edit-save-screener text-center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.editScreener($event)\">{{vm.constants.screener.saveScreenerButtonTitle}}</md-button></div></div>");
$templateCache.put("app/main/ui/theme-colors/theme-colors.html","<div id=\"theme-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Theme Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-warn reference-button\" ng-click=\"vm.createTheme($event);\"><md-icon md-font-icon=\"icon-palette\"></md-icon><span>Create Your Own Theme!</span></md-button></div></div><div class=\"content\"><md-tabs class=\"color-tabs\" md-dynamic-height=\"\" md-swipe-content=\"\" md-stretch-tabs=\"always\"><md-tab label=\"Primary Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/primary/primary.html\'\"></md-content></md-tab><md-tab label=\"Accent Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/accent/accent.html\'\"></md-content></md-tab><md-tab label=\"Warn Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/warn/warn.html\'\"></md-content></md-tab><md-tab label=\"Background Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/background/background.html\'\"></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" translate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" translate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\">404</div><div class=\"message\" translate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><div class=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for anything\" translate=\"\" translate-attr-placeholder=\"ERROR404.SEARCH\" flex=\"\"></div><a class=\"back-link md-accent-color\" href=\"/\" translate=\"ERROR404.GO_BACK\">Go back to dashboard</a></div></div>");
$templateCache.put("app/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img ng-src=\"assets/images/logos/wolfline.png\" alt=\"The Wolfline. Quant sports trading analytics\"></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recover your password</div><form name=\"forgotPasswordForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate=\"\" translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"forgotPasswordForm.email.$error\" ng-show=\"forgotPasswordForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine || vm.isSubmitting\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\" ng-click=\"vm.forgotPassword()\">SEND RESET LINK</md-button><div layout=\"row\" layout-align=\"center center\"><md-progress-circular class=\"login-loader\" ng-if=\"vm.isSubmitting\" md-mode=\"indeterminate\"></md-progress-circular></div></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/pages/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"login-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img ng-src=\"assets/images/logos/wolfline.png\" alt=\"The Wolfline. Quant sports trading analytics\"></div><div ng-if=\"!vm.localStorage\" class=\"md-warn-bg p-16\">This application cannot be used with private browsing or a browser that does not support local storage.</div><div ng-if=\"vm.localStorage\"><div class=\"title\" translate=\"LOGIN.TITLE\"><span class=\"wl-icon-thewolf\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span><span class=\"path5\"></span><span class=\"path6\"></span><span class=\"path7\"></span><span class=\"path8\"></span><span class=\"path9\"></span></span> Log in to your account</div><form name=\"loginForm\" ng-submit=\"vm.authenticate()\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"loginForm.email.$error\" ng-show=\"loginForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"LOGIN.PASSWORD\" required=\"\"><div ng-messages=\"loginForm.password.$error\" ng-show=\"loginForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><div class=\"submit\" layout=\"row\" layout-xs=\"column\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine || vm.isSubmitting\" translate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></div><div layout=\"row\" class=\"text-center\"><md-progress-circular class=\"login-loader\" ng-if=\"vm.isSubmitting\" md-mode=\"indeterminate\"></md-progress-circular></div></form></div></div></div></div>");
$templateCache.put("app/pages/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"reset-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img ng-src=\"assets/images/logos/wolfline.png\" alt=\"The Wolfline. Quant sports trading analytics\"></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password</div><form name=\"resetPasswordForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" required=\"\" minlength=\"6\"><div ng-messages=\"resetPasswordForm.password.$error\" ng-show=\"resetPasswordForm.password.$touched\" role=\"alert\"><div ng-message=\"required\">Password field is required</div><div ng-message=\"minlength\">Password field must be at least 6 characters</div></div><div ng-if=\"vm.serverErrorMessage\" role=\"alert\" class=\"red-fg font-size-12\">{{ vm.serverErrorMessage }}</div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" required=\"\" match=\"{{vm.form.password}}\"><div ng-messages=\"resetPasswordForm.passwordConfirm.$error\" ng-show=\"resetPasswordForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\">Password (Confirm) field is required</div><div ng-message=\"match\">Password do not match</div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" ng-click=\"vm.resetPassword()\">RESET MY PASSWORD</md-button></form></div></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div class=\"toolbar-separator\"></div><ms-search-bar></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs=\"\">{{ user.FirstName }} {{ user.LastName }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"navigation-toggle\" hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs=\"\">{{ user.firstName }} {{ user.lastName }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm=\"\" aria-label=\"Toggle navigation\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><md-menu id=\"odds-format-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"odds-format-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\">{{vm.selectedOddsFormat.label}}</div></md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"oddsFormat in vm.oddsFormats\"><md-button ng-click=\"vm.changeOddsFormat(oddsFormat)\" aria-label=\"{{oddsFormat.label}}\"><span layout=\"row\" layout-align=\"start center\">{{oddsFormat.label}}</span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs=\"\">{{ user.firstName }} {{ user.lastName }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.profile\" ui-sref-opts=\"{reload:true}\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.orderhistory\"><md-icon md-font-icon=\"icon-timer\" class=\"icon\"></md-icon><md-button>Order History</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\" ng-if=\"vm.languages.length > 1\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul class=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-horizontal-nested.html\"><div ms-navigation-horizontal-item layout=\"row\"> <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\" ng-class=\"{\'active md-accent-bg\': vm.isActive}\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </div> <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-class=\"{\'active md-accent-bg\': vm.isActive}\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren\"> <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-nested.html\"><div ms-navigation-item layout=\"row\"> <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && !node.href && node.title && !node.event && !node.hidden\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </div> <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ui-sref-opts=\"{{node.uisrefopts}}\" ng-if=\"node.uisref && node.title && !node.hidden\" ng-click=\"vm.hideVerticalMobileMenu()\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </a> <a class=\"ms-navigation-button\" href=\"{{node.href}}\" target=\"_blank\" ng-if=\"node.href && node.title && !node.hidden\" ng-click=\"vm.hideVerticalMobileMenu()\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </a> <a class=\"ms-navigation-button\" ui-sref-active=\"active md-accent-bg\" ng-if=\"node.event && node.title && !node.hidden\" ng-click=\"node.event(node.eventParams)\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren\"> <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/main/papertrade/dialogs/papertrade/papertrade-dialog.html","<md-dialog class=\"paper-trade-dialog\" aria-label=\"{{vm.title}}\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><form id=\"paper-trade-form\" name=\"paperTradeForm\" ng-class=\"[\'md-inline-form\', vm.formBetClass]\" novalidate=\"\"><md-dialog-content ms-scroll=\"\"><div class=\"h3\">{{ vm.match.awayCompetitor.name }} @ {{ vm.match.homeCompetitor.name }}</div><div class=\"h4 secondary-text\">Match Date: {{vm.match.matchDate|formatDate: vm.user.timezone}}</div><div layout=\"row\"><div layout=\"column\" flex=\"\"><table class=\"simple odds-table condensed\"><thead><tr><th>{{vm.constants.matchResults.team}}</th><th>{{vm.constants.betTypes.ats}}</th><th>{{vm.constants.betTypes.moneyline}}</th><th colspan=\"2\">{{vm.constants.betTypes.totals}}</th></tr></thead><tbody><tr><td><span class=\"team-indicator\">A</span>&nbsp;<br hide-gt-xs=\"\">{{ vm.match.awayCompetitor.name }}</td><td><span ng-if=\"vm.match.spreadOdds && vm.match.spreadOdds.status == 0\" class=\"spread-odds\"><span ng-if=\"vm.match.spreadOdds.favorite == 1\">-</span><span ng-if=\"vm.match.spreadOdds.favorite == 0\">+</span>{{vm.match.spreadOdds.marketPrice}}</span> <span ng-if=\"vm.match.spreadOdds && vm.match.spreadOdds.status == 0\" class=\"spread-price\">({{vm.match.spreadOdds.awayJuicePrice|formatOdds:vm.user.oddsFormat}})</span> <span ng-if=\"!vm.match.spreadOdds || vm.match.spreadOdds.status > 0\">N/A</span></td><td><span ng-if=\"vm.match.moneylineOdds && vm.match.moneylineOdds.status == 0\">{{vm.match.moneylineOdds.awayMarketPrice|formatOdds:vm.user.oddsFormat}}</span> <span ng-if=\"!vm.match.moneylineOdds || vm.match.moneylineOdds.status > 0\">N/A</span></td><td rowspan=\"2\"><span ng-if=\"vm.match.totalsOdds && vm.match.totalsOdds.status == 0\">Over {{vm.match.totalsOdds.marketPrice}}<br>{{vm.match.totalsOdds.overJuicePrice|formatOdds:vm.user.oddsFormat}}</span> <span ng-if=\"!vm.match.totalsOdds || vm.match.totalsOdds.status > 0\">N/A</span></td><td rowspan=\"2\"><span ng-if=\"vm.match.totalsOdds&& vm.match.totalsOdds.status == 0\">Under {{vm.match.totalsOdds.marketPrice}}<br>{{vm.match.totalsOdds.underJuicePrice|formatOdds:vm.user.oddsFormat}}</span> <span ng-if=\"!vm.match.totalsOdds || vm.match.totalsOdds.status > 0\">N/A</span></td></tr><tr><td><span class=\"team-indicator\">H</span>&nbsp;<br hide-gt-xs=\"\">{{ vm.match.homeCompetitor.name }}</td><td><span ng-if=\"vm.match.spreadOdds && vm.match.spreadOdds.status == 0\" class=\"spread-odds\"><span ng-if=\"vm.match.spreadOdds.favorite == 0\">-</span><span ng-if=\"vm.match.spreadOdds.favorite == 1\">+</span>{{vm.match.spreadOdds.marketPrice}}</span> <span ng-if=\"vm.match.spreadOdds && vm.match.spreadOdds.status == 0\" class=\"spread-price\">({{vm.match.spreadOdds.homeJuicePrice|formatOdds:vm.user.oddsFormat}})</span> <span ng-if=\"!vm.match.spreadOdds || vm.match.spreadOdds.status > 0\">N/A</span></td><td><span ng-if=\"vm.match.moneylineOdds && vm.match.moneylineOdds.status == 0\">{{vm.match.moneylineOdds.homeMarketPrice|formatOdds:vm.user.oddsFormat}}</span> <span ng-if=\"!vm.match.moneylineOdds || vm.match.moneylineOdds.status > 0\">N/A</span></td></tr></tbody></table></div></div><div layout=\"row\"><md-input-container layout=\"column\" flex=\"\"><label>Trade Type</label><md-select name=\"betType\" ng-disabled=\"vm.papertrade.id\" ng-model=\"vm.form.betType\" required=\"\"><md-option ng-repeat=\"b in vm.betTypes\" ng-value=\"b\" ng-click=\"vm.changeBetType(b)\">{{b.name}}</md-option></md-select><div ng-messages=\"paperTradeForm.betType.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div></div></md-input-container><md-input-container class=\"md-block\" layout=\"column\" flex=\"\"><label>Trade Size</label> <input type=\"number\" id=\"tradeSizeWagerAmount\" name=\"tradeSize\" ng-model=\"vm.form.wagerAmount\" min=\"0\" max=\"{{constants.errors.maxTradeValue}}\" required=\"\"><div ng-messages=\"paperTradeForm.tradeSize.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div><div ng-message=\"min\">{{constants.errors.positiveNumber}}</div><div ng-message=\"max\">{{constants.errors.maxNumberError}} {{constants.errors.maxTradeValue}}</div></div></md-input-container></div><div layout=\"row\"><md-input-container id=\"ats-wager-type-container\" class=\"wager-type-container\" layout=\"column\" flex=\"\"><label>Team</label><md-select name=\"spreadWagerType\" ng-model=\"vm.form.wagerType\" ng-model-options=\"{trackBy: \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"w in vm.spreadWagerTypes\" ng-value=\"w\">{{w.label}}</md-option></md-select><div ng-messages=\"paperTradeForm.spreadWagerType.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div></div></md-input-container><md-input-container id=\"totals-wager-type-container\" class=\"wager-type-container\" layout=\"column\" flex=\"\"><label>Over/Under</label><md-select name=\"totalsWagerType\" ng-model=\"vm.form.wagerType\" ng-model-options=\"{trackBy: \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"w in vm.totalsWagerTypes\" ng-value=\"w\">{{w.label}}</md-option></md-select><div ng-messages=\"paperTradeForm.totalsWagerType.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div></div></md-input-container><md-input-container id=\"moneyline-wager-type-container\" class=\"wager-type-container\" layout=\"column\" flex=\"\"><label>Home/Away</label><md-select name=\"moneylineWagerType\" ng-model=\"vm.form.wagerType\" ng-model-options=\"{trackBy: \'$value.id\'}\" required=\"\"><md-option ng-repeat=\"w in vm.moneylineWagerTypes\" ng-value=\"w\">{{w.label}}</md-option></md-select><div ng-messages=\"paperTradeForm.moneylineWagerType.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.savePaperTrade()\" class=\"send-button md-accent md-raised\" ng-disabled=\"paperTradeForm.$invalid\" aria-label=\"SAVE\">SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/research/dialogs/screener/screener-dialog.html","<md-dialog class=\"screener-dialog\" aria-label=\"{{vm.title}}\"><form name=\"screenerForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Name</label> <input name=\"name\" ng-model=\"vm.screenerForm.name\" required=\"\"><div ng-messages=\"screenerForm.name.$error\"><div ng-message=\"required\">{{constants.errors.required}}</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label>Description</label> <textarea ng-model=\"vm.screenerForm.description\" columns=\"1\" rows=\"5\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveScreener()\" class=\"send-button md-accent md-raised\" ng-disabled=\"screenerForm.$invalid\" aria-label=\"SAVE\">SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\"><div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div class=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button class=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" layout-align=\"space-between\" layout-fill=\"\" flex=\"\"><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" ng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html","<md-dialog class=\"custom-theme-dialog\" aria-label=\"Custom Theme\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Custom Theme Generator</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" ng-repeat=\"type in [\'primary\', \'accent\', \'warn\', \'background\']\"><h3 class=\"type\">{{type}}</h3><md-input-container><label>Palette</label><md-select ng-model=\"vm.theme[type].name\" ng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].contrast, 1)}\"><md-option ng-value=\"palette\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\">{{palette}}</md-option></md-select></md-input-container><div layout=\"row\" ng-repeat=\"hueType in [\'default\', \'hue-1\', \'hue-2\', \'hue-3\']\"><md-input-container><label>{{hueType}}</label><md-select ng-model=\"vm.theme[type].hues[hueType]\" ng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].contrast, 1)}\"><md-option ng-value=\"hue\" ng-repeat=\"(hue, opt) in vm.palettes[vm.theme[type].name]\" ng-style=\"{\'background-color\': vm.rgba(opt.value), \'color\': vm.rgba(opt.contrast, 1)}\">{{hue}}</md-option></md-select></md-input-container></div></div><md-divider></md-divider><div layout=\"row\"><p>To make this theme permanent, copy the below code and add it into the \"fuseThemes\" object in \"core/theming/fuse-themes.constant.js\" file. You can also replace the \"CUSTOM_THEME_NAME\" with your theme name.</p></div><div layout=\"row\"><textarea readonly=\"\" class=\"theme-object\">\"CUSTOM_THEME_NAME\" : {{vm.theme}}</textarea></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.setTheme()\">Set Theme</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ui/theme-colors/tabs/accent/accent.html","<div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Default</div><div flex=\"\">{{vm.themes.active.theme.accent.color}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.accent.contrast1}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.accent.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-accent-bg .secondary-text</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.accent.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-accent-bg .hint-text</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.accent.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-accent-bg .divider</div></div><div flex=\"100\" class=\"md-accent-fg\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.accent.color}}</div><div flex=\"\">.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 1</div><div flex=\"\">{{vm.themes.active.theme.accent.hue1.color}}</div><div flex=\"\">.md-accent-bg .md-hue-1</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.accent.hue1.contrast1}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.accent.hue1.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-accent-bg .md-hue-1 .secondary-text</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.accent.hue1.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-accent-bg .md-hue-1 .hint-text</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.accent.hue1.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-accent-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-1\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.accent.hue1.color}}</div><div flex=\"\">.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 2</div><div flex=\"\">{{vm.themes.active.theme.accent.hue2.color}}</div><div flex=\"\">.md-accent-bg .md-hue-2</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.accent.hue2.contrast1}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.accent.hue2.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-accent-bg .md-hue-2 .secondary-text</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.accent.hue2.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-accent-bg .md-hue-2 .hint-text</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.accent.hue2.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-accent-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-2\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.accent.hue2.color}}</div><div flex=\"\">.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 3</div><div flex=\"\">{{vm.themes.active.theme.accent.hue3.color}}</div><div flex=\"\">.md-accent-bg .md-hue-3</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.accent.hue3.contrast1}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.accent.hue3.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-accent-bg .md-hue-3 .secondary-text</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.accent.hue3.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-accent-bg .md-hue-3 .hint-text</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.accent.hue3.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-accent-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-3\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.accent.hue3.color}}</div><div flex=\"\">.md-accent-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/background/background.html","<div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Default</div><div flex=\"\">{{vm.themes.active.theme.background.color}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.background.contrast1}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.background.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-background-bg .secondary-text</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.background.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-background-bg .hint-text</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.background.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-background-bg .divider</div></div><div flex=\"100\" class=\"md-primary-bg md-background-fg\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.background.color}}</div><div flex=\"\">.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 1</div><div flex=\"\">{{vm.themes.active.theme.background.hue1.color}}</div><div flex=\"\">.md-background-bg .md-hue-1</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.background.hue1.contrast1}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.background.hue1.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-background-bg .md-hue-1 .secondary-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.background.hue1.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-background-bg .md-hue-1 .hint-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.background.hue1.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-background-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding=\"\"><div flex=\"\" class=\"md-background-fg md-hue-1\">As foreground color</div><div flex=\"\" class=\"md-background-fg md-hue-1\">{{vm.themes.active.theme.background.hue1.color}}</div><div flex=\"\" class=\"md-background-fg md-hue-1\">.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 2</div><div flex=\"\">{{vm.themes.active.theme.background.hue2.color}}</div><div flex=\"\">.md-background-bg .md-hue-2</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.background.hue2.contrast1}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.background.hue2.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-background-bg .md-hue-2 .secondary-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.background.hue2.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-background-bg .md-hue-2 .hint-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.background.hue2.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-background-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding=\"\"><div flex=\"\" class=\"md-background-fg md-hue-2\">As foreground color</div><div flex=\"\" class=\"md-background-fg md-hue-2\">{{vm.themes.active.theme.background.hue2.color}}</div><div flex=\"\" class=\"md-background-fg md-hue-2\">.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 3</div><div flex=\"\">{{vm.themes.active.theme.background.hue3.color}}</div><div flex=\"\">.md-background-bg .md-hue-3</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.background.hue3.contrast1}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.background.hue3.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-background-bg .md-hue-3 .secondary-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.background.hue3.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-background-bg .md-hue-3 .hint-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.background.hue3.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-background-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding=\"\"><div flex=\"\" class=\"md-background-fg md-hue-3\">As foreground color</div><div flex=\"\" class=\"md-background-fg md-hue-3\">{{vm.themes.active.theme.background.hue3.color}}</div><div flex=\"\" class=\"md-background-fg md-hue-3\">.md-background-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/warn/warn.html","<div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Default</div><div flex=\"\">{{vm.themes.active.theme.warn.color}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.warn.contrast1}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.warn.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-warn-bg .secondary-text</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.warn.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-warn-bg .hint-text</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.warn.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-warn-bg .divider</div></div><div flex=\"100\" class=\"md-warn-fg\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.warn.color}}</div><div flex=\"\">.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 1</div><div flex=\"\">{{vm.themes.active.theme.warn.hue1.color}}</div><div flex=\"\">.md-warn-bg .md-hue-1</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.warn.hue1.contrast1}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.warn.hue1.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-warn-bg .md-hue-1 .secondary-text</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.warn.hue1.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-warn-bg .md-hue-1 .hint-text</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.warn.hue1.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-warn-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-1\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.warn.hue1.color}}</div><div flex=\"\">.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 2</div><div flex=\"\">{{vm.themes.active.theme.warn.hue2.color}}</div><div flex=\"\">.md-warn-bg .md-hue-2</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.warn.hue2.contrast1}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.warn.hue2.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-warn-bg .md-hue-2 .secondary-text</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.warn.hue2.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-warn-bg .md-hue-2 .hint-text</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.warn.hue2.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-warn-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-2\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.warn.hue2.color}}</div><div flex=\"\">.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 3</div><div flex=\"\">{{vm.themes.active.theme.warn.hue3.color}}</div><div flex=\"\">.md-warn-bg .md-hue-3</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.warn.hue3.contrast1}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.warn.hue3.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-warn-bg .md-hue-3 .secondary-text</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.warn.hue3.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-warn-bg .md-hue-3 .hint-text</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.warn.hue3.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-warn-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-3\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.warn.hue3.color}}</div><div flex=\"\">.md-warn-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/primary/primary.html","<div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Default</div><div flex=\"\">{{vm.themes.active.theme.primary.color}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.primary.contrast1}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.primary.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-primary-bg .secondary-text</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.primary.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-primary-bg .hint-text</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.primary.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-primary-bg .divider</div></div><div flex=\"100\" class=\"md-primary-fg\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.primary.color}}</div><div flex=\"\">.md-primary-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 1</div><div flex=\"\">{{vm.themes.active.theme.primary.hue1.color}}</div><div flex=\"\">.md-primary-bg .md-hue-1</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.primary.hue1.contrast1}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.primary.hue1.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-primary-bg .md-hue-1 .secondary-text</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.primary.hue1.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-primary-bg .md-hue-1 .hint-text</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.primary.hue1.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-primary-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-1\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.primary.hue1.color}}</div><div flex=\"\">.md-primary-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 2</div><div flex=\"\">{{vm.themes.active.theme.primary.hue2.color}}</div><div flex=\"\">.md-primary-bg .md-hue-2</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.primary.hue2.contrast1}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.primary.hue2.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-primary-bg .md-hue-2 .secondary-text</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.primary.hue2.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-primary-bg .md-hue-2 .hint-text</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.primary.hue2.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-primary-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-2\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.primary.hue2.color}}</div><div flex=\"\">.md-primary-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 3</div><div flex=\"\">{{vm.themes.active.theme.primary.hue3.color}}</div><div flex=\"\">.md-primary-bg .md-hue-3</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.primary.hue3.contrast1}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.primary.hue3.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-primary-bg .md-hue-3 .secondary-text</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.primary.hue3.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-primary-bg .md-hue-3 .hint-text</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.primary.hue3.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-primary-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-3\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.primary.hue3.color}}</div><div flex=\"\">.md-primary-fg</div></div></div>");}]);